// src/errors/error-codes.ts
var ERROR_CODES = {
  APP_MAINTENANCE_MODE: "The application is under maintenance",
  ACCESS_CONTEXT_NOT_FOUND: "AccessContext not found. Make sure it is injected in the constructor",
  ACCESS_CONTEXT_ALREADY_INITIALIZED: "AccessContextService has already been initialized",
  ACCOUNT_EMAIL_ALREADY_REGISTERED: "The given email is already associated to another user account",
  INTEGRATION_STRATEGY_NOT_FOUND: "INTEGRATION_STRATEGY_NOT_FOUND",
  AUTH_ERROR: "Authentication error",
  AUTH_PENDING_ACTIVATION: "Account is pending activation.",
  CANNOT_PARSE_REDIS_SESSION: "Cannot parse redis session",
  CHAIN_SERVICE_UNAVAILABLE: "Chain service unavailable",
  CHAT_SESSION_ALREADY_INITIALIZED: "Chat session is already initialized.",
  CHAT_SESSION_NOT_INITIALIZED: "Chat session is not initialized.",
  CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE: "Given Instagram Account ID is already in use by another chatbot.",
  CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE: "Given Facebook Page ID is already in use by another chatbot.",
  CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE: "Given Whatsapp Phone ID is already in use by another chatbot.",
  CONTACT_NOT_FOUND: "Contact not found",
  CONVERSATION_INVALID_CHANNEL: "The given channel is not supported for this operation",
  CONVERSATION_EXPIRED: "Expired conversation",
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_REGISTERED: "The given Instagram Account is not registered to the customer platform.",
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_PLATFORM_NOT_FOUND: "Communication Platform not found",
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_FOUND: "Instagram Account not found",
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_REGISTERED: "The given page is not registered to the customer platform.",
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PLATFORM_NOT_FOUND: "Communication Platform not found",
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_FOUND: "Facebook Page not found",
  CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_ALREADY_REGISTERED: "The phone number is already registered in our system.",
  CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND: `The phone number does not belong to the customer's Whatsapp Business Account.`,
  CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA: "The platform is not fully registered or is malformed.",
  CUSTOMER_CREATION_FAILED: "Customer creation failed",
  COMPANY_NOT_FOUND: "Company not found",
  DEFAULT_ERROR: "Default error used when no specific error is available",
  DEPENDENT_RECORD_NOT_FOUND: "Dependent record not found",
  EMAIL_NOT_CONFIRMED: "Email not confirmed",
  ERROR_PARSING_REAL_ESTATE_FEED_PARAMS: "Error parsing real estate feed params",
  ERROR_WHILE_CHECKING_PERMISSIONS: "Error while checking permissions",
  EXTERNAL_API_ERROR: "External API error",
  FAILED_CREATING_APPRAISAL: "Error creating appraisal",
  FAILED_CREATING_CONTACT: "Error creating contact",
  FOREIGN_KEY_CONSTRAINT_FAILED: "Foreign key constraint failed",
  INSTAGRAM_WEBHOOK_MISSING_MESSAGES: "Received empty messages array",
  INVALID_AGENT_CONTEXT_SCHEMA: "Invalid agent context schema",
  INVALID_CACHE_KEY: "Invalid cache key",
  INVALID_CHAT_MODE: "Invalid chat mode",
  INVALID_CHAT_MODEL: "Invalid chat model",
  INVALID_CONVERSATION_BOT_SCHEMA: "Invalid conversation bot schema",
  INVALID_CUSTOMER_CONFIGURATION_SCHEMA: "Invalid customer configuration schema",
  INVALID_DOCUMENT_SEARCHER_TYPE: "Invalid document searcher type",
  INVALID_DTO: "The provided data is invalid",
  INVALID_FEED_PARAMS_CONFIG: "Invalid feed params config",
  INVALID_LOGIN_CREDENTIALS: "Invalid login credentials",
  INVALID_MODE_DETECTION_BOT_SCHEMA: "Invalid mode detection bot schema",
  INVALID_OR_EXPIRED_TOKEN: "Invalid or expired token",
  INVALID_ORIGIN: "Invalid origin",
  INVALID_PROMPT_VALUES: "Invalid prompt values",
  INVALID_SIGNATURE: "The provided signature is not valid",
  INVALID_SIMULATED_ORIGIN: "Invalid simulated origin",
  INVALID_UUID_PARAM: "Invalid UUID param",
  INVALID_VERIFY_TOKEN: "Invalid verify token",
  INVALID_VERTICAL: "Invalid vertical",
  INVALID_PRICING_STRUCTURE: "Invalid pricing structure",
  INVALID_INTEGRATION_STRATEGY_CONFIGURATION: "Invalid integration strategy configuration",
  INVALID_CASL_CONDITION: "Invalid CASL condition",
  INVALID_CASL_SUBJECT: "Invalid CASL subject",
  INVALID_CASL_RULE: "Invalid CASL rule",
  INVALID_TRANSFORMER_PREPROCESSOR: "Invalid transformer preprocessor",
  INVALID_AGENT_NAME: "Invalid agent name",
  INVALID_LEAD_FIELD_DEFINITION: "Invalid lead field definition",
  INVALID_TOOL_CALL: "Invalid tool call",
  INVALID_PROFILE_CUSTOM_FIELD: "Invalid profile custom field",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  INVITE_USER_ACCOUNT_ALREADY_ACTIVE: "The user already exists and has completed the invite process",
  INVITE_USER_BELONGS_TO_ANOTHER_CUSTOMER: "The user has been invited by another customer",
  INVITE_USER_UNABLE_TO_SEND_CUSTOM_EMAIL: "Failed to send the invite link. Probably due an external API failure. Try again later.",
  INVALID_CHATBOT_CONFIGURATION: "Invalid chatbot configuration",
  INVALID_APP_RUNTIME_CONTEXT: "Invalid app runtime context",
  INVALID_UPDATE: "Invalid update",
  INVALID_EVENT_ACTION_CONFIGURATION: "Invalid event action configuration",
  JOB_NOT_FOUND: "Job not found",
  LLM_ERROR: "LLM error",
  MESSAGE_COMPONENT_EXPIRED: "Message component has expired",
  MESSAGE_COMPONENT_NOT_FOUND: "Message component not found",
  MESSENGER_FACEBOOK_PAGES_WEBHOOK_MISSING_MESSAGES: "Received empty messages array",
  MISSING_CHAT_CONTACT_KEY: "Missing chat contact key",
  MISSING_CUSTOMER_API_KEY_FROM_REQUEST: "Missing customer API key from request",
  MISSING_CUSTOMER_API_KEY: "Missing Customer API KEY",
  MISSING_CHATBOT_API_KEY: "Missing chatbot API key",
  MISSING_CUSTOMER_CONFIGURATION: "Missing configuration",
  MISSING_CUSTOMER_ID: "Missing customer id",
  MISSING_PERMISSION: "Missing permission",
  NEW_PASSWORD_MUST_BE_DIFFERENT: "New password must be different",
  NEWSLETTER_EMAIL_ALREADY_REGISTERED: "Newsletter email already registered",
  NO_CONVERSATION_FOUND: "No session found",
  NO_MESSAGE_FOUND: "No message found",
  NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED: "No more than 3 chatbot instances allowed",
  NOT_FOUND: "Not found",
  NOT_ALLOWED: "The user is not allowed to execute this action",
  PIPE_VALIDATION_FAILED: "Pipe validation failed",
  PROCESSING_MESSAGE_FAILED: "Processing message failed",
  PROMPT_VALUES_NOT_FOUND: "Prompt values not found",
  STREAMING_ERROR: "Unable to stream previous chunk",
  RESOURCE_IS_NOT_OWNED_BY_CUSTOMER: "The underlying resource is not owned by the given customer",
  TOO_MANY_REQUESTS: "Rate limit exceeded. Please try again later.",
  UNIQUE_CONSTRAINT_VIOLATION: "Unique constraint violation",
  UNKNOWN_DB_ERROR: "Unknown database error",
  USER_ACCOUNT_NOT_CONFIRMED: "User account is pending confirmation",
  USER_ACCOUNT_INVITE_FLOW_NOT_COMPLETED: "User has not completed the invite flow",
  USER_ADMIN_NOT_FOUND: "User admin not found",
  USER_BANNED: "User is banned",
  USER_DELETED: "User account was deleted",
  USER_FORBIDDEN_ANONYMOUS_ACCOUNT: "User account is anonymous and cannot access this resource",
  USER_INVITE_EMAIL_ALREADY_REGISTERED: "User invite email already registered",
  USER_PROFILE_NOT_FOUND: "User profile not found",
  UPDATE_FAILED: "Update failed",
  VERTICAL_NOT_FOUND: "Vertical not found",
  WHATSAPP_WEBHOOK_MISSING_MESSAGES: "Request body does not contain any whatsapp message.",
  MISSING_CUSTOMER_CHATBOT_CONFIG_SECTION_KEY: "Missing customer chatbot config section key",
  CONVERSATION_TAG_ALREADY_REGISTERED: "Conversation tag already exist"
};
var PROBLEMS = {
  APP_MAINTENANCE_MODE: {
    title: "The application is under maintenance",
    code: "APP_MAINTENANCE_MODE",
    detail: null,
    status: 503,
    type: null
  },
  INVALID_DTO: {
    title: "The provided data is invalid",
    code: "INVALID_DTO",
    detail: null,
    status: 400,
    type: null
  },
  NO_MESSAGE_FOUND: {
    title: "No message found",
    code: "NO_MESSAGE_FOUND",
    detail: null,
    status: 400,
    type: null
  },
  CONTACT_NOT_FOUND: {
    title: "Contact not found",
    code: "CONTACT_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  CONVERSATION_INVALID_CHANNEL: {
    title: "The current conversation channel is not supported for this operation",
    code: "CONVERSATION_INVALID_CHANNEL",
    detail: null,
    status: 409,
    type: null
  },
  CONVERSATION_EXPIRED: {
    title: "Expired conversation",
    code: "CONVERSATION_EXPIRED",
    detail: null,
    status: 410,
    type: null
  },
  NO_CONVERSATION_FOUND: {
    title: "No conversaiton found",
    code: "NO_CONVERSATION_FOUND",
    detail: null,
    status: 400,
    type: null
  },
  PROCESSING_MESSAGE_FAILED: {
    title: "Processing message failed",
    code: "PROCESSING_MESSAGE_FAILED",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_VERIFY_TOKEN: {
    title: "Invalid verify token",
    code: "INVALID_VERIFY_TOKEN",
    detail: null,
    status: 400,
    type: null
  },
  CANNOT_PARSE_REDIS_SESSION: {
    title: "Cannot parse redis session",
    code: "CANNOT_PARSE_REDIS_SESSION",
    detail: null,
    status: 500,
    type: null
  },
  CHAIN_SERVICE_UNAVAILABLE: {
    title: "Chain service unavailable",
    code: "CHAIN_SERVICE_UNAVAILABLE",
    detail: null,
    status: 503,
    type: null
  },
  INVALID_CHAT_MODE: {
    title: "Chat mode not found",
    code: "INVALID_CHAT_MODE",
    detail: null,
    status: 404,
    type: null
  },
  INVALID_CHAT_MODEL: {
    title: "Invalid chat model",
    code: "INVALID_CHAT_MODEL",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_DOCUMENT_SEARCHER_TYPE: {
    title: "Invalid document searcher type",
    code: "INVALID_DOCUMENT_SEARCHER_TYPE",
    detail: null,
    status: 400,
    type: null
  },
  COMPANY_NOT_FOUND: {
    title: "Company not found",
    code: "COMPANY_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  INTEGRATION_STRATEGY_NOT_FOUND: {
    title: "Integration strategy not found",
    code: "INTEGRATION_STRATEGY_NOT_FOUND",
    detail: null,
    status: 500,
    type: null
  },
  MISSING_CUSTOMER_ID: {
    title: "Missing customer id",
    code: "MISSING_CUSTOMER_ID",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_ORIGIN: {
    title: "Invalid origin",
    code: "INVALID_ORIGIN",
    detail: null,
    status: 403,
    type: null
  },
  MISSING_CUSTOMER_API_KEY: {
    title: "Missing Customer API KEY",
    code: "MISSING_CUSTOMER_API_KEY",
    detail: null,
    status: 400,
    type: null
  },
  MISSING_CUSTOMER_CONFIGURATION: {
    title: "Missing configuration",
    code: "MISSING_CUSTOMER_CONFIGURATION",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_CUSTOMER_CONFIGURATION_SCHEMA: {
    title: "Invalid customer configuration schema",
    code: "INVALID_CUSTOMER_CONFIGURATION_SCHEMA",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_SIGNATURE: {
    title: "The provided signature is not valid",
    code: "INVALID_SIGNATURE",
    detail: null,
    status: 403,
    type: null
  },
  VERTICAL_NOT_FOUND: {
    title: "Vertical not found",
    code: "VERTICAL_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  INVALID_VERTICAL: {
    title: "Invalid vertical",
    code: "INVALID_VERTICAL",
    detail: null,
    status: 500,
    type: null
  },
  PROMPT_VALUES_NOT_FOUND: {
    title: "Prompt values not found",
    code: "PROMPT_VALUES_NOT_FOUND",
    detail: null,
    status: 500,
    type: null
  },
  ERROR_PARSING_REAL_ESTATE_FEED_PARAMS: {
    title: "Error parsing real estate feed params",
    code: "ERROR_PARSING_REAL_ESTATE_FEED_PARAMS",
    detail: null,
    status: 409,
    type: null
  },
  NEWSLETTER_EMAIL_ALREADY_REGISTERED: {
    title: "Newsletter email already registered",
    code: "NEWSLETTER_EMAIL_ALREADY_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  ACCOUNT_EMAIL_ALREADY_REGISTERED: {
    title: "Email already registered",
    code: "ACCOUNT_EMAIL_ALREADY_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  UNIQUE_CONSTRAINT_VIOLATION: {
    title: "Unique constraint violation",
    code: "UNIQUE_CONSTRAINT_VIOLATION",
    detail: null,
    status: 409,
    type: null
  },
  UNKNOWN_DB_ERROR: {
    title: "Unknown database error",
    code: "UNKNOWN_DB_ERROR",
    detail: null,
    status: 500,
    type: null
  },
  EXTERNAL_API_ERROR: {
    title: "External API error",
    code: "EXTERNAL_API_ERROR",
    detail: null,
    status: 502,
    type: null
  },
  FAILED_CREATING_CONTACT: {
    title: "Error creating contact",
    code: "FAILED_CREATING_CONTACT",
    detail: null,
    status: 502,
    type: null
  },
  FOREIGN_KEY_CONSTRAINT_FAILED: {
    title: "Foreign key constraint failed",
    code: "FOREIGN_KEY_CONSTRAINT_FAILED",
    detail: null,
    status: 409,
    type: null
  },
  DEPENDENT_RECORD_NOT_FOUND: {
    title: "Dependent record not found",
    code: "DEPENDENT_RECORD_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  FAILED_CREATING_APPRAISAL: {
    title: "Error creating appraisal",
    code: "FAILED_CREATING_APPRAISAL",
    detail: null,
    status: 502,
    type: null
  },
  INVALID_SIMULATED_ORIGIN: {
    title: "Invalid simulated origin",
    code: "INVALID_SIMULATED_ORIGIN",
    detail: null,
    status: 400,
    type: null
  },
  MISSING_CUSTOMER_API_KEY_FROM_REQUEST: {
    title: "Missing customer API key from request",
    code: "MISSING_CUSTOMER_API_KEY_FROM_REQUEST",
    detail: null,
    status: 400,
    type: null
  },
  DEFAULT_ERROR: {
    title: "Default error used when no specific error is available",
    code: "DEFAULT_ERROR",
    detail: null,
    status: 500,
    type: null
  },
  AUTH_ERROR: {
    title: "Authentication error",
    code: "AUTH_ERROR",
    detail: null,
    status: 403,
    type: null
  },
  AUTH_PENDING_ACTIVATION: {
    title: "Account is pending activation.",
    code: "AUTH_PENDING_ACTIVATION",
    detail: null,
    status: 403,
    type: null
  },
  USER_PROFILE_NOT_FOUND: {
    title: "User profile not found",
    code: "USER_PROFILE_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  USER_FORBIDDEN_ANONYMOUS_ACCOUNT: {
    title: "Anonymous user accounts are not allowed to access this resource",
    code: "USER_FORBIDDEN_ANONYMOUS_ACCOUNT",
    detail: null,
    status: 403,
    type: null
  },
  USER_ACCOUNT_NOT_CONFIRMED: {
    title: "User account is pending confirmation",
    code: "USER_ACCOUNT_NOT_CONFIRMED",
    detail: null,
    status: 403,
    type: null
  },
  USER_BANNED: {
    title: "The user account is banned",
    code: "USER_BANNED",
    detail: null,
    status: 403,
    type: null
  },
  USER_DELETED: {
    title: "The user account was deleted",
    code: "USER_DELETED",
    detail: null,
    status: 403,
    type: null
  },
  INVALID_UUID_PARAM: {
    title: "Invalid UUID param",
    code: "INVALID_UUID_PARAM",
    detail: null,
    status: 400,
    type: null
  },
  JOB_NOT_FOUND: {
    title: "Job not found",
    code: "JOB_NOT_FOUND",
    detail: null,
    status: 500,
    type: null
  },
  PIPE_VALIDATION_FAILED: {
    title: "Pipe validation failed",
    code: "PIPE_VALIDATION_FAILED",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_MODE_DETECTION_BOT_SCHEMA: {
    title: "Invalid mode detection bot schema",
    code: "INVALID_MODE_DETECTION_BOT_SCHEMA",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_CONVERSATION_BOT_SCHEMA: {
    title: "Invalid conversation bot schema",
    code: "INVALID_CONVERSATION_BOT_SCHEMA",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_PROMPT_VALUES: {
    title: "Invalid prompt values",
    code: "INVALID_PROMPT_VALUES",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_FEED_PARAMS_CONFIG: {
    title: "Invalid feed params config",
    code: "INVALID_FEED_PARAMS_CONFIG",
    detail: null,
    status: 500,
    type: null
  },
  MISSING_CHAT_CONTACT_KEY: {
    title: "Missing chat contact key",
    code: "MISSING_CHAT_CONTACT_KEY",
    detail: null,
    status: 502,
    type: null
  },
  MESSAGE_COMPONENT_NOT_FOUND: {
    title: "Message component not found",
    code: "MESSAGE_COMPONENT_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  MESSAGE_COMPONENT_EXPIRED: {
    title: "Message component has expired",
    code: "MESSAGE_COMPONENT_EXPIRED",
    detail: null,
    status: 410,
    type: null
  },
  MISSING_PERMISSION: {
    title: "Missing permission",
    code: "MISSING_PERMISSION",
    detail: null,
    status: 403,
    type: null
  },
  ERROR_WHILE_CHECKING_PERMISSIONS: {
    title: "Error while checking permissions",
    code: "ERROR_WHILE_CHECKING_PERMISSIONS",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_CACHE_KEY: {
    title: "Invalid cache key",
    code: "INVALID_CACHE_KEY",
    detail: null,
    status: 500,
    type: null
  },
  LLM_ERROR: {
    title: "Error while processing LLM message",
    code: "LLM_ERROR",
    detail: null,
    status: 502,
    type: null
  },
  NEW_PASSWORD_MUST_BE_DIFFERENT: {
    title: "New password must be different",
    code: "NEW_PASSWORD_MUST_BE_DIFFERENT",
    detail: null,
    status: 422,
    type: null
  },
  INVALID_OR_EXPIRED_TOKEN: {
    title: "Invalid or expired token",
    code: "INVALID_OR_EXPIRED_TOKEN",
    detail: null,
    status: 404,
    type: null
  },
  INVALID_LOGIN_CREDENTIALS: {
    title: "Invalid login credentials",
    code: "INVALID_LOGIN_CREDENTIALS",
    detail: null,
    status: 401,
    type: null
  },
  EMAIL_NOT_CONFIRMED: {
    title: "Email not confirmed",
    code: "EMAIL_NOT_CONFIRMED",
    detail: null,
    status: 400,
    type: null
  },
  NOT_FOUND: {
    title: "Not found",
    code: "NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  NOT_ALLOWED: {
    title: "The user is not allowed to execute this action",
    code: "NOT_ALLOWED",
    detail: null,
    status: 403,
    type: null
  },
  USER_INVITE_EMAIL_ALREADY_REGISTERED: {
    title: "User invite email already registered",
    code: "USER_INVITE_EMAIL_ALREADY_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  USER_ADMIN_NOT_FOUND: {
    title: "User admin not found",
    code: "USER_ADMIN_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  USER_ACCOUNT_INVITE_FLOW_NOT_COMPLETED: {
    title: "User has not completed the invite flow",
    code: "USER_ACCOUNT_INVITE_FLOW_NOT_COMPLETED",
    detail: null,
    status: 403,
    type: null
  },
  NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED: {
    title: "No more than 3 chatbot instances allowed",
    code: "NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED",
    detail: null,
    status: 400,
    type: null
  },
  WHATSAPP_WEBHOOK_MISSING_MESSAGES: {
    title: "Request body does not contain any whatsapp message.",
    code: "WHATSAPP_WEBHOOK_MISSING_MESSAGES",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_PRICING_STRUCTURE: {
    title: "Invalid pricing structure",
    code: "INVALID_PRICING_STRUCTURE",
    detail: null,
    status: 500,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA: {
    title: "The platform is not fully registered or is malformed.",
    code: "CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA",
    detail: null,
    status: 409,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND: {
    title: `The phone number does not belong to the customer's Whatsapp Business Account.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND",
    detail: null,
    status: 409,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_ALREADY_REGISTERED: {
    title: "The phone number is already registered in our system.",
    code: "CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_ALREADY_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE: {
    title: "Given Instagram Account ID is already in use by another chatbot.",
    code: "CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE",
    detail: null,
    status: 409,
    type: null
  },
  CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE: {
    title: "Given Facebook Page ID is already in use by another chatbot.",
    code: "CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE",
    detail: null,
    status: 409,
    type: null
  },
  CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE: {
    title: "Given Whatsapp Phone ID is already in use by another chatbot.",
    code: "CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE",
    detail: null,
    status: 409,
    type: null
  },
  INVALID_INTEGRATION_STRATEGY_CONFIGURATION: {
    title: "Invalid integration strategy configuration",
    code: "INVALID_INTEGRATION_STRATEGY_CONFIGURATION",
    detail: null,
    status: 500,
    type: null
  },
  STREAMING_ERROR: {
    title: "Unable to stream previous chunk",
    code: "STREAMING_ERROR",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_AGENT_CONTEXT_SCHEMA: {
    title: "Invalid agent context schema",
    code: "INVALID_AGENT_CONTEXT_SCHEMA",
    detail: null,
    status: 500,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_PLATFORM_NOT_FOUND: {
    title: `Communication platform not found.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_PLATFORM_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_FOUND: {
    title: `Instagram Account not found`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_REGISTERED: {
    title: `The given Instagram Account is not registered to the customer platform.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_INSTAGRAM_ACCOUNT_NOT_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PLATFORM_NOT_FOUND: {
    title: `Communication platform not found.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PLATFORM_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_FOUND: {
    title: `Facebook Page not found.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_FOUND",
    detail: null,
    status: 404,
    type: null
  },
  CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_REGISTERED: {
    title: `The given page is not registered to the customer platform.`,
    code: "CUSTOMER_COMMUNICATION_PLATFORM_MESSENGER_FACEBOOK_PAGES_PAGE_NOT_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  MESSENGER_FACEBOOK_PAGES_WEBHOOK_MISSING_MESSAGES: {
    title: "Received empty messages array",
    code: "MESSENGER_FACEBOOK_PAGES_WEBHOOK_MISSING_MESSAGES",
    detail: null,
    status: 400,
    type: null
  },
  INSTAGRAM_WEBHOOK_MISSING_MESSAGES: {
    title: "Received empty messages array",
    code: "INSTAGRAM_WEBHOOK_MISSING_MESSAGES",
    detail: null,
    status: 400,
    type: null
  },
  MISSING_CUSTOMER_CHATBOT_CONFIG_SECTION_KEY: {
    title: "Missing customer chatbot config section key",
    code: "MISSING_CUSTOMER_CHATBOT_CONFIG_SECTION_KEY",
    detail: null,
    status: 400,
    type: null
  },
  TOO_MANY_REQUESTS: {
    title: "Rate limit exceeded. Please try again later.",
    code: "TOO_MANY_REQUESTS",
    detail: null,
    status: 429,
    type: null
  },
  CONVERSATION_TAG_ALREADY_REGISTERED: {
    title: "Conversation tag already exist",
    code: "CONVERSATION_TAG_ALREADY_REGISTERED",
    detail: null,
    status: 409,
    type: null
  },
  RESOURCE_IS_NOT_OWNED_BY_CUSTOMER: {
    title: "The underlying resource is not owned by the given customer",
    code: "RESOURCE_IS_NOT_OWNED_BY_CUSTOMER",
    detail: null,
    status: 403,
    type: null
  },
  INVALID_CASL_CONDITION: {
    title: "Invalid CASL condition",
    code: "INVALID_CASL_CONDITION",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_CASL_SUBJECT: {
    title: "Invalid CASL subject",
    code: "INVALID_CASL_SUBJECT",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_CASL_RULE: {
    title: "Invalid CASL rule",
    code: "INVALID_CASL_RULE",
    detail: null,
    status: 500,
    type: null
  },
  INVITE_USER_ACCOUNT_ALREADY_ACTIVE: {
    title: "The user already exists and has completed the invite process",
    code: "INVITE_USER_ACCOUNT_ALREADY_ACTIVE",
    detail: null,
    status: 409,
    type: null
  },
  INVITE_USER_BELONGS_TO_ANOTHER_CUSTOMER: {
    title: "The user has been invited by another customer",
    code: "INVITE_USER_BELONGS_TO_ANOTHER_CUSTOMER",
    detail: null,
    status: 409,
    type: null
  },
  INVITE_USER_UNABLE_TO_SEND_CUSTOM_EMAIL: {
    title: "Failed to send the invite link. Probably due an external API failure. Try again later.",
    code: "INVITE_USER_UNABLE_TO_SEND_CUSTOM_EMAIL",
    detail: null,
    status: 503,
    type: null
  },
  INVALID_TRANSFORMER_PREPROCESSOR: {
    title: "Invalid transformer preprocessor",
    code: "INVALID_TRANSFORMER_PREPROCESSOR",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_AGENT_NAME: {
    title: "Invalid agent name",
    code: "INVALID_AGENT_NAME",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_LEAD_FIELD_DEFINITION: {
    title: "Invalid lead field definition",
    code: "INVALID_LEAD_FIELD_DEFINITION",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_TOOL_CALL: {
    title: "Invalid tool call",
    code: "INVALID_TOOL_CALL",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_PROFILE_CUSTOM_FIELD: {
    title: "Invalid profile custom field",
    code: "INVALID_PROFILE_CUSTOM_FIELD",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_APP_RUNTIME_CONTEXT: {
    title: "Invalid app runtime context",
    code: "INVALID_APP_RUNTIME_CONTEXT",
    detail: null,
    status: 500,
    type: null
  },
  ACCESS_CONTEXT_NOT_FOUND: {
    title: "AccessContext not found",
    code: "ACCESS_CONTEXT_NOT_FOUND",
    detail: "AccessContext not found. Make sure it is injected in the constructor",
    status: 500,
    type: null
  },
  CHAT_SESSION_ALREADY_INITIALIZED: {
    title: "Chat session is already initialized",
    code: "CHAT_SESSION_ALREADY_INITIALIZED",
    detail: null,
    status: 409,
    type: null
  },
  CHAT_SESSION_NOT_INITIALIZED: {
    title: "Chat session is not initialized",
    code: "CHAT_SESSION_NOT_INITIALIZED",
    detail: null,
    status: 409,
    type: null
  },
  ACCESS_CONTEXT_ALREADY_INITIALIZED: {
    title: "AccessContextService has already been initialized",
    code: "ACCESS_CONTEXT_ALREADY_INITIALIZED",
    detail: null,
    status: 409,
    type: null
  },
  MISSING_CHATBOT_API_KEY: {
    title: "Missing chatbot API key",
    code: "MISSING_CHATBOT_API_KEY",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_PHONE_NUMBER: {
    title: "Invalid phone number",
    code: "INVALID_PHONE_NUMBER",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_CHATBOT_CONFIGURATION: {
    title: "Invalid chatbot configuration",
    code: "INVALID_CHATBOT_CONFIGURATION",
    detail: null,
    status: 500,
    type: null
  },
  UPDATE_FAILED: {
    title: "Update failed",
    code: "UPDATE_FAILED",
    detail: null,
    status: 500,
    type: null
  },
  INVALID_UPDATE: {
    title: "Invalid update",
    code: "INVALID_UPDATE",
    detail: null,
    status: 400,
    type: null
  },
  INVALID_EVENT_ACTION_CONFIGURATION: {
    title: "Invalid event action configuration",
    code: "INVALID_EVENT_ACTION_CONFIGURATION",
    detail: null,
    status: 500,
    type: null
  },
  CUSTOMER_CREATION_FAILED: {
    title: "Customer creation failed",
    code: "CUSTOMER_CREATION_FAILED",
    detail: null,
    status: 500,
    type: null
  }
};

// src/errors/response-as-problem-detail.ts
function responseAsProblemDetail(data) {
  if (data !== null && typeof data === "object" && "code" in data && "title" in data && "type" in data) {
    return true;
  }
  return false;
}

// src/errors/client-error-messages.ts
function getClientErrorMessage(error) {
  return CLIENT_ERROR_MESSAGES[error.code] ?? CLIENT_ERROR_DEFAULT_STATUS_MESSAGE[error.status.toString()] ?? {
    title: "errors:clientErrorFallbackMessage.title",
    description: "errors:clientErrorFallbackMessage.description"
  };
}
var CLIENT_ERROR_MESSAGES = {
  NEWSLETTER_EMAIL_ALREADY_REGISTERED: {
    title: "errors:clientErrorMessages.NEWSLETTER_EMAIL_ALREADY_REGISTERED.title",
    description: "errors:clientErrorMessages.NEWSLETTER_EMAIL_ALREADY_REGISTERED.description"
  },
  ACCOUNT_EMAIL_ALREADY_REGISTERED: {
    title: "errors:clientErrorMessages.ACCOUNT_EMAIL_ALREADY_REGISTERED.title",
    description: "errors:clientErrorMessages.ACCOUNT_EMAIL_ALREADY_REGISTERED.description"
  },
  CONVERSATION_EXPIRED: {
    title: "errors:clientErrorMessages.CONVERSATION_EXPIRED.title",
    description: "errors:clientErrorMessages.CONVERSATION_EXPIRED.description"
  },
  CONVERSATION_INVALID_CHANNEL: {
    title: "errors:clientErrorMessages.CONVERSATION_INVALID_CHANNEL.title",
    description: "errors:clientErrorMessages.CONVERSATION_INVALID_CHANNEL.description"
  },
  CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA: {
    title: "errors:clientErrorMessages.CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA.title",
    description: "errors:clientErrorMessages.CUSTOMER_COMMUNICATION_PLATFORM_MISSING_WABA.description"
  },
  CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND: {
    title: "errors:clientErrorMessages.CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND.title",
    description: "errors:clientErrorMessages.CUSTOMER_COMMUNICATION_PLATFORM_WHATSAPP_PHONE_NOT_FOUND.description"
  },
  NEW_PASSWORD_MUST_BE_DIFFERENT: {
    title: "errors:clientErrorMessages.NEW_PASSWORD_MUST_BE_DIFFERENT.title",
    description: "errors:clientErrorMessages.NEW_PASSWORD_MUST_BE_DIFFERENT.description"
  },
  INVALID_OR_EXPIRED_TOKEN: {
    title: "errors:clientErrorMessages.INVALID_OR_EXPIRED_TOKEN.title",
    description: "errors:clientErrorMessages.INVALID_OR_EXPIRED_TOKEN.description"
  },
  INVALID_LOGIN_CREDENTIALS: {
    title: "errors:clientErrorMessages.INVALID_LOGIN_CREDENTIALS.title",
    description: "errors:clientErrorMessages.INVALID_LOGIN_CREDENTIALS.description"
  },
  EMAIL_NOT_CONFIRMED: {
    title: "errors:clientErrorMessages.EMAIL_NOT_CONFIRMED.title",
    description: "errors:clientErrorMessages.EMAIL_NOT_CONFIRMED.description"
  },
  USER_INVITE_EMAIL_ALREADY_REGISTERED: {
    title: "errors:clientErrorMessages.USER_INVITE_EMAIL_ALREADY_REGISTERED.title",
    description: "errors:clientErrorMessages.USER_INVITE_EMAIL_ALREADY_REGISTERED.description"
  },
  NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED: {
    title: "errors:clientErrorMessages.NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED.title",
    description: "errors:clientErrorMessages.NO_MORE_THAN_3_CHATBOT_INSTANCES_ALLOWED.description"
  },
  INVALID_PHONE_NUMBER: {
    title: "errors:clientErrorMessages.INVALID_PHONE_NUMBER.title",
    description: "errors:clientErrorMessages.INVALID_PHONE_NUMBER.description"
  },
  CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE: {
    title: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE.title",
    description: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_WHATSAPP_PHONE_ALREADY_IN_USE.description"
  },
  CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE: {
    title: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE.title",
    description: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_INSTAGRAM_ACCOUNT_ALREADY_IN_USE.description"
  },
  CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE: {
    title: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE.title",
    description: "errors:clientErrorMessages.CHATBOT_CONFIGURATION_FACEBOOK_PAGE_ALREADY_IN_USE.description"
  }
};
var CLIENT_ERROR_DEFAULT_STATUS_MESSAGE = {
  "400": {
    title: "errors:clientErrorDefaultStatusMessage.400.title",
    description: "errors:clientErrorDefaultStatusMessage.400.description"
  },
  "401": {
    title: "errors:clientErrorDefaultStatusMessage.401.title",
    description: "errors:clientErrorDefaultStatusMessage.401.description"
  },
  "403": {
    title: "errors:clientErrorDefaultStatusMessage.403.title",
    description: "errors:clientErrorDefaultStatusMessage.403.description"
  },
  "404": {
    title: "errors:clientErrorDefaultStatusMessage.404.title",
    description: "errors:clientErrorDefaultStatusMessage.404.description"
  },
  "409": {
    title: "errors:clientErrorDefaultStatusMessage.409.title",
    description: "errors:clientErrorDefaultStatusMessage.409.description"
  }
};

// src/types/integration-context/real-estate/create-lead-contact.dto.ts
import z from "zod";
var superRefineEmailOrPhone = (val, ctx) => {
  if (!val.email && !val.phone) {
    ctx.addIssue({
      message: "Debe ingresar al menos un email o un tel\xE9fono",
      path: ["email"],
      code: "custom"
    });
    ctx.addIssue({
      message: "Debe ingresar al menos un email o un tel\xE9fono",
      path: ["phone"],
      code: "custom"
    });
  }
};
var CreateLeadContactChatbotDtoNonRefinedSchema = z.object({
  name: z.string().min(2, { message: "El nombre debe tener al menos 2 caracteres" }).max(50, { message: "El nombre debe tener como m\xE1ximo 50 caracteres" }),
  email: z.string().max(30, { message: "El email debe tener como m\xE1ximo 50 caracteres" }).email({ message: "El email debe ser v\xE1lido" }).or(z.literal("")),
  phone: z.string().min(8, { message: "El tel\xE9fono debe tener al menos 8 caracteres" }).max(15, { message: "El tel\xE9fono debe tener como m\xE1ximo 15 caracteres" }).or(z.literal("")),
  visitedProperties: z.string().optional(),
  messageComponentId: z.string().uuid().optional(),
  additionalFields: z.record(z.string()).optional()
});
var CreateLeadContactChatbotDtoSchema = CreateLeadContactChatbotDtoNonRefinedSchema.superRefine(superRefineEmailOrPhone);

// src/types/integration-context/real-estate/create-lead-appraisal.dto.ts
import z2 from "zod";
var CreateLeadAppraisalChatbotDtoSchema = z2.object({
  location: z2.string().min(2, { message: "La ubicaci\xF3n debe tener al menos 2 caracteres" }).max(80, { message: "La ubicaci\xF3n debe tener como m\xE1ximo 80 caracteres" }),
  propertyType: z2.string().optional(),
  propertyDetails: z2.string().optional()
}).merge(CreateLeadContactChatbotDtoSchema.innerType()).superRefine(superRefineEmailOrPhone);

// src/types/integrations/integration-authentication.type.ts
import z3 from "zod";
var IntegrationApiKeyAuthenticationSchema = z3.object({
  type: z3.literal("API_KEY"),
  credentials: z3.object({
    headers: z3.record(z3.string()).optional(),
    queryParams: z3.record(z3.string()).optional()
  })
});
var IntegrationOAuthAccessTokenAuthenticationSchema = z3.object({
  type: z3.literal("OAUTH2_ACCESS_TOKEN"),
  credentials: z3.object({
    accessToken: z3.string(),
    expiresAt: z3.string().optional()
  })
});
var IntegrationOAuthClientCredentialsAuthenticationSchema = z3.object({
  type: z3.literal("OAUTH2_CLIENT_CREDENTIALS"),
  credentials: z3.object({
    clientId: z3.string(),
    clientSecret: z3.string(),
    tokenUrl: z3.string().url()
  })
});
var IntegrationOAuthAuthCodeAuthenticationSchema = z3.object({
  type: z3.literal("OAUTH2_AUTH_CODE"),
  credentials: z3.object({
    clientId: z3.string(),
    clientSecret: z3.string(),
    redirectUri: z3.string().url()
  })
});
var IntegrationBasicAuthAuthenticationSchema = z3.object({
  type: z3.literal("BASIC_AUTH"),
  credentials: z3.object({
    username: z3.string(),
    password: z3.string()
  })
});
var IntegrationBearerTokenAuthenticationSchema = z3.object({
  type: z3.literal("BEARER_TOKEN"),
  credentials: z3.object({
    token: z3.string()
  })
});
var IntegrationHmacSignedPayloadAuthenticationSchema = z3.object({
  type: z3.literal("HMAC_SIGNED_PAYLOAD"),
  credentials: z3.object({
    header: z3.string(),
    secret: z3.string()
  })
});
var IntegrationPayloadEncryptionAuthenticationSchema = z3.object({
  type: z3.literal("PAYLOAD_ENCRYPTION"),
  credentials: z3.object({
    algorithm: z3.object({
      name: z3.literal("XSalsa20-Poly1305"),
      encryptionKey: z3.string()
    })
  })
});
var IntegrationAuthenticationSchema = z3.discriminatedUnion("type", [
  IntegrationApiKeyAuthenticationSchema,
  IntegrationOAuthAccessTokenAuthenticationSchema,
  IntegrationOAuthClientCredentialsAuthenticationSchema,
  IntegrationOAuthAuthCodeAuthenticationSchema,
  IntegrationBasicAuthAuthenticationSchema,
  IntegrationBearerTokenAuthenticationSchema,
  IntegrationHmacSignedPayloadAuthenticationSchema,
  IntegrationPayloadEncryptionAuthenticationSchema
]);
var IntegrationEncryptedAuthenticationCredentialsSchema = z3.object({
  credentials: z3.object({
    nonce: z3.string(),
    encrypted: z3.string()
  })
});
var IntegrationApiKeyEncryptedAuthenticationSchema = IntegrationApiKeyAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationOAuthAccessTokenEncryptedAuthenticationSchema = IntegrationOAuthAccessTokenAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationOAuthClientCredentialsEncryptedAuthenticationSchema = IntegrationOAuthClientCredentialsAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationOAuthAuthCodeEncryptedAuthenticationSchema = IntegrationOAuthAuthCodeAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationBasicAuthEncryptedAuthenticationSchema = IntegrationBasicAuthAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationBearerTokenEncryptedAuthenticationSchema = IntegrationBearerTokenAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationHmacSignedPayloadEncryptedAuthenticationSchema = IntegrationHmacSignedPayloadAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationPayloadEncryptionEncryptedAuthenticationSchema = IntegrationPayloadEncryptionAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var IntegrationEncryptedAuthenticationSchema = z3.discriminatedUnion("type", [
  IntegrationApiKeyEncryptedAuthenticationSchema,
  IntegrationOAuthAccessTokenEncryptedAuthenticationSchema,
  IntegrationOAuthClientCredentialsEncryptedAuthenticationSchema,
  IntegrationOAuthAuthCodeEncryptedAuthenticationSchema,
  IntegrationBasicAuthEncryptedAuthenticationSchema,
  IntegrationBearerTokenEncryptedAuthenticationSchema,
  IntegrationHmacSignedPayloadEncryptedAuthenticationSchema
]);

// src/types/chat-model/chat-model.type.ts
import { z as z4 } from "zod";
var CHAT_MODEL_FACTORY = "CHAT_MODEL_FACTORY";
var OPEN_AI_MODELS = {
  GPT_5_1: "gpt-5.1",
  GPT_5_MINI: "gpt-5-mini",
  GPT_5_NANO: "gpt-5-nano",
  GPT_4_1_MINI: "gpt-4.1-mini",
  GPT_4_1: "gpt-4.1",
  GPT_4_1_NANO: "gpt-4.1-nano",
  O_4_MINI: "o4-mini",
  O_3_MINI: "o3-mini"
};
var ANTHROPIC_MODELS = {
  SONNET: "claude-3-sonnet-20240229",
  OPUS: "claude-3-opus-20240229",
  HAIKU: "claude-3-haiku-20240307"
};
var GEMINI_MODELS = {
  GEMINI_FLASH: "gemini-1.5-flash-001"
};
var ChatModelSupportedOptionsSchema = z4.object({ temperature: z4.number().min(0).max(1) }).optional();
var ChatModelSchema = z4.object({
  name: z4.enum([...Object.keys(OPEN_AI_MODELS)]),
  options: ChatModelSupportedOptionsSchema.optional()
}).or(
  z4.object({
    name: z4.enum([...Object.keys(ANTHROPIC_MODELS)]),
    options: ChatModelSupportedOptionsSchema.optional()
  })
).or(
  z4.object({
    name: z4.enum([...Object.keys(GEMINI_MODELS)]),
    options: ChatModelSupportedOptionsSchema.optional()
  })
);

// src/types/bot/bot-action.type.ts
import z5 from "zod";
var BotActionSchema = z5.enum(["lead-send-contact", "lead-send-appraisal"]);

// src/types/customer-chatbot/customer-chatbot-config/real-estate/real-estate-agents-config.type.ts
import { z as z12 } from "zod";

// src/types/template-transformer/string-template-transformer-type.ts
import { z as z7 } from "zod";

// src/types/template-transformer/matchers-type.ts
import z6 from "zod";
var WhereConditionKeySchema = z6.union([
  z6.literal("$eq"),
  z6.literal("$ne"),
  z6.literal("$gt"),
  z6.literal("$lt"),
  z6.literal("$gte"),
  z6.literal("$lte")
]);
var WhereConditionValueSchema = z6.union([z6.string(), z6.number(), z6.boolean()]);
var MatcherWhereSchema = z6.object({
  value: z6.record(WhereConditionKeySchema, WhereConditionValueSchema)
});
var MatchersSchema = z6.array(
  z6.object({
    template: z6.string(),
    where: MatcherWhereSchema.optional()
  })
);

// src/types/template-transformer/string-template-transformer-type.ts
var StringTemplateTransformerSchema = z7.object({
  name: z7.literal("stringTemplateTransformer"),
  params: z7.object({
    matchers: MatchersSchema
  })
});

// src/types/template-transformer/template-transformer-type.ts
import z9 from "zod";

// src/types/template-transformer/array-template-transformer-type.ts
import z8 from "zod";
var ArrayStringTemplateTransformerSchema = z8.object({
  name: z8.literal("arrayStringTemplateTransformer"),
  params: z8.object({
    joiner: z8.string(),
    matchers: MatchersSchema
  })
});

// src/types/template-transformer/template-transformer-type.ts
var TransformerSchema = z9.discriminatedUnion("name", [
  StringTemplateTransformerSchema,
  ArrayStringTemplateTransformerSchema
]);
var ParamTransformerConfigurationSchema = z9.object({
  key: z9.string().describe("This value will replace the key in the template"),
  valuesMap: z9.record(z9.string()).optional(),
  transformer: TransformerSchema,
  enabled: z9.boolean().describe("If the transformation should be performed").default(true)
});
var stringTemplateInterpolationRegex = /{{([\s\S]+?)}}/g;

// src/types/template-transformer/transformer-params-preprocessor-type.ts
import z10 from "zod";
var PriceRangePreprocessorSchema = z10.object({
  type: z10.literal("adjustPriceRange").describe("Adjusts the minPrice and maxPrice value of the property search params."),
  enabled: z10.boolean().describe("Enable or disable the preprocessor"),
  configuration: z10.object({
    percentage: z10.number().min(0).max(1).describe("Adjustment percentage (e.g., 0.1 for 10%)")
  })
});
var LocationSearchPreprocessorSchema = z10.object({
  type: z10.literal("locationSearch").describe("Search for locations based on the param detected by the chatbot"),
  enabled: z10.boolean().describe("Enable or disable the preprocessor"),
  configuration: z10.object({
    // TODO: Add support for lat+lon coords
    transformer: z10.discriminatedUnion("type", [
      // TODO: Extend transformer objects with a config key if required
      z10.object({ type: z10.literal("raw") }),
      z10.object({ type: z10.literal("tokkoBrokerFullTextSearch") }),
      z10.object({ type: z10.literal("id") })
    ]).optional()
  })
});
var TransformerParamsPreprocessorSchema = z10.discriminatedUnion("type", [
  PriceRangePreprocessorSchema,
  LocationSearchPreprocessorSchema
]);

// src/types/customer-chatbot/customer-chatbot-config/base-agent-config.type.ts
import { z as z11 } from "zod";
var BaseAgentConfigSchema = z11.object({
  isEnabled: z11.boolean()
});

// src/types/customer-chatbot/customer-chatbot-config/real-estate/real-estate-agents-config.type.ts
var PropertySearchAgentConfigSchema = BaseAgentConfigSchema.extend({
  baseFeedUrl: z12.string().url(),
  filteredFeedUrlTemplate: z12.string().optional(),
  transformerParamsPreprocessor: z12.array(TransformerParamsPreprocessorSchema).optional(),
  searchConfiguration: z12.object({
    allowedLocationGroups: z12.array(z12.string()).optional()
  }).optional(),
  feedUrlParametersConfiguration: z12.record(
    z12.string().describe("The key of the parameter to transform"),
    ParamTransformerConfigurationSchema
  ),
  rentEnabled: z12.boolean(),
  saleEnabled: z12.boolean(),
  propertyExchangeEnabled: z12.boolean().optional()
});
var PropertyPromptFieldsSchema = z12.object({
  description: ParamTransformerConfigurationSchema.extend({
    key: z12.literal("Description"),
    transformer: StringTemplateTransformerSchema
  }),
  //! TODO: These key will remain optional until we have a proper UI to manage its value
  propertyUrl: z12.object({
    key: z12.literal("Property URL"),
    enabled: z12.boolean(),
    urlTemplate: z12.string(),
    configuration: z12.record(
      z12.string().describe("The key of the parameter to transform"),
      ParamTransformerConfigurationSchema
    )
  }).optional(),
  address: z12.object({
    key: z12.literal("Address"),
    enabled: z12.boolean(),
    transformer: StringTemplateTransformerSchema
  }).optional()
});
var PropertyDetailsAgentConfigSchema = BaseAgentConfigSchema.extend({
  urlMatcher: z12.array(z12.string()).describe("An array of regular expressions to match the urls of the property details pages"),
  propertyPromptFields: PropertyPromptFieldsSchema
});
var AppraisalAgentConfigSchema = BaseAgentConfigSchema;
var PROPERTY_DETAILS_AGENT_NAME = "propertyDetails";
var PROPERTY_APPRAISAL_AGENT_NAME = "propertyAppraisal";
var PROPERTY_SEARCH_AGENT_NAME = "propertySearch";
var RealEstateAgentConfigSchema = z12.object({
  [PROPERTY_SEARCH_AGENT_NAME]: PropertySearchAgentConfigSchema,
  [PROPERTY_DETAILS_AGENT_NAME]: PropertyDetailsAgentConfigSchema,
  [PROPERTY_APPRAISAL_AGENT_NAME]: AppraisalAgentConfigSchema
});

// src/types/headers/headers.type.ts
var API_CUSTOM_HEADERS = {
  X_APP_MODE_MAINTENANCE_BYPASS_KEY: "x-app-mode-maintenance-bypass-key",
  X_CHATBOT_API_KEY: "x-chatbot-api-key",
  X_CHAT_CONVERSATION_KEY: "x-chat-conversation-key",
  X_CHAT_RESPONSE_MESSAGE_ID: "x-chat-response-message-id",
  X_HAS_COMPLETED_FORM: "x-has-completed-form",
  X_CHAT_MODE: "x-chat-mode",
  X_SIMULATED_ORIGIN: "x-simulated-origin",
  X_CHAT_CONTACT_KEY: "x-chat-contact-key",
  X_CHAT_FULL_URL: "x-chat-full-url",
  X_REAL_ESTATE_PROPERTY_ID: "x-real-estate-property-id",
  X_REAL_ESTATE_DEVELOPMENT_ID: "x-real-estate-development-id",
  X_EVAL_KEY: "x-eval-key"
};

// src/dtos/customers/customer/create-customer-account-wizard.dto.ts
import z15 from "zod";

// src/dtos/common/common-schemas.ts
import { z as z13 } from "zod";
var EmailSchema = z13.string({ required_error: "El valor es requerido" }).email({ message: "Ingres\xE1 un correo electr\xF3nico v\xE1lido" });
var PasswordSchema = z13.string({ required_error: "El valor es requerido" }).min(8, { message: "La contrase\xF1a debe tener al menos 8 caracteres" }).max(50, { message: "La contrase\xF1a debe tener como m\xE1ximo 50 caracteres" });
var LocationSchema = z13.string({ message: "Ingres\xE1 un c\xF3digo de pa\xEDs v\xE1lido" });
var RelaxedUrlSchema = z13.string().trim().refine(
  (value) => {
    if (!value) return false;
    return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i.test(value);
  },
  // TODO: i18n for error messages
  { message: "Ingres\xE1 una URL v\xE1lida (ej: ejemplo.com o https://ejemplo.com)" }
).transform((value) => {
  if (!/^https?:\/\//i.test(value)) {
    return `https://${value}`;
  }
  return value;
}).pipe(z13.string().url({ message: "La URL no es v\xE1lida" }));
var GOOGLE_RECAPTCHA_RESPONSE_KEY = "g-recaptcha-response";
var GoogleRecaptachaSchema = z13.object({
  [GOOGLE_RECAPTCHA_RESPONSE_KEY]: z13.string().optional()
});

// src/dtos/integrations/create-customer-integration-dto.ts
import z14 from "zod";
var CreateTokkoIntegrationDtoSchema = z14.object({
  type: z14.literal("REAL_ESTATE_TOKKO_BROKER"),
  payload: z14.object({
    apiKey: z14.string().min(1, "API Key is required")
  })
});
var CreateM3CIntegrationDtoSchema = z14.object({
  type: z14.literal("RETAIL_M3C"),
  payload: z14.object({
    userName: z14.string().min(1, "El nombre de usuario es requerido`"),
    password: z14.string().min(1, "El password es requerido"),
    apiUrl: z14.string().url("La URL no es v\xE1lida")
  })
});
var CreateCustomIntegrationDtoSchema = z14.object({
  type: z14.literal("OTHER"),
  payload: z14.object({
    info: z14.string().min(1, "Please describe your data source")
  })
});
var CreateCustomerIntegrationDtoSchema = z14.discriminatedUnion("type", [
  CreateTokkoIntegrationDtoSchema,
  CreateM3CIntegrationDtoSchema,
  CreateCustomIntegrationDtoSchema
]);

// src/dtos/customers/customer/create-customer-account-wizard.dto.ts
var CreateCustomerAccountWizardFormStep1Schema = z15.object({
  name: z15.string().min(1, "First name is required"),
  lastName: z15.string().min(1, "Last name is required"),
  companyName: z15.string().min(1, "Company name is required"),
  vertical: z15.string().min(1, "Industry is required"),
  location: z15.string().min(1, "Location is required")
});
var CreateCustomerAccountWizardFormStep2Schema = z15.object({
  integrationData: CreateCustomerIntegrationDtoSchema
});
var CreateCustomerAccountWizardFormStep3Schema = z15.object({
  chatbotName: z15.string().min(1, "Chatbot name is required").max(100, "El nombre del chatbot debe tener menos de 100 caracteres"),
  companyWebsite: RelaxedUrlSchema,
  primaryColor: z15.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Ingres\xE1 un color hexadecimal v\xE1lido"),
  initialMessage: z15.string().min(1, "Initial message is required").max(200, "El mensaje inicial debe tener menos de 200 caracteres")
});
var CreateCustomerAccountWizardFormSchema = z15.object({
  step1: CreateCustomerAccountWizardFormStep1Schema,
  step2: CreateCustomerAccountWizardFormStep2Schema,
  // These are optional because they are not required for "Other" integration
  step3: z15.object({
    chatbotName: z15.string().optional(),
    companyWebsite: RelaxedUrlSchema.optional(),
    primaryColor: z15.string().optional(),
    initialMessage: z15.string().optional()
  })
}).superRefine((data, ctx) => {
  if (data.step2.integrationData.type !== "OTHER") {
    const step3Validation = CreateCustomerAccountWizardFormStep3Schema.safeParse(data.step3);
    if (!step3Validation.success) {
      step3Validation.error.issues.forEach((issue) => {
        ctx.addIssue({
          ...issue,
          path: ["step3", ...issue.path]
        });
      });
    }
  }
});

// src/types/chat/conversation.type.ts
import z19 from "zod";

// src/types/conversation/conversation-state/conversation-state-type.ts
import z16 from "zod";
var RealEstateSearchParamsSchema = z16.object({
  operationType: z16.enum(["buy", "rent"]).describe("The type of operation."),
  numberOfRooms: z16.enum(["studioApartment", "1", "2", "3", "4", ">4"]).describe("The number of rooms (optional).").nullable(),
  currencyType: z16.enum(["USD", "ARS"]).describe("The currency type. Default is USD."),
  minPrice: z16.number().describe("The minimum price (optional).").nullable(),
  maxPrice: z16.number().describe("The maximum price (optional).").nullable(),
  neighborhood: z16.string().describe("The neighborhood of the properties (optional).").nullable(),
  propertyType: z16.array(z16.enum(["apartment", "house", "terrain", "garage", "office"])).describe("The type of property (optional, default is an empty array).").nullable(),
  age: z16.number().describe("The maximum age in years of the property (optional).").nullable(),
  constructionStatus: z16.enum(["constructed", "underConstruction"]).describe("The construction status of the property (optional).").nullable(),
  amenities: z16.array(z16.string()).describe("List of amenities (optional, default is an empty array)."),
  keywords: z16.array(z16.string()).describe("List of keywords that describe the property (optional, default is an empty array)."),
  size: z16.number().nullable().describe("The size of the property in square meters (optional, default is null).")
});
var HasAppraisedSchema = z16.boolean().describe("Whether the user has requested an appraisal for a property.");
var HasContactedCompanySchema = z16.boolean().describe("Whether the user has contacted the company.");
var LastPropertyInterestedIn = z16.object({
  propertyId: z16.string().describe("The id of the property").nullable().optional(),
  developmentId: z16.string().describe("The id of the development").nullable().optional(),
  formattedProperty: z16.string().describe("The formatted property values for chatbot consumption."),
  address: z16.string().describe("The address of the property")
});
var GeneralIntentSchema = z16.enum(["ENGAGE_PROPERTY", "SEEK_INFO", "CONTACT_COMPANY"]).describe(
  "This is the most general intent of the user. Either he wants to search, visit, appraise or get details about a property. He ask a general question about market, financing or the company itself. Or he wants to talk to a human."
);
var SpecificIntentSchema = z16.enum(["REQUEST_VISIT", "REQUEST_DETAILS", "APPRAISE_PROPERTY", "SEARCH_PROPERTIES"]).describe(
  "This is the specific intent of the user. Either he wants to visit a property, get details about a property, appraise a property or search for properties."
);
var ScopeSchema = z16.enum(["SPECIFIC_PROPERTY", "BROAD_SEARCH"]).describe(
  'Whether the user is referring to a specific property (e.g., "the house on Main St 123") or doing a general search (e.g., "looking for a 2-bedroom apartment").'
);
var TransactionTypeSchema = z16.enum(["buy", "rent", "sell", "appraise"]).describe("Whether the user wants to buy, rent, sell a property or appraise a property.");
var ConversationStateDetailsSchema = z16.string().describe("It captures qualitative details about the user request.");
var HasBeenUpdatedByAgentSchema = z16.boolean().describe("Flag to indicate if the conversation state has been updated by an agent.");
var RealEstateConversationStateSchema = z16.object({
  hasAppraised: HasAppraisedSchema.optional(),
  hasContactedCompany: HasContactedCompanySchema.optional(),
  lastPropertyInterestedIn: LastPropertyInterestedIn.optional(),
  generalIntent: GeneralIntentSchema.optional(),
  specificIntent: SpecificIntentSchema.optional(),
  scope: ScopeSchema.optional(),
  transactionType: TransactionTypeSchema.optional(),
  lastSearchCriteria: RealEstateSearchParamsSchema.optional().describe("The last search criteria used by the user."),
  details: ConversationStateDetailsSchema.optional(),
  hasBeenUpdatedByAgent: HasBeenUpdatedByAgentSchema.optional()
});
var ConversationStateSchema = RealEstateConversationStateSchema;
var RetailSearchParamsSchema = z16.object({
  // Basic search parameters
  query: z16.string().describe("General search query for product title, description, or keywords (optional).").nullable(),
  // Brand filtering
  brand: z16.string().describe("Filter by specific brand name (optional).").nullable(),
  brandIds: z16.array(z16.string()).describe("Filter by specific brand IDs (optional, default is an empty array)."),
  // Category filtering
  categories: z16.array(z16.string()).describe("Filter by product categories (optional, default is an empty array)."),
  categoryIds: z16.array(z16.string()).describe("Filter by specific category IDs (optional, default is an empty array)."),
  // Price filtering
  minPrice: z16.number().describe("The minimum price (optional).").nullable(),
  maxPrice: z16.number().describe("The maximum price (optional).").nullable(),
  // Product identification
  sku: z16.string().describe("Filter by specific SKU (optional).").nullable(),
  // Product status and availability
  inStock: z16.boolean().describe("Filter products by stock availability (optional).").nullable(),
  // Promotion filtering
  hasActivePromo: z16.boolean().describe("Filter products with active promotions (optional).").nullable()
});
var RetailOrderItemSchema = z16.object({
  productId: z16.string().describe("The product ID"),
  quantity: z16.number().positive().describe("The quantity of the product"),
  addedAt: z16.string().describe("ISO timestamp when the item was added to the order")
});
var RetailOrderSchema = z16.object({
  items: z16.array(RetailOrderItemSchema).describe("The items in the order"),
  notes: z16.string().describe("Optional notes or comments for the order").optional(),
  createdAt: z16.string().describe("ISO timestamp when the order was created"),
  updatedAt: z16.string().describe("ISO timestamp when the order was last updated"),
  status: z16.enum(["draft", "committed"]).describe("The status of the order")
});
var RetailHasContactedCompanySchema = z16.boolean().describe("Whether the user has contacted the company.");
var RetailConversationStateDetailsSchema = z16.string().describe("It captures qualitative details about the user request.");
var RetailGeneralIntentSchema = z16.enum(["SEARCH_PRODUCTS", "MODIFY_ORDER", "CONTACT_COMPANY", "GENERAL_INQUIRY"]).describe(
  "This is the most general intent of the user. Either he wants to search products, modify the current order, contact the company or ask a general question."
);
var RetailConversationStateSchema = z16.object({
  generalIntent: RetailGeneralIntentSchema.optional(),
  hasContactedCompany: RetailHasContactedCompanySchema.optional(),
  details: RetailConversationStateDetailsSchema.optional(),
  lastSearchCriteria: RetailSearchParamsSchema.optional().describe("The last search criteria used by the user."),
  currentOrder: RetailOrderSchema.optional().describe("The current order being managed by the user."),
  hasBeenUpdatedByAgent: HasBeenUpdatedByAgentSchema.optional()
});
var AnyConversationStateSchema = z16.union([RealEstateConversationStateSchema, RetailConversationStateSchema]);

// src/types/conversation/message/message-content-type.ts
import z17 from "zod";
var TEXT_MESSAGE_CONTENT_TYPE = "text";
var IMAGE_MESSAGE_CONTENT_TYPE = "image";
var AUDIO_MESSAGE_CONTENT_TYPE = "audio";
var MimeTypeSchema = z17.string();
var CaptionSchema = z17.string().max(3e3);
var ResourceRefSchema = z17.discriminatedUnion("kind", [
  z17.object({ kind: z17.literal("url"), url: z17.string() }),
  z17.object({ kind: z17.literal("fileId"), fileId: z17.string() })
]);
var TextMessageContentSchema = z17.object({
  type: z17.literal(TEXT_MESSAGE_CONTENT_TYPE),
  text: z17.string().max(7500)
});
var ImageMessageContentSchema = z17.object({
  type: z17.literal(IMAGE_MESSAGE_CONTENT_TYPE),
  resource: ResourceRefSchema,
  mimeType: MimeTypeSchema,
  alt: z17.string().max(1e3).optional(),
  caption: CaptionSchema.optional()
});
var AudioMessageContentSchema = z17.object({
  type: z17.literal(AUDIO_MESSAGE_CONTENT_TYPE),
  resource: ResourceRefSchema,
  mimeType: MimeTypeSchema,
  transcription: z17.string().max(15e3).optional()
});
var MessageContentSchema = z17.discriminatedUnion("type", [
  TextMessageContentSchema,
  ImageMessageContentSchema,
  AudioMessageContentSchema
]);
function extractTextMessageContents(contents) {
  return contents.filter((content) => content.type === TEXT_MESSAGE_CONTENT_TYPE);
}
function extractOnlyTextMessageContent(contents) {
  const textContents = extractTextMessageContents(contents);
  return textContents.map((content) => content.text).join("\n");
}
function buildTextMessageContent(text) {
  return { type: TEXT_MESSAGE_CONTENT_TYPE, text };
}

// src/types/chat/tool-invocation.type.ts
import z18 from "zod";
var CONTACT_FORM_TOOL_NAME = "displayContactForm";
var ToolNameSchema = z18.enum([CONTACT_FORM_TOOL_NAME]);
var BaseToolInvocationSchema = z18.object({
  toolCallId: z18.string(),
  name: z18.string(),
  args: z18.record(z18.any()).optional(),
  result: z18.string().optional()
});
var DisplayContactFormToolInvocationSchema = BaseToolInvocationSchema.extend({
  name: z18.literal(CONTACT_FORM_TOOL_NAME),
  // this will be a stringified JSON object with the following schema
  result: z18.object({
    name: z18.string().optional(),
    email: z18.string().optional(),
    phone: z18.string().optional(),
    message: z18.string().optional()
  }).optional()
});
var ToolInvocationSchema = z18.discriminatedUnion("name", [DisplayContactFormToolInvocationSchema]);

// src/types/chat/conversation.type.ts
var CHAT_CONVERSATION_CHANNEL = ["FACEBOOK", "INSTAGRAM", "SANDBOX", "WEB", "WHATSAPP"];
var ChatConversationChannelSchema = z19.enum(CHAT_CONVERSATION_CHANNEL);
var CHUNK_END_SEPARATOR = "";
var STRING_PREFIX = "STRING";
var TOOLCALL_PREFIX = "TOOLCALL";
var TOOLRESULT_PREFIX = "TOOLRESULT";
var ERROR_PREFIX = "ERROR";
var DataStreamPrefixSchema = z19.enum([STRING_PREFIX, TOOLCALL_PREFIX, TOOLRESULT_PREFIX, ERROR_PREFIX]);
var AssistantMessageDtoSchema = z19.object({
  role: z19.literal("assistant"),
  manual: z19.boolean().optional().describe("Indicates whether this message was manually added to the history."),
  //! Deprecated: Use HumanAssistantMessageSchema
  sentBy: z19.string().optional().describe('ID that references "who" sent this message, useful to identify which user has sent a manual message.'),
  content: MessageContentSchema.array(),
  id: z19.string().min(1),
  createdAt: z19.string().datetime(),
  // Tool invocations results should be a string
  // the result will be parsed in the client
  toolInvocations: z19.array(BaseToolInvocationSchema).optional(),
  metadata: z19.object({
    isAdReply: z19.boolean().optional()
  }).optional()
});
var ChannelSpecificMessageSchema = z19.object({
  whatsapp: z19.object({
    echoFromPhoneNumber: z19.string().optional()
  }).optional(),
  messenger: z19.object({
    //! TODO: Placeholder
  }).optional(),
  instagram: z19.object({
    //! TODO: Placeholder
  }).optional()
});
var HumanAssistantMessageSourceSchema = z19.enum(["whatsapp", "instagram", "messenger", "customer_dashboard"]);
var HumanAssistantMessageDtoSchema = z19.object({
  role: z19.literal("human_assistant"),
  userId: z19.string().uuid().optional(),
  source: HumanAssistantMessageSourceSchema.optional(),
  //! Source is optional as older messages don't have it
  content: MessageContentSchema.array(),
  id: z19.string().min(1),
  createdAt: z19.string().datetime()
}).merge(ChannelSpecificMessageSchema);
var UserMessageDtoSchema = z19.object({
  role: z19.literal("user"),
  content: MessageContentSchema.array(),
  id: z19.string().min(1),
  createdAt: z19.string().datetime()
}).merge(ChannelSpecificMessageSchema);
var ConversationMessageDtoSchema = z19.discriminatedUnion("role", [
  AssistantMessageDtoSchema,
  UserMessageDtoSchema,
  HumanAssistantMessageDtoSchema
]);
var ToolCallSchema = z19.object({
  toolCallId: z19.string(),
  args: z19.record(z19.any()),
  name: z19.string()
});
var ToolResultDtoSchema = z19.object({
  toolCallId: z19.string(),
  result: z19.string(),
  name: z19.string()
});
var ChatConversationReviewContentSchema = z19.object({
  rating: z19.number().int().min(1).max(5),
  comment: z19.string()
});
var ChatConversationMetadataSchema = z19.object({
  facebook: z19.object({
    psid: z19.string().optional(),
    pageId: z19.string().optional()
  }).optional(),
  instagram: z19.object({
    instagramSenderBusinessScopedUserId: z19.string().optional(),
    instagramSenderUserName: z19.string().optional(),
    instagramRecipientAccountId: z19.string().optional()
  }).optional(),
  whatsapp: z19.object({
    whatsappUserPhoneNumber: z19.string(),
    whatsappBusinessAccountId: z19.string(),
    whatsappBusinessPhoneNumberId: z19.string()
  }).optional(),
  manualMode: z19.boolean().optional(),
  manualModeStartedOn: z19.preprocess((val) => val instanceof Date ? val.toISOString() : val, z19.string().optional()),
  reads: z19.record(
    z19.string(),
    z19.preprocess((val) => val instanceof Date ? val.toISOString() : val, z19.string())
  ).optional(),
  conversationState: AnyConversationStateSchema.optional()
});

// src/types/customer-chatbot/base-customer-chatbot.type.ts
import z25 from "zod";

// src/types/zod/zod-custom-schemas.type.ts
import z20 from "zod";
var zLiteralSchema = z20.union([z20.string(), z20.number(), z20.boolean(), z20.null()]);
var zJsonSchema = () => z20.lazy(() => z20.union([zLiteralSchema, z20.array(zJsonSchema()), z20.record(zJsonSchema())]));
var IsEnabledSwitchSchema = z20.coerce.boolean().default(false);
var dateStringSchema = () => z20.union([z20.string(), z20.date()]).transform((val) => val instanceof Date ? val.toISOString() : val);

// src/types/customer-chatbot/customer-chatbot-config.type.ts
import { z as z22 } from "zod";

// src/types/customer-chatbot/customer-chatbot-config/initial-message.type.ts
import { z as z21 } from "zod";
var MessageSchema = z21.string().max(300, { message: "El m\xE1ximo de caracteres permitidos es de 300" });
var AdditionalMessagesSchema = z21.object({
  urlMatcher: z21.array(z21.string()).min(1, { message: "Debes tener al menos un URL matcher" }),
  message: MessageSchema
});
var InitialMessageSchema = z21.object({
  defaultMessage: MessageSchema,
  additionalMessages: z21.array(AdditionalMessagesSchema).optional()
});

// src/types/customer-chatbot/customer-chatbot-config.type.ts
var ZIndexSchema = z22.number({ invalid_type_error: "El valor deber ser un numero entero" }).int().min(0, { message: "El valor no puede ser menor a 0" }).max(999999, {
  message: "El valor no puede ser mayor a 999999"
});
var PositionValueSchema = z22.number({ invalid_type_error: "El valor deber ser un numero entero" }).int().min(10, { message: "El valor no puede ser menor a 10px" }).max(100, { message: "El valor no puede ser mayor a 100px" });
var BaseCustomerChatbotConfigurationStyleSchema = z22.object({
  primaryColor: z22.string(),
  zIndex: ZIndexSchema,
  position: z22.object({
    bottom: PositionValueSchema,
    right: PositionValueSchema
  })
});
var BaseCustomerChatbotConfigurationSchema = z22.object({
  companyDescription: z22.string().optional().nullable(),
  conversationTone: z22.string().optional().nullable(),
  reinforcedInstructions: z22.string().optional().nullable(),
  agents: z22.record(z22.string(), z22.any()),
  integrationStrategy: z22.record(z22.string(), z22.any()).optional(),
  homeUrl: z22.string(),
  companyName: z22.string(),
  phoneNumber: z22.string().optional().nullable(),
  manualMode: z22.object({
    maxDuration: z22.number().positive().nullable()
    // A custom duration for the manual mode in seconds. If null, the manual mode will be enabled until the conversation is closed.
  }).optional(),
  initialMessages: InitialMessageSchema,
  style: BaseCustomerChatbotConfigurationStyleSchema,
  channels: z22.object({
    web: z22.object({
      isEnabled: z22.boolean(),
      allowedDomains: z22.array(z22.string())
    }),
    whatsapp: z22.object({
      isEnabled: z22.boolean(),
      phoneNumberId: z22.string().nullable(),
      phoneFilterMode: z22.enum(["none", "whitelist", "blacklist"]).optional(),
      allowedSenders: z22.array(z22.string()).optional(),
      blockedSenders: z22.array(z22.string()).optional(),
      markIncomingMessagesAsRead: z22.boolean().optional()
    }),
    instagram: z22.object({
      isEnabled: z22.boolean(),
      instagramAccountId: z22.string().nullable()
    }),
    messengerFacebookPages: z22.object({
      isEnabled: z22.boolean(),
      facebookPageId: z22.string().nullable(),
      markIncomingMessagesAsRead: z22.boolean().optional()
    })
  })
});
var BASE_CUSTOMER_CHATBOT_CONFIGURATION_KEYS_TO_OMIT = {
  integrationStrategy: true,
  homeUrl: true,
  companyName: true,
  channels: true
};

// src/types/customer-chatbot/customer-chatbot-key.type.ts
import z23 from "zod";
var CustomerChatbotKeySchema = z23.string().length(64);

// src/types/customer-chatbot/vertical.type.ts
import z24 from "zod";
var REAL_ESTATE_VERTICAL = "REAL_ESTATE";
var CUSTOM_BOLSA_COMERCIO_ROSARIO = "CUSTOM_BOLSA_COMERCIO_ROSARIO";
var RETAIL_VERTICAL = "RETAIL";
var HOTEL_VERTICAL = "HOTEL";
var UNASSIGNED = "UNASSIGNED";
var VERTICAL = [
  REAL_ESTATE_VERTICAL,
  RETAIL_VERTICAL,
  HOTEL_VERTICAL,
  CUSTOM_BOLSA_COMERCIO_ROSARIO,
  UNASSIGNED
];
var VerticalSchema = z24.enum(VERTICAL);

// src/types/customer-chatbot/base-customer-chatbot.type.ts
var CustomerChatbotMetadataSchema = z25.object({
  // // Tracks data source synchronization status to inform users about the current state of their chatbot's knowledge base
  //! TODO: Move this to a new customer integration metadata schema
  // dataSourceSynchronization: z
  //   .object({
  //     lastSuccessfulSynchronizationDate: z.string().nullable(),
  //     job: z
  //       .object({
  //         id: z.string(),
  //         date: z.string(),
  //         status: z.enum(['running', 'completed', 'failed']),
  //         meilisearchTasks: z.array(z.object({ id: z.string() })),
  //       })
  //       .nullable(),
  //   })
  //   .optional(),
  // Tracks websites where the chatbot is installed (checked via get-config endpoint) to alert users if the chatbot needs to be connected
  connectedWebsites: z25.array(
    z25.object({
      host: z25.string(),
      lastCheckDate: dateStringSchema()
    })
  ).optional(),
  // Tracks when the chatbot appearance was last customized, allowing us to prompt users who haven't personalized their chatbot yet
  appearance: z25.object({
    lastUpdatedDate: dateStringSchema()
  }).optional(),
  // Tracks when the chatbot initial messages were last customized, allowing us to prompt users who haven't personalized their chatbot yet
  initialMessages: z25.object({
    lastUpdatedDate: dateStringSchema()
  }).optional()
});
var BaseCustomerChatbotSchema = z25.object({
  vertical: VerticalSchema,
  id: z25.string().uuid(),
  key: CustomerChatbotKeySchema,
  customer_id: z25.string().uuid(),
  lead_field_profile_id: z25.string().uuid().nullable(),
  name: z25.string(),
  active: z25.boolean(),
  configuration: BaseCustomerChatbotConfigurationSchema,
  customerIntegrationId: z25.string().uuid().nullable(),
  //! TODO: Remove optional clause once cache is flushed
  metadata: CustomerChatbotMetadataSchema.optional()
});

// src/types/application-events/application-events.type.ts
import z29 from "zod";

// src/types/event-automation/trigger/trigger-event-type.ts
import z26 from "zod";
var REAL_ESTATE_LEAD_REQUESTED_CONTACT_EVENT_TYPE = "chatbot.real_estate.lead.requested_contact";
var REAL_ESTATE_LEAD_REQUESTED_APPRAISAL_EVENT_TYPE = "chatbot.real_estate.lead.requested_appraisal";
var REAL_ESTATE_LEAD_REQUESTED_VISIT_EVENT_TYPE = "chatbot.real_estate.lead.requested_visit";
var RETAIL_LEAD_CREATED_EVENT_TYPE = "chatbot.retail.lead.created";
var RETAIL_LEAD_REQUESTED_CONTACT_CUSTOMER_SUPPORT_EVENT_TYPE = "chatbot.retail.contact.requested_customer_support";
var COMMON_MESSAGE_FAILED_EVENT_TYPE = "chatbot.common.message.failed";
var TriggerEventTypeSchema = z26.enum([
  REAL_ESTATE_LEAD_REQUESTED_CONTACT_EVENT_TYPE,
  REAL_ESTATE_LEAD_REQUESTED_APPRAISAL_EVENT_TYPE,
  REAL_ESTATE_LEAD_REQUESTED_VISIT_EVENT_TYPE,
  RETAIL_LEAD_REQUESTED_CONTACT_CUSTOMER_SUPPORT_EVENT_TYPE
]);

// src/types/application-events/chatbot-application-events.type.ts
import { z as z27 } from "zod";
var BaseChatbotEventSchema = z27.object({
  // FIX: remove customerId, this is not needed in the event
  customerId: z27.string().uuid(),
  chatbotId: z27.string().uuid(),
  conversationId: z27.string().uuid(),
  date: z27.string()
});
var BaseChatbotRealEstateLeadDataSchema = z27.object({
  contactId: z27.string().uuid(),
  customFields: z27.record(z27.string(), zJsonSchema()).optional(),
  // Custom fields that the customer could set up for the bot to ask the user
  visitedProperties: z27.string().optional(),
  // A list of properties that the user has visited on the website before this lead is sent
  //! TODO: FIX THIS
  conversationChannel: ChatConversationChannelSchema,
  conversationMessages: z27.array(ConversationMessageDtoSchema),
  transactionType: ConversationStateSchema.shape.transactionType.optional(),
  lastPropertyInterestedIn: ConversationStateSchema.shape.lastPropertyInterestedIn.optional()
});
var RealEstateAppraisalLeadDataSchema = z27.object({
  leadType: z27.literal("appraisal"),
  propertyAddress: z27.string(),
  propertyType: z27.string().optional(),
  propertyDetails: z27.string().optional(),
  preferredAppraisalDate: z27.string().optional()
}).merge(BaseChatbotRealEstateLeadDataSchema);
var RealEstateVisitLeadDataSchema = z27.object({
  leadType: z27.literal("visit"),
  propertyId: z27.string(),
  preferredVisitDate: z27.string().optional()
}).merge(BaseChatbotRealEstateLeadDataSchema);
var RealEstateContactLeadDataSchema = z27.object({
  leadType: z27.literal("contact")
}).merge(BaseChatbotRealEstateLeadDataSchema);
var ChatbotRealEstateRequestedContactEventSchema = z27.object({
  eventType: z27.literal(REAL_ESTATE_LEAD_REQUESTED_CONTACT_EVENT_TYPE),
  data: RealEstateContactLeadDataSchema
}).merge(BaseChatbotEventSchema);
var ChatbotRealEstateRequestedAppraisalEventSchema = z27.object({
  eventType: z27.literal(REAL_ESTATE_LEAD_REQUESTED_APPRAISAL_EVENT_TYPE),
  data: RealEstateAppraisalLeadDataSchema
}).merge(BaseChatbotEventSchema);
var ChatbotRealEstateRequestedVisitEventSchema = z27.object({
  eventType: z27.literal(REAL_ESTATE_LEAD_REQUESTED_VISIT_EVENT_TYPE),
  data: RealEstateVisitLeadDataSchema
}).merge(BaseChatbotEventSchema);
var BaseChatbotRetailLeadDataSchema = z27.object({
  contactId: z27.string().uuid(),
  customFields: z27.record(z27.string(), zJsonSchema()).optional(),
  // Custom fields that the customer could set up for the bot to ask the user
  conversationChannel: ChatConversationChannelSchema,
  conversationMessages: z27.array(ConversationMessageDtoSchema)
});
var RetailContactCustomerSupportDataSchema = z27.object({
  reason: z27.literal("customer_support")
}).merge(BaseChatbotRetailLeadDataSchema);
var ChatbotRetailRequestedContactCustomerSupportEventSchema = z27.object({
  eventType: z27.literal(RETAIL_LEAD_REQUESTED_CONTACT_CUSTOMER_SUPPORT_EVENT_TYPE),
  data: RetailContactCustomerSupportDataSchema
}).merge(BaseChatbotEventSchema);
var ChatbotApplicationEventSchema = z27.discriminatedUnion("eventType", [
  ChatbotRealEstateRequestedContactEventSchema,
  ChatbotRealEstateRequestedAppraisalEventSchema,
  ChatbotRealEstateRequestedVisitEventSchema,
  ChatbotRetailRequestedContactCustomerSupportEventSchema
]);

// src/types/application-events/workflow-application-events.type.ts
import { z as z28 } from "zod";
var WorkflowEventTypesSchema = z28.enum([
  "workflows.lead.created",
  "workflows.lead.assigned",
  "workflows.lead.step_changed"
]);
var BaseWorkflowEventSchema = z28.object({
  customerId: z28.string().uuid(),
  workflowId: z28.string().uuid(),
  contactId: z28.string().uuid(),
  date: z28.string()
});
var WorkflowLeadCreatedEventSchema = z28.object({
  eventType: z28.literal(WorkflowEventTypesSchema.enum["workflows.lead.created"]),
  data: z28.object({
    stepId: z28.string(),
    conversationId: z28.string().uuid().optional()
  })
}).merge(BaseWorkflowEventSchema);
var WorkflowLeadAssignedEventSchema = z28.object({
  eventType: z28.literal(WorkflowEventTypesSchema.enum["workflows.lead.assigned"]),
  data: z28.object({
    assignedToUserId: z28.string().uuid(),
    conversationId: z28.string().uuid().optional()
  })
}).merge(BaseWorkflowEventSchema);
var WorkflowLeadStepChangedEventSchema = z28.object({
  eventType: z28.literal(WorkflowEventTypesSchema.enum["workflows.lead.step_changed"]),
  data: z28.object({
    stepId: z28.string(),
    conversationId: z28.string().uuid().optional()
  })
}).merge(BaseWorkflowEventSchema);
var WorkflowApplicationEventSchema = z28.discriminatedUnion("eventType", [
  WorkflowLeadCreatedEventSchema,
  WorkflowLeadAssignedEventSchema,
  WorkflowLeadStepChangedEventSchema
]);

// src/types/application-events/application-events.type.ts
var ApplicationEventTypesSchema = z29.enum([
  ...TriggerEventTypeSchema.options,
  ...WorkflowEventTypesSchema.options
]);
var ApplicationEventSchema = ChatbotApplicationEventSchema.or(WorkflowApplicationEventSchema);

// src/types/customer-chatbot/customer-chatbot.type.ts
import z31 from "zod";

// src/types/customer-chatbot/customer-chatbot-config/real-estate/customer-chatbot-config.type.ts
import { z as z30 } from "zod";
var RealEstateCustomerChatbotConfigurationSchema = BaseCustomerChatbotConfigurationSchema.extend({
  agents: RealEstateAgentConfigSchema,
  geocodingEnabled: z30.boolean().optional()
});
var RealEstateCustomerChatbotSchema = BaseCustomerChatbotSchema.extend({
  vertical: z30.literal(REAL_ESTATE_VERTICAL),
  configuration: RealEstateCustomerChatbotConfigurationSchema
});
var BolsaComercioRosarioCustomerChatbotConfigurationSchema = BaseCustomerChatbotConfigurationSchema.extend({
  agents: z30.any()
  // TODO: Define Agents
});
var BolsaComercioRosarioCustomerChatbotSchema = BaseCustomerChatbotSchema.extend({
  vertical: z30.literal(CUSTOM_BOLSA_COMERCIO_ROSARIO),
  configuration: BolsaComercioRosarioCustomerChatbotConfigurationSchema
});
var RetailCustomerChatbotConfigurationSchema = BaseCustomerChatbotConfigurationSchema.extend({
  agents: z30.any()
  // TODO: Add Whatever agent config is needed
});
var RetailCustomerChatbotSchema = BaseCustomerChatbotSchema.extend({
  vertical: z30.literal(RETAIL_VERTICAL),
  configuration: RetailCustomerChatbotConfigurationSchema
});
var CustomerChatbotConfigurationUnionSchema = z30.union([
  RealEstateCustomerChatbotConfigurationSchema,
  BolsaComercioRosarioCustomerChatbotConfigurationSchema,
  RetailCustomerChatbotConfigurationSchema
]);

// src/types/customer-chatbot/customer-chatbot.type.ts
var CustomerChatbotUnionSchema = z31.discriminatedUnion("vertical", [
  RealEstateCustomerChatbotSchema,
  BolsaComercioRosarioCustomerChatbotSchema,
  RetailCustomerChatbotSchema
]);

// src/utils/zod-utils.ts
var preprocessStringToNumber = (val) => {
  return typeof val === "string" ? parseInt(val) : val;
};
var preprocessStringToBoolean = (val) => {
  if (typeof val === "string") {
    const v = val.toLowerCase();
    if (v === "true") return true;
    if (v === "false") return false;
  } else if (typeof val === "boolean") {
    return val;
  }
  return void 0;
};
var preprocessStringToArray = (val) => {
  if (typeof val === "string") {
    return [val];
  } else if (Array.isArray(val)) {
    return val;
  }
  return void 0;
};

// src/dtos/common/database-queries.dto.ts
import z32 from "zod";
var PaginatedEntityListDtoSchema = z32.object({
  pageSize: z32.preprocess(
    preprocessStringToNumber,
    z32.union([z32.literal(10), z32.literal(20), z32.literal(50), z32.literal(100)], {
      invalid_type_error: "Solo se permite paginar por 10, 20, 50 o 100 elementos por p\xE1gina"
    }).default(20)
  ),
  currentPage: z32.preprocess(preprocessStringToNumber, z32.number().int().min(1).default(1)),
  orderBy: z32.enum(["created_at", "id"], {
    invalid_type_error: "No se puede ordenar por este campo."
  }).default("created_at"),
  orderCriteria: z32.enum(["asc", "desc"], {
    invalid_type_error: 'El criterio de ordenamiento no es v\xE1lido. Valores permitidos "asc", "desc".'
  }).default("desc")
});

// src/dtos/chat-conversation/create-chat-conversation.dto.ts
import z36 from "zod";

// src/dtos/webhooks/instagram/webhook-instagram-chatbot.ts
import { z as z33 } from "zod";
var InstagramUserSchema = z33.object({
  id: z33.string()
});
var InstagramMessageAttachmentSchema = z33.object({
  type: z33.enum(["audio", "file", "ig_reel", "image", "reel", "share", "story_mention", "video"]),
  payload: z33.object({
    url: z33.string()
  })
});
var InstagramMessageReplyToSchema = z33.union([
  z33.object({
    mid: z33.string().optional()
  }),
  z33.object({
    story: z33.object({
      url: z33.string(),
      id: z33.string()
    }).optional()
  })
]);
var InstagramMessageReferralSchema = z33.union([
  z33.object({
    product: z33.object({
      id: z33.string()
    }).optional()
  }),
  z33.object({
    ref: z33.string().optional(),
    ad_id: z33.string().optional(),
    source: z33.literal("ADS").optional(),
    type: z33.literal("OPEN_THREAD").optional(),
    ads_context_data: z33.object({
      ad_title: z33.string().optional(),
      photo_url: z33.string().optional(),
      video_url: z33.string().optional()
    }).optional()
  })
]);
var InstagramMessageSchema = z33.object({
  mid: z33.string(),
  text: z33.string().optional(),
  is_deleted: z33.boolean().optional(),
  is_echo: z33.boolean().optional(),
  is_unsupported: z33.boolean().optional(),
  attachments: z33.array(InstagramMessageAttachmentSchema).optional(),
  quick_reply: z33.object({
    payload: z33.string()
  }).optional(),
  referral: InstagramMessageReferralSchema.optional(),
  reply_to: InstagramMessageReplyToSchema.optional()
});
var InstagramReactionSchema = z33.object({
  mid: z33.string(),
  action: z33.enum(["react", "unreact"]),
  reaction: z33.string().optional(),
  // Not included when action is 'unreact'
  emoji: z33.string().optional()
  // Not included when action is 'unreact'
});
var InstagramPostbackSchema = z33.object({
  mid: z33.string(),
  title: z33.string(),
  payload: z33.string()
});
var InstagramMessagingReferralSchema = z33.object({
  ref: z33.string().optional(),
  source: z33.string().optional(),
  type: z33.string().optional()
});
var InstagramReadSchema = z33.object({
  mid: z33.string()
});
var InstagramMessagingSchema = z33.object({
  sender: InstagramUserSchema,
  recipient: InstagramUserSchema,
  timestamp: z33.number(),
  // One or more of these may appear
  message: InstagramMessageSchema.optional(),
  reaction: InstagramReactionSchema.optional(),
  postback: InstagramPostbackSchema.optional(),
  referral: InstagramMessagingReferralSchema.optional(),
  read: InstagramReadSchema.optional()
});
var InstagramEntrySchema = z33.object({
  id: z33.string(),
  time: z33.number(),
  messaging: z33.array(InstagramMessagingSchema)
});
var InstagramWebhookDtoSchema = z33.object({
  object: z33.literal("instagram"),
  entry: z33.array(InstagramEntrySchema)
});

// src/dtos/webhooks/messenger/webhook-messenger-facebook-pages-chatbot.ts
import z34 from "zod";
var MessengerFacebookPagesBaseMessageSchema = z34.object({
  mid: z34.string(),
  // An optional reference to the message ID that this message is replying to
  reply_to: z34.object({
    mid: z34.string()
  }).optional()
});
var MessengerFacebookPagesTextMessageSchema = MessengerFacebookPagesBaseMessageSchema.extend({
  text: z34.string(),
  // A quick_reply payload is only provided with a text message when the user tap on a Quick Replies button.
  // https://developers.facebook.com/docs/messenger-platform/send-messages/quick-replies
  quick_reply: z34.object({
    payload: z34.record(z34.string(), z34.any())
  }).optional()
});
var MessengerFacebookPagesMessageAttachmentAudio = z34.object({
  type: z34.literal("audio"),
  payload: z34.object({
    url: z34.string()
  })
});
var MessengerFacebookPagesMessageAttachmentFile = z34.object({
  type: z34.literal("file"),
  payload: z34.object({
    url: z34.string()
  })
});
var MessengerFacebookPagesMessageAttachmentImage = z34.object({
  type: z34.literal("image"),
  payload: z34.object({
    url: z34.string(),
    sticker_id: z34.number().optional()
    // Only applicable to image (when a sticker is sent)
  })
});
var MessengerFacebookPagesMessageAttachmentFallback = z34.object({
  type: z34.literal("fallback"),
  payload: z34.object({
    url: z34.string(),
    // Fallback attachment url
    title: z34.string().optional()
    // Only applicable to fallback, reel, and ig_reel
  })
});
var MessengerFacebookPagesMessageAttachmentReel = z34.object({
  type: z34.literal("reel"),
  payload: z34.object({
    url: z34.string(),
    title: z34.string(),
    // Only applicable to fallback, reel, and ig_reel
    reel_video_id: z34.string()
    // Only applicable to reel and ig_reel
  })
});
var MessengerFacebookPagesMessageAttachmentIgReel = z34.object({
  type: z34.literal("ig_reel"),
  payload: z34.object({
    url: z34.string(),
    title: z34.string(),
    // Only applicable to fallback, reel, and ig_reel
    reel_video_id: z34.string()
    // Only applicable to reel and ig_reel
  })
});
var MessengerFacebookPagesMessageAttachmentVideo = z34.object({
  type: z34.literal("video"),
  payload: z34.object({
    url: z34.string()
  })
});
var MessengerFacebookPagesMessageAttachmentProductTemplate = z34.object({
  type: z34.literal("template"),
  payload: z34.object({
    product: z34.object({
      elements: z34.array(
        z34.object({
          id: z34.string(),
          // Product ID
          retailer_id: z34.string(),
          // External ID
          image_url: z34.string(),
          title: z34.string(),
          subtitle: z34.string()
        })
      )
    })
  })
});
var MessengerFacebookPagesMessageWithAttachmentSchema = MessengerFacebookPagesBaseMessageSchema.extend({
  text: z34.string().optional(),
  attachments: z34.array(
    z34.union([
      MessengerFacebookPagesMessageAttachmentAudio,
      MessengerFacebookPagesMessageAttachmentFallback,
      MessengerFacebookPagesMessageAttachmentFile,
      MessengerFacebookPagesMessageAttachmentIgReel,
      MessengerFacebookPagesMessageAttachmentImage,
      MessengerFacebookPagesMessageAttachmentReel,
      MessengerFacebookPagesMessageAttachmentVideo,
      MessengerFacebookPagesMessageAttachmentProductTemplate
    ])
  )
});
var MessengerFacebookPagesMessageFromShopsProductDetailPageSchema = MessengerFacebookPagesBaseMessageSchema.extend({
  text: z34.string(),
  referral: z34.object({
    source: z34.string(),
    type: z34.string(),
    ref: z34.string(),
    ad_id: z34.string().optional(),
    ads_context_data: z34.object({
      ad_title: z34.string(),
      photo_url: z34.string().optional(),
      video_url: z34.string().optional(),
      product_id: z34.string().optional(),
      post_id: z34.string()
    }).optional(),
    product: z34.object({
      id: z34.string()
    }).optional()
  })
});
var MessengerFacebookPagesMessageWithCommandsSchema = MessengerFacebookPagesBaseMessageSchema.extend({
  text: z34.string(),
  commands: z34.array(z34.object({ name: z34.string() }))
});
var MessengerFacebookPagesMessageSchema = z34.union([
  // The order of these schemas matters for correct type inference
  MessengerFacebookPagesMessageFromShopsProductDetailPageSchema,
  MessengerFacebookPagesMessageWithAttachmentSchema,
  MessengerFacebookPagesMessageWithCommandsSchema,
  MessengerFacebookPagesTextMessageSchema
]);
var MessengerFacebookPagesMessagesWebhookDtoSchema = z34.object({
  object: z34.literal("page"),
  entry: z34.array(
    z34.object({
      id: z34.string(),
      // Page id
      time: z34.number().optional(),
      messaging: z34.array(
        z34.object({
          timestamp: z34.number().optional(),
          sender: z34.object({
            id: z34.string(),
            // Page scoped user id
            user_ref: z34.string().optional()
            // optional - the reference for a person who used the Chat Plugin to message your business
          }),
          recipient: z34.object({
            id: z34.string()
            // Page id
          }),
          message: MessengerFacebookPagesMessageSchema
        })
      )
    })
  ).min(1)
});

// src/dtos/webhooks/whatsapp/webhook-whatsapp-chatbot.ts
import { z as z35 } from "zod";
var WhatsappErrorSchema = z35.object({
  code: z35.number(),
  title: z35.string(),
  message: z35.string(),
  error_data: z35.object({
    details: z35.string()
  })
});
var WhatsappBaseMessageSchema = z35.object({
  // The customer's WhatsApp ID. A business can respond to a customer using this ID.
  // This ID may not match the customer's phone number, which is returned by the API as input when sending a message to the customer.
  from: z35.string(),
  //! <WHATSAPP_USER_PHONE_NUMBER> for incoming messages, <WHATSAPP_BUSINESS_PHONE_NUMBER> for echoes messages
  to: z35.string().optional(),
  //! <WHATSAPP_USER_PHONE_NUMBER> for echoes messages
  // The ID for the message that was received by the business.
  // You could use messages endpoint to mark this specific message as read.
  id: z35.string(),
  //'<WHATSAPP_MESSAGE_ID>',
  timestamp: z35.string(),
  // Unix timestamp indicating when the WhatsApp server received the message from the customer.
  // Optionals
  // Only included when a user replies or interacts with one of your messages
  context: z35.object({
    forwarded: z35.boolean().optional(),
    // Set to true if the message received by the business has been forwarded.
    frequently_forwarded: z35.boolean().optional(),
    // Set to true if the message received by the business has been forwarded more than 5 times.
    from: z35.string().optional(),
    // The WhatsApp ID for the customer who replied to an inbound message.
    id: z35.string().optional(),
    // The message ID for the sent message for an inbound reply.
    referred_product: z35.object({
      catalog_id: z35.string(),
      product_retailer_id: z35.string()
    }).optional()
  }).optional(),
  errors: z35.array(WhatsappErrorSchema).optional(),
  // An identity object. Webhook is triggered when a customer's phone number or profile information has been updated
  identity: z35.object({ acknowledged: z35.any(), created_timestamp: z35.string(), hash: z35.string() }).optional(),
  // When a customer has interacted with your message, this object is included in the messages object
  interactive: z35.object({
    type: z35.object({
      // Sent when a customer clicks a button
      button_reply: z35.object({
        id: z35.string(),
        title: z35.string()
      }).optional(),
      // Sent when a customer selects an item from a list.
      list_reply: z35.object({
        id: z35.string(),
        title: z35.string(),
        description: z35.string()
      }).optional()
    })
  }).optional(),
  // Included in the messages object when a customer has placed an order
  order: z35.object({
    catalog_id: z35.string(),
    text: z35.string(),
    product_items: z35.array(
      z35.object({
        product_retailer_id: z35.string(),
        quantity: z35.string(),
        item_price: z35.string(),
        currency: z35.string()
      })
    )
  }).optional(),
  // When a customer clicks an ad that redirects to WhatsApp, this object is included in the messages object.
  referral: z35.object({
    source_url: z35.string(),
    source_type: z35.string(),
    source_id: z35.string(),
    headline: z35.string(),
    body: z35.string(),
    media_type: z35.string().optional(),
    image_url: z35.string().optional(),
    video_url: z35.string().optional(),
    thumbnail_url: z35.string().optional(),
    ctwa_clid: z35.string()
  }).optional()
});
var WhatsappTextMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("text"),
  text: z35.object({
    body: z35.string()
    //'<MESSAGE_BODY_TEXT>',
  })
});
var WhatsappReactionMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("reaction"),
  reaction: z35.object({
    message_id: z35.string(),
    emoji: z35.string()
  })
});
var WhatsappAudioMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("audio"),
  audio: z35.object({
    mime_type: z35.string(),
    id: z35.string(),
    sha256: z35.string(),
    voice: z35.boolean().optional()
  })
});
var WhatsappButtonMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("button"),
  button: z35.object({
    payload: z35.string(),
    text: z35.string()
  })
});
var WhatsappDocumentMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("document"),
  document: z35.object({
    caption: z35.string().optional(),
    filename: z35.string(),
    mime_type: z35.string(),
    sha256: z35.string(),
    id: z35.string()
  })
});
var WhatsappImageMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("image"),
  image: z35.object({
    caption: z35.string().optional(),
    mime_type: z35.string(),
    sha256: z35.string(),
    id: z35.string()
  })
});
var WhatsappStickerMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("sticker"),
  sticker: z35.object({
    animated: z35.boolean(),
    mime_type: z35.string(),
    sha256: z35.string(),
    id: z35.string()
  })
});
var WhatsappSystemMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("system"),
  system: z35.object({
    body: z35.string(),
    // Describes the change to the customer's identity or phone number.
    identity: z35.string(),
    // Hash for the identity fetched from server.
    wa_id: z35.string().optional(),
    // New WhatsApp ID for the customer when their phone number is updated. Available on webhook versions v12.0 and later.
    type: z35.enum(["customer_changed_number", "customer_identity_changed"]),
    // Type of system update.
    customer: z35.string()
    // The WhatsApp ID for the customer prior to the update.
  })
});
var WhatsappVideoMessageSchema = WhatsappBaseMessageSchema.extend({
  type: z35.literal("video"),
  video: z35.object({
    caption: z35.string(),
    filename: z35.string(),
    mime_type: z35.string(),
    sha256: z35.string(),
    id: z35.string()
  })
});
var WhatsappMessageSchema = z35.discriminatedUnion("type", [
  WhatsappAudioMessageSchema,
  WhatsappButtonMessageSchema,
  WhatsappDocumentMessageSchema,
  WhatsappImageMessageSchema,
  WhatsappReactionMessageSchema,
  WhatsappStickerMessageSchema,
  WhatsappSystemMessageSchema,
  WhatsappTextMessageSchema,
  WhatsappVideoMessageSchema
]);
var whatsappMessageTypes = WhatsappMessageSchema.options.map((option) => option.shape.type.value);
var WhatsappMessageTypeSchema = z35.enum([.../* @__PURE__ */ new Set([...whatsappMessageTypes])]);
var WhatsappStatuses = z35.object({
  biz_opaque_callback_data: z35.string().optional(),
  conversation: z35.object({
    id: z35.string(),
    origin: z35.object({
      type: z35.string(),
      expiration_timestamp: z35.string().optional()
    })
  }),
  errors: z35.array(WhatsappErrorSchema).optional(),
  id: z35.string(),
  pricing: z35.object({
    category: z35.string(),
    pricing_model: z35.string()
  }),
  recipient_id: z35.string(),
  status: z35.enum(["delivered", "read", "sent"]),
  timestamp: z35.string().or(z35.number())
});
var WhatsappFieldBaseValueSchema = z35.object({
  messaging_product: z35.literal("whatsapp"),
  metadata: z35.object({
    display_phone_number: z35.string(),
    //'<BUSINESS_DISPLAY_PHONE_NUMBER>'
    phone_number_id: z35.string()
    // '<BUSINESS_PHONE_NUMBER_ID>',
  }),
  statuses: z35.array(WhatsappStatuses).optional(),
  errors: z35.array(WhatsappErrorSchema).optional()
});
var WhatsappFieldEchoesSchema = z35.object({
  value: WhatsappFieldBaseValueSchema.extend({
    message_echoes: z35.array(WhatsappMessageSchema).optional()
  }),
  field: z35.literal("smb_message_echoes")
});
var WhatsappFieldMessagesSchema = z35.object({
  value: WhatsappFieldBaseValueSchema.extend({
    contacts: z35.array(
      z35.object({
        profile: z35.object({
          name: z35.string()
          // '<WHATSAPP_USER_NAME>'
        }),
        wa_id: z35.string()
        //'<WHATSAPP_USER_ID>',
      })
    ).optional(),
    messages: z35.array(WhatsappMessageSchema).optional()
  }),
  field: z35.literal("messages")
});
var WhatsappFieldSmbAppStateSyncSchema = z35.object({
  value: WhatsappFieldBaseValueSchema.extend({
    state_sync: z35.array(
      z35.object({
        type: z35.literal("contact"),
        contact: z35.object({
          full_name: z35.string(),
          first_name: z35.string(),
          phone_number: z35.string()
        }),
        action: z35.string(),
        metadata: z35.object({
          timestamp: z35.string()
        })
      })
    )
  }),
  field: z35.literal("smb_app_state_sync")
});
var WhatsappFieldHistorySchema = z35.object({
  value: WhatsappFieldBaseValueSchema.extend({
    history: z35.array(
      z35.object({
        metadata: z35.object({
          phase: z35.number(),
          chunk_order: z35.number(),
          progress: z35.number()
        }),
        threads: z35.array(
          z35.object({
            id: z35.string(),
            messages: z35.array(
              WhatsappMessageSchema.and(
                z35.object({
                  history_context: z35.object({
                    status: z35.enum(["DELIVERED", "ERROR", "PENDING", "PLAYED", "READ", "SENT"])
                  })
                })
              )
            )
          })
        )
      })
    )
  }),
  field: z35.literal("history")
});
var WhatsappHistoryErrorSchema = z35.object({
  history: z35.array(
    z35.object({
      errors: z35.array(
        z35.object({
          code: z35.number(),
          title: z35.string(),
          message: z35.string(),
          error_data: z35.object({
            details: z35.string()
          })
        })
      )
    })
  )
});
var WhatsappMessageChangeSchema = z35.discriminatedUnion("field", [
  WhatsappFieldEchoesSchema,
  WhatsappFieldMessagesSchema,
  WhatsappFieldSmbAppStateSyncSchema,
  WhatsappFieldHistorySchema
]);
var WhatsappWebhookDtoSchema = z35.object({
  object: z35.literal("whatsapp_business_account"),
  entry: z35.array(
    z35.object({
      id: z35.string(),
      //'<WHATSAPP_BUSINESS_ACCOUNT_ID>',
      changes: z35.array(
        WhatsappMessageChangeSchema.or(WhatsappHistoryErrorSchema)
        //! History errors can't be discriminated. There's no "field" attribute
      ).min(1)
    })
  ).min(1)
});
var WhatsappGroupedWebhookUserDataSchema = z35.object({
  whatsappContactName: z35.string().optional(),
  whatsappUserId: z35.string().optional()
});
var WhatsappUserMessagesSchema = WhatsappGroupedWebhookUserDataSchema.extend({
  messages: z35.array(WhatsappMessageSchema)
});
var WhatsappGroupedWebhookIncomingMessagesByUserPhoneNumberSchema = z35.object({
  userPhoneNumbers: z35.record(z35.string(), WhatsappUserMessagesSchema)
});
var WhatsappGroupedWebhookEchoesMessagesByUserPhoneNumberSchema = z35.object({
  userPhoneNumbers: z35.record(
    z35.string(),
    WhatsappUserMessagesSchema.extend({
      echoesPhoneNumber: z35.string()
    })
  )
});
var WhatsappBusinessPhoneDataSchema = z35.object({
  incomingMessages: WhatsappGroupedWebhookIncomingMessagesByUserPhoneNumberSchema.optional(),
  echoesMessages: WhatsappGroupedWebhookEchoesMessagesByUserPhoneNumberSchema.optional(),
  contactsSync: z35.array(z35.lazy(() => WhatsappFieldSmbAppStateSyncSchema.shape.value.shape.state_sync.element)).optional(),
  historyMessages: z35.array(z35.lazy(() => WhatsappFieldHistorySchema.shape.value.shape.history.element)).optional(),
  //! Uses z.lazy() for recursive schema references
  historyErrors: z35.array(z35.lazy(() => WhatsappHistoryErrorSchema.shape.history.element)).optional()
  //! Uses z.lazy() for recursive schema references
});
var WhatsappGroupedWebhookDataSchema = z35.object({
  businessAccountIds: z35.record(
    z35.string(),
    z35.object({
      businessPhoneNumberIds: z35.record(z35.string(), WhatsappBusinessPhoneDataSchema)
    })
  )
});

// src/dtos/chat-conversation/create-chat-conversation.dto.ts
var IncomingMessagesSchema = z36.union([
  z36.array(WhatsappMessageSchema),
  z36.array(MessengerFacebookPagesMessageSchema),
  z36.array(InstagramMessagingSchema),
  z36.array(ConversationMessageDtoSchema)
]);

// src/dtos/chat-conversation/find-or-create-chat-conversation.dto.ts
import z38 from "zod";

// src/dtos/contact/contact-dto.ts
import z37 from "zod";
var ChatContactCustomFieldsSchema = z37.record(z37.string()).nullable();
var ChatContactMetadataSchema = z37.object({
  instagram: z37.object({
    profilePicture: z37.string().nullable().optional(),
    instagramAccounts: z37.record(
      z37.string(),
      z37.object({
        instagramBusinessScopedId: z37.string().nullable().optional()
      })
    ).optional()
  }).optional(),
  facebook: z37.object({
    profilePicture: z37.string().nullable().optional(),
    pages: z37.record(
      z37.string(),
      z37.object({
        psid: z37.string().nullable().optional()
      })
    ).optional()
  }).optional()
});
var ConversationChatbotKeySchema = z37.string().max(128);
var ChatContactSchema = z37.object({
  id: z37.string().uuid(),
  created_at: z37.string(),
  updated_at: z37.string().nullable(),
  key: ConversationChatbotKeySchema,
  customer_id: z37.string().uuid(),
  email: z37.string().email().nullable(),
  name: z37.string().nullable(),
  phone: z37.string().nullable(),
  location: z37.string().nullable(),
  source: z37.enum(["MANUAL", "AUTO_WHATSAPP", "AUTO_WEB", "AUTO_FACEBOOK", "AUTO_INSTAGRAM", "UNKNOWN"]).default("UNKNOWN"),
  facebook_user: z37.string().nullable(),
  instagram_user: z37.string().nullable(),
  whatsapp_phone: z37.string().nullable(),
  metadata: ChatContactMetadataSchema.nullable(),
  custom_fields: ChatContactCustomFieldsSchema
});
var CreateContactDtoSchema = z37.object({
  key: ConversationChatbotKeySchema,
  email: z37.string().email().nullable().optional(),
  name: z37.string().nullable().optional(),
  phone: z37.string().min(6, { message: "El campo debe tener como m\xEDnimo 6 caracteres" }).max(40, { message: "El campo debe tener como m\xE1ximo 40 caracteres" }).nullable().optional(),
  location: z37.string().min(2, { message: "El campo debe tener como m\xEDnimo 2 caracteres" }).nullable().optional(),
  source: z37.enum(["MANUAL", "AUTO_WHATSAPP", "AUTO_WEB", "AUTO_FACEBOOK", "AUTO_INSTAGRAM", "UNKNOWN"]).default("UNKNOWN"),
  facebook_user: z37.string().nullable().optional(),
  instagram_user: z37.string().nullable().optional(),
  whatsapp_phone: z37.string().min(6, { message: "El campo debe tener como m\xEDnimo 6 caracteres" }).max(40, { message: "El campo debe tener como m\xE1ximo 40 caracteres" }).nullable().optional(),
  metadata: ChatContactMetadataSchema.nullable().optional(),
  custom_fields: ChatContactCustomFieldsSchema.optional().nullable()
});
var CreateContactFromDashboardDtoSchema = CreateContactDtoSchema.omit({ key: true, source: true }).superRefine(
  (data, ctx) => {
    if (!data.name) {
      ctx.addIssue({
        code: z37.ZodIssueCode.custom,
        message: "El nombre es un campo obligatorio",
        path: ["name"]
      });
    }
    if (!data.phone && !data.email) {
      ctx.addIssue({
        code: z37.ZodIssueCode.custom,
        message: "Al menos un campo de contacto debe ser proporcionado",
        path: ["phone"]
      });
      ctx.addIssue({
        code: z37.ZodIssueCode.custom,
        message: "Al menos un campo de contacto debe ser proporcionado",
        path: ["email"]
      });
    }
  }
);
var UpdateContactFromDashboardDtoSchema = CreateContactDtoSchema;

// src/dtos/chat-conversation/find-or-create-chat-conversation.dto.ts
var FindOrCreateChatConversationDtoSchema = z38.object({
  initialMessages: z38.array(ConversationMessageDtoSchema).optional(),
  conversationKey: z38.string().optional(),
  originUrl: z38.string().optional(),
  channel: ChatConversationChannelSchema.optional(),
  contactKey: ConversationChatbotKeySchema.nullable().optional()
});

// src/dtos/chat-conversation/receive-chat-conversation-messages.dto.ts
import z39 from "zod";
var ChatbotWebContextSchema = z39.object({
  user: z39.object({
    id: z39.string().or(z39.number()).optional(),
    email: z39.string().optional(),
    userName: z39.string().optional(),
    realName: z39.string().optional()
  }).optional(),
  realEstate: z39.object({
    propertyId: z39.string().optional().nullable(),
    developmentId: z39.string().optional().nullable(),
    city: z39.string().optional().nullable(),
    state: z39.string().optional().nullable(),
    postalCode: z39.string().optional().nullable(),
    lat: z39.string().optional().nullable(),
    lng: z39.string().optional().nullable(),
    street: z39.string().optional().nullable(),
    unit: z39.string().optional().nullable()
  }).optional()
});
var ReceiveChatConversationMessagesDtoSchema = z39.object({
  // 24 pairs of messages + open conversation message
  //! TODO: Allow longer conversations
  messages: z39.array(ConversationMessageDtoSchema).max(50),
  context: ChatbotWebContextSchema.optional()
});

// src/dtos/web-contact-message/create-web-contact-message.dto.ts
import z40 from "zod";
var CreateWebContactMessageDtoSchema = z40.object({
  user_name: z40.string({ required_error: "El valor es obligatorio" }).min(2, { message: "Tienes que ingresar al menos 2 caracteres" }).max(50, { message: "No puedes ingresar m\xE1s de 50 caracteres" }),
  user_email: EmailSchema,
  subject: z40.string({ required_error: "El valor es obligatorio" }).min(2, { message: "Tienes que ingresar al menos 2 caracteres" }).max(50, { message: "No puedes ingresar m\xE1s de 50 caracteres" }),
  message: z40.string({ required_error: "El valor es obligatorio" }).min(10, { message: "Tienes que ingresar al menos 10 caracteres" }).max(500, { message: "No puedes ingresar m\xE1s de 500 caracteres" })
}).merge(GoogleRecaptachaSchema);

// src/dtos/web-newsletter-signup/create-web-newsletter-signup.dto.ts
import z41 from "zod";
var CreateWebNewsletterSignUpDtoSchema = z41.object({
  email: EmailSchema
}).merge(GoogleRecaptachaSchema);

// src/dtos/communication-platforms/common.ts
import z42 from "zod";
var FacebookLoginCompleteEmbeddedSignupProcessDtoSchema = z42.object({
  code: z42.string()
});
var FacebookLoginSaveEmbeddedSignupProgressDtoSchema = z42.object({
  history: z42.array(
    z42.object({
      data: zJsonSchema()
      // We're not sure what this payload can contain
    })
  )
});

// src/dtos/communication-platforms/instagram.ts
import z43 from "zod";
var InstagramGraphApiGetOauthAccessTokenSuccessResponseSchema = z43.object({
  access_token: z43.string(),
  user_id: z43.string(),
  permissions: z43.string()
});
var InstagramGraphApiGetOauthAccessTokenErrorSchema = z43.object({
  error_type: z43.string(),
  code: z43.number().or(z43.string()),
  error_message: z43.string()
});
var InstagramLoginCompleteSignupProcessDtoSchema = z43.object({
  code: z43.string(),
  redirectUrl: z43.string().url()
});
var InstagramGraphApiErrorSchema = z43.object({
  error: z43.object({
    message: z43.string(),
    type: z43.string(),
    code: z43.number().or(z43.string()),
    error_subcode: z43.number().or(z43.string()).optional(),
    is_transient: z43.boolean().optional(),
    error_user_title: z43.string().optional(),
    error_user_msg: z43.string().optional(),
    fbtrace_id: z43.string()
  })
});
var SanitizedCustomerCommunicationPlatformInstagramSchema = z43.object({
  created_at: z43.string().or(z43.date()),
  customer_id: z43.string(),
  id: z43.string(),
  signup_progress: zJsonSchema(),
  registered_instagram_accounts: z43.array(
    z43.object({
      account_id: z43.string(),
      account_app_scoped_user_id: z43.string()
    })
  ).default([])
});
var ExtendedCustomerCommunicationPlatformInstagramSchema = z43.object({
  platform: SanitizedCustomerCommunicationPlatformInstagramSchema,
  instagramAccountChatbotAssignments: z43.array(
    z43.object({
      instagramAccountId: z43.string(),
      instagramAccountAppScopedUserId: z43.string(),
      instagramAccountName: z43.string(),
      instagramAccountUserName: z43.string(),
      instagramAccountLink: z43.string(),
      instagramAccountIsConnected: z43.boolean(),
      chatbotId: z43.string().nullable(),
      chatbotName: z43.string().nullable()
    })
  )
});

// src/dtos/communication-platforms/messenger-facebook-pages.ts
import z44 from "zod";
var SanitizedCustomerCommunicationPlatformMessengerFacebookPagesSchema = z44.object({
  created_at: z44.string().or(z44.date()),
  customer_id: z44.string(),
  id: z44.string(),
  business_scoped_system_user_id: z44.string().nullable(),
  embedded_signup_progress: zJsonSchema(),
  registered_facebook_pages: z44.array(
    z44.object({
      page_id: z44.string(),
      page_access_token: z44.string().nullable()
    })
  ).default([])
});
var ExtendedCustomerCommunicationPlatformMessengerFacebookPagesSchema = z44.object({
  platform: SanitizedCustomerCommunicationPlatformMessengerFacebookPagesSchema,
  facebookBusinesses: z44.array(
    z44.object({
      facebookBusinessId: z44.string(),
      facebookBusinessName: z44.string()
    })
  ),
  facebookPageAssignments: z44.array(
    z44.object({
      facebookPageId: z44.string(),
      facebookPageName: z44.string(),
      facebookPageLink: z44.string(),
      facebookPageIsConnected: z44.boolean(),
      facebookBusinessId: z44.string(),
      facebookBusinessName: z44.string(),
      chatbotId: z44.string().nullable(),
      chatbotName: z44.string().nullable()
    })
  )
});

// src/dtos/communication-platforms/whatsapp.ts
import { z as z46 } from "zod";

// src/dtos/external/meta/meta-graph-api.dto.ts
import z45 from "zod";
var MetaGraphApiPaginationSchema = z45.object({
  paging: z45.object({
    cursors: z45.object({
      before: z45.string().nullable(),
      after: z45.string().nullable()
    }),
    previous: z45.string().optional(),
    next: z45.string().optional()
  })
});
var MetaGraphApiErrorSchema = z45.object({
  error: z45.object({
    message: z45.string(),
    type: z45.string(),
    code: z45.number(),
    fbtrace_id: z45.string(),
    error_subcode: z45.number().optional()
  })
});
var MetaGraphApiGetOauthAccessTokenSuccessResponseSchema = z45.object({
  access_token: z45.string(),
  token_type: z45.string(),
  expires_in: z45.number()
});
var MetaGraphApiRefreshAccessTokenSuccessResponseSchema = z45.object({
  access_token: z45.string(),
  token_type: z45.string()
});
var MetaGraphApiDebugTokenSuccessResponseSchema = z45.object({
  data: z45.object({
    app_id: z45.string(),
    type: z45.string(),
    application: z45.string(),
    data_access_expires_at: z45.number(),
    expires_at: z45.number(),
    is_valid: z45.boolean(),
    issued_at: z45.number(),
    scopes: z45.array(z45.string()),
    granular_scopes: z45.array(
      z45.object({
        scope: z45.string(),
        target_ids: z45.array(z45.string())
      })
    ),
    user_id: z45.string()
  })
});
var MetaGraphApiDebugTokenErrorSchema = z45.object({
  data: z45.object({
    error: z45.object({
      code: z45.number(),
      message: z45.string()
    }),
    is_valid: z45.boolean(),
    scopes: z45.array(zJsonSchema())
  })
});
var MetaGraphApiGetWhatsappBusinessAccountSuccessResponseSchema = z45.object({
  id: z45.string(),
  name: z45.string(),
  currency: z45.string(),
  timezone_id: z45.string(),
  message_template_namespace: z45.string(),
  on_behalf_of_business: z45.object({
    name: z45.string(),
    id: z45.string(),
    status: z45.string(),
    type: z45.string()
  }).optional()
});
var MetaGraphApiGetWhatsappBusinessAccountPhoneNumberSuccessResponseSchema = z45.object({
  id: z45.string(),
  certificate: z45.string().optional(),
  code_verification_status: z45.enum(["NOT_VERIFIED", "VERIFIED", "EXPIRED"]),
  conversational_automation: z45.any().optional(),
  display_phone_number: z45.string(),
  eligibility_for_api_business_global_search: z45.any().optional(),
  health_status: z45.any().optional(),
  is_official_business_account: z45.boolean().optional(),
  is_on_biz_app: z45.boolean().optional(),
  is_pin_enabled: z45.boolean().optional(),
  is_preverified_number: z45.boolean().optional(),
  last_onboarded_time: z45.string(),
  messaging_limit_tier: z45.enum(["TIER_50", "TIER_250", "TIER_1K", "TIER_10K", "TIER_100K", "TIER_UNLIMITED"]).optional(),
  name_status: z45.string().optional(),
  new_certificate: z45.string().optional(),
  new_name_status: z45.string().optional(),
  platform_type: z45.enum(["CLOUD_API", "ON_PREMISE", "NOT_APPLICABLE"]),
  // If NOT_APPLICABLE, the number is not registered with Cloud API or On-Premises API.
  quality_score: z45.any().optional(),
  quality_rating: z45.string(),
  search_visibility: z45.string().optional(),
  status: z45.string().optional(),
  throughput: z45.object({
    level: z45.enum(["STANDARD", " HIGH", "NOT_APPLICABLE"])
  }),
  verified_name: z45.string(),
  webhook_configuration: z45.object({
    application: z45.string()
  })
});
var MetaGraphApiGetWhatsappBusinessAccountPhoneNumberListSuccessResponseSchema = MetaGraphApiPaginationSchema.extend({
  data: z45.array(MetaGraphApiGetWhatsappBusinessAccountPhoneNumberSuccessResponseSchema)
});
var MetaGraphApiWhatsappBusinessPhoneSendMessageResponseSchema = z45.object({
  messaging_product: z45.literal("whatsapp"),
  contacts: z45.array(z45.object({ input: z45.string(), wa_id: z45.string() })),
  messages: z45.array(z45.object({ id: z45.string() }))
});
var MetaGraphApiGetAssociatedFacebookPageSchema = z45.object({
  access_token: z45.string(),
  category: z45.string(),
  category_list: z45.array(z45.object({ id: z45.string(), name: z45.string() })),
  name: z45.string(),
  id: z45.string(),
  tasks: z45.array(z45.string()),
  is_messenger_platform_bot: z45.boolean(),
  is_webhooks_subscribed: z45.boolean(),
  link: z45.string(),
  business: z45.object({
    id: z45.string(),
    name: z45.string()
  })
});
var MetaGraphApiGetUserIdsForAppsSchema = z45.object({
  id: z45.string(),
  app: z45.object({
    link: z45.string(),
    name: z45.string(),
    id: z45.string()
  })
});

// src/dtos/communication-platforms/whatsapp.ts
var WhatsappRegisterPhoneNumberIdDtoSchema = z46.object({
  whatsappPhoneNumberId: z46.string()
});
var WhatsappUnRegisterPhoneNumberIdDtoSchema = z46.object({
  whatsappPhoneNumberId: z46.string()
});
var WhatsappPlatformBusinessPhoneNumbersSchema = MetaGraphApiGetWhatsappBusinessAccountPhoneNumberListSuccessResponseSchema.shape.data.element;
var SanitizedCustomerCommunicationPlatformWhatsappSchema = z46.object({
  created_at: z46.string().or(z46.date()),
  customer_id: z46.string(),
  id: z46.string(),
  whatsapp_business_account_id: z46.string().nullable(),
  whatsapp_embedded_signup_progress: zJsonSchema(),
  registered_phones: z46.array(
    z46.object({
      whatsapp_phone_id: z46.string()
    })
  )
});
var ExtendedCustomerCommunicationPlatformWhatsappSchema = z46.object({
  platform: SanitizedCustomerCommunicationPlatformWhatsappSchema,
  metaWhatsappAccount: z46.object({ id: z46.string(), profileName: z46.string() }).nullable(),
  metaWhatsappPhones: z46.array(WhatsappPlatformBusinessPhoneNumbersSchema),
  phoneChatbotAssignments: z46.array(
    z46.object({
      whatsappPhoneNumber: z46.string(),
      whatsappPhoneNumberId: z46.string(),
      chatbotId: z46.string().nullable(),
      chatbotName: z46.string().nullable()
    })
  )
});

// src/dtos/customer-dashboard/account/update-account-email.dto.ts
import z47 from "zod";
var CustomerDashboardUpdateAccountEmailDtoSchema = z47.object({
  newEmail: EmailSchema,
  confirmNewEmail: EmailSchema
}).refine((data) => data.newEmail === data.confirmNewEmail, {
  message: "Las emails deben coincidir",
  path: ["confirmNewEmail"]
  // This is the field that will get the error message
});

// src/dtos/customer-dashboard/account/update-account-password.dto.ts
import z48 from "zod";
var CustomerDashboardUpdateAccountPasswordDtoSchema = z48.object({
  newPassword: PasswordSchema,
  confirmNewPassword: PasswordSchema
}).refine((data) => data.newPassword === data.confirmNewPassword, {
  message: "Las contrase\xF1as deben coincidir",
  path: ["confirmNewPassword"]
  // This is the field that will get the error message
});

// src/dtos/conversations/assign-contact-dto.ts
import z49 from "zod";
var AssignContactToConversationDtoSchema = z49.object({
  conversationId: z49.string().uuid(),
  contactId: z49.string().uuid(),
  reassignAllConversations: IsEnabledSwitchSchema
});

// src/dtos/customer-dashboard/chatbot/conversation-tags/manage-customer-conversation-tags.dto.ts
import { z as z50 } from "zod";
var CustomerDashboardUpsertConversationTagDtoSchema = z50.object({
  tagText: z50.string().trim().min(1)
});
var sortableFields = ["id", "created_at", "tag_text", "updated_at"];
var CustomerDashboardFindManyConversationTagsDtoSchema = PaginatedEntityListDtoSchema.merge(
  z50.object({
    orderBy: z50.enum(sortableFields).default("created_at"),
    search: z50.string().trim().min(1).optional()
  })
);

// src/dtos/customer-dashboard/user-invite/create-user-invite.dto.ts
import z52 from "zod";

// src/types/auth/user-role.ts
import z51 from "zod";
var USER_SYSTEM_ROLES = ["admin", "user", "test", "endion_customer_support"];
var APP_USER_ROLES = {
  admin: "admin",
  user: "user",
  test: "test",
  endion_customer_support: "endion_customer_support"
};
var AppUserRoleSchema = z51.enum(USER_SYSTEM_ROLES, { required_error: "El valor es requerido" });

// src/dtos/customer-dashboard/user-invite/create-user-invite.dto.ts
var USER_INVITE_ROLES = USER_SYSTEM_ROLES.filter((role) => role !== "endion_customer_support");
var AppUserInviteRoleSchema = z52.enum(USER_INVITE_ROLES);
var CreateUserInviteDtoSchema = z52.object({
  email: EmailSchema,
  userRoleId: z52.string().uuid()
});

// src/dtos/customer-dashboard/user-invite/confirm-user-invite.dto.ts
import z53 from "zod";
var ConfirmUserInviteDtoSchema = z53.object({
  name: z53.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  lastName: z53.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  password: PasswordSchema,
  passwordRepeat: PasswordSchema
}).refine((data) => data.password === data.passwordRepeat, {
  message: "Las contrase\xF1as deben coincidir",
  path: ["passwordRepeat"]
});

// src/dtos/customer-dashboard/auth/auth.dto.ts
import z54 from "zod";
var LoginUserDtoSchema = z54.object({
  email: EmailSchema,
  password: PasswordSchema
}).merge(GoogleRecaptachaSchema);
var AllowedVerticalsForSignup = [
  VerticalSchema.Values.REAL_ESTATE,
  VerticalSchema.Values.RETAIL,
  VerticalSchema.Values.HOTEL,
  VerticalSchema.Values.UNASSIGNED
];
var VerticalSchemaForSignup = z54.enum(AllowedVerticalsForSignup);
var CreateCustomerDtoSchema = z54.object({
  name: z54.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  lastName: z54.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  companyName: z54.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  email: EmailSchema,
  password: PasswordSchema,
  passwordRepeat: PasswordSchema,
  vertical: VerticalSchemaForSignup,
  location: LocationSchema,
  additionalInfo: z54.string().max(500, { message: "Escribe un m\xE1ximo de 500 caracteres" }).optional()
}).refine((data) => data.password === data.passwordRepeat, {
  message: "Las contrase\xF1as deben coincidir",
  path: ["passwordRepeat"]
});
var CreateUserDtoSchema = z54.object({
  //! TODO: Remove
  user_id: z54.string().uuid()
});
var ResetPasswordDtoSchema = z54.object({
  email: EmailSchema
});
var UpdatePasswordDtoSchema = CustomerDashboardUpdateAccountPasswordDtoSchema;
var SignUpUserSuccessResponseSchema = z54.object({
  success: z54.boolean()
});

// src/dtos/customer-dashboard/customer-chatbot/create-customer-chatbot.dto.ts
import z55 from "zod";
var CreateCustomerChatbotDtoSchema = z55.object({
  name: z55.string(),
  configuration: z55.record(z55.string(), z55.any()),
  key: z55.string(),
  vertical: VerticalSchema,
  lead_field_profile_id: z55.string().uuid().nullable(),
  active: z55.boolean()
});
var CopyCustomerChatbotDtoSchema = z55.object({
  name: z55.string({ required_error: "El valor es requerido" }).min(2, { message: "El m\xEDnimo de caracteres permitiros es de 2" }).max(50, { message: "El m\xE1ximo de caracteres permitidos es de 50" }),
  // this key will be used to copy the configuration from the selected chatbot
  customer_chatbot_key_to_copy_config: z55.string({ required_error: "El valor es requerido" }).max(64, { message: "El m\xE1ximo de caracteres permitidos es de 64" })
});

// src/dtos/customer-dashboard/customer-chatbot/create-customer-chatbot-from-customer-signup-wizard.dto.ts
import z56 from "zod";
var CreateCustomerChatbotFromCustomerSignupWizardDtoSchema = z56.object({
  // From step1
  vertical: VerticalSchemaForSignup,
  // From step2
  chatbotName: z56.string().min(1, "El nombre del chatbot es requerido").max(100, "El nombre del chatbot debe tener menos de 100 caracteres"),
  integrationData: CreateCustomerIntegrationDtoSchema,
  customerIntegrationFriendlyName: z56.string().min(1, "El nombre de la integraci\xF3n es requerido").max(100, "El nombre de la integraci\xF3n debe tener menos de 100 caracteres"),
  // From step3
  companyName: z56.string().min(1, "El nombre de la empresa es requerido").max(100, "El nombre de la empresa debe tener menos de 100 caracteres"),
  companyWebsite: RelaxedUrlSchema,
  primaryColor: z56.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Ingres\xE1 un color hexadecimal v\xE1lido"),
  initialMessage: z56.string().min(1, "El mensaje inicial es requerido").max(200, "El mensaje inicial debe tener menos de 200 caracteres")
});

// src/dtos/customer-dashboard/customer-chatbot/edit-customer-chatbot.dto.ts
import z64 from "zod";

// src/dtos/customer-dashboard/customer-chatbot/behavior-config.dto.ts
import z57 from "zod";
var EditChatbotBehaviorConfigDtoSchema = z57.object({
  leadFieldProfileId: z57.string().uuid().optional().nullable(),
  companyName: z57.string({ message: "El valor es requerido" }).min(2, { message: "El m\xEDnimo de caracteres permitidos es de 2" }).max(50, { message: "El m\xE1ximo de caracteres permitidos es de 50" }),
  companyDescription: z57.string().max(800, { message: "El m\xE1ximo de caracteres permitidos es de 800" }).optional().nullable(),
  conversationTone: z57.string().max(700, { message: "El m\xE1ximo de caracteres permitidos es de 700" }).optional().nullable(),
  reinforcedInstructions: z57.string().max(800, { message: "El m\xE1ximo de caracteres permitidos es de 800" }).optional().nullable(),
  phoneNumber: z57.string().max(20, { message: "El maximo de caracteres es de 20" }).optional().nullable(),
  homeUrl: BaseCustomerChatbotConfigurationSchema.shape.homeUrl
});

// src/dtos/customer-dashboard/customer-chatbot/channels.dto.ts
import z58 from "zod";
var IsEnabledSwitchSchema2 = z58.coerce.boolean();
var EditChatbotWebDtoSchema = z58.object({
  isEnabled: IsEnabledSwitchSchema2,
  allowedDomains: BaseCustomerChatbotConfigurationSchema.shape.channels.shape.web.shape.allowedDomains
});
var EditChatbotWhatsappDtoSchema = z58.preprocess(
  (val) => {
    if (val === void 0 || val !== null && typeof val === "object" && "isEnabled" in val && val.isEnabled === false)
      return {
        isEnabled: false,
        phoneNumberId: null,
        allowedSenders: void 0,
        blockedSenders: void 0,
        phoneFilterMode: "none",
        markIncomingMessagesAsRead: false
      };
    return val;
  },
  BaseCustomerChatbotConfigurationSchema.shape.channels.shape.whatsapp.extend({
    phoneFilterMode: z58.enum(["none", "whitelist", "blacklist"]).default("none"),
    markIncomingMessagesAsRead: IsEnabledSwitchSchema2
  }).refine(
    (val) => {
      return !(val == null ? void 0 : val.isEnabled) || (val == null ? void 0 : val.phoneNumberId) && (val == null ? void 0 : val.phoneNumberId.length) > 0;
    },
    { message: "A phone number ID is required", path: ["phoneNumberId"] }
  ).refine(
    (val) => {
      const hasAllowedSenders = (val == null ? void 0 : val.allowedSenders) && val.allowedSenders.length > 0;
      const hasBlockedSenders = (val == null ? void 0 : val.blockedSenders) && val.blockedSenders.length > 0;
      return !(hasAllowedSenders && hasBlockedSenders);
    },
    {
      message: "You have to choose to use either a whitelist or a blacklist",
      path: ["allowedSenders"]
    }
  )
).default({
  isEnabled: false,
  phoneNumberId: null,
  allowedSenders: void 0,
  blockedSenders: void 0,
  phoneFilterMode: "none",
  markIncomingMessagesAsRead: true
});
var EditChatbotInstagramDtoSchema = z58.preprocess(
  (val) => {
    if (val === void 0 || val !== null && typeof val === "object" && "isEnabled" in val && val.isEnabled === false)
      return { isEnabled: false, instagramAccountId: null };
    return val;
  },
  BaseCustomerChatbotConfigurationSchema.shape.channels.shape.instagram.refine(
    (val) => {
      return !(val == null ? void 0 : val.isEnabled) || (val == null ? void 0 : val.instagramAccountId) && (val == null ? void 0 : val.instagramAccountId.length) > 0;
    },
    { message: "An Instagram Account ID is required", path: ["instagramAccountId"] }
  )
).default({ isEnabled: false, instagramAccountId: null });
var EditChatbotMessengerDtoSchema = z58.preprocess(
  (val) => {
    if (val === void 0 || val !== null && typeof val === "object" && "isEnabled" in val && val.isEnabled === false)
      return { isEnabled: false, facebookPageId: null, markIncomingMessagesAsRead: false };
    return val;
  },
  BaseCustomerChatbotConfigurationSchema.shape.channels.shape.messengerFacebookPages.extend({
    markIncomingMessagesAsRead: IsEnabledSwitchSchema2
  }).refine(
    (val) => {
      return !(val == null ? void 0 : val.isEnabled) || (val == null ? void 0 : val.facebookPageId) && (val == null ? void 0 : val.facebookPageId.length) > 0;
    },
    { message: "A Facebook Page ID is required", path: ["facebookPageId"] }
  )
).default({ isEnabled: false, facebookPageId: null, markIncomingMessagesAsRead: true });
var EditChannelsConfigDtoSchema = z58.object({
  channels: z58.object({
    web: EditChatbotWebDtoSchema,
    whatsapp: EditChatbotWhatsappDtoSchema,
    instagram: EditChatbotInstagramDtoSchema,
    messengerFacebookPages: EditChatbotMessengerDtoSchema
  })
});

// src/dtos/customer-dashboard/customer-chatbot/initial-message.dto.ts
import z59 from "zod";
var EditChatbotInitialMessagesDtoSchema = z59.object({
  initialMessages: InitialMessageSchema
});

// src/dtos/customer-dashboard/customer-chatbot/real-estate/agents-config.dto.ts
import z60 from "zod";
var EditRealEstateAgentsDtoSchema = z60.object({
  agents: z60.object({
    [PROPERTY_DETAILS_AGENT_NAME]: z60.object({
      isEnabled: IsEnabledSwitchSchema,
      propertyPromptFields: z60.object({
        description: z60.object({
          enabled: IsEnabledSwitchSchema
        })
      })
    }),
    [PROPERTY_SEARCH_AGENT_NAME]: z60.object({
      isEnabled: IsEnabledSwitchSchema,
      rentEnabled: IsEnabledSwitchSchema,
      saleEnabled: IsEnabledSwitchSchema,
      propertyExchangeEnabled: IsEnabledSwitchSchema.optional(),
      searchConfiguration: z60.object({
        allowedLocationGroups: z60.array(z60.string()).optional()
      }).optional()
    }).superRefine((data, ctx) => {
      var _a;
      if (data.isEnabled) {
        if (!((_a = data.searchConfiguration) == null ? void 0 : _a.allowedLocationGroups) || data.searchConfiguration.allowedLocationGroups.length === 0) {
          ctx.addIssue({
            code: z60.ZodIssueCode.custom,
            message: "Array must contain at least 1 element(s)",
            path: ["searchConfiguration", "allowedLocationGroups"]
          });
        }
      }
    }),
    [PROPERTY_APPRAISAL_AGENT_NAME]: z60.object({
      isEnabled: IsEnabledSwitchSchema
    })
  })
});

// src/dtos/customer-dashboard/customer-chatbot/real-estate/basic-config.dto.ts
import z62 from "zod";

// src/utils/checkbox-input-schema.ts
import z61 from "zod";
var CheckboxInputSchema = z61.coerce.boolean();

// src/dtos/customer-dashboard/customer-chatbot/real-estate/basic-config.dto.ts
var EditChatbotBasicConfigDtoSchema = z62.object({
  name: z62.string({ required_error: "El valor es requerido" }).min(2, { message: "El m\xEDnimo de caracteres permitidos es de 2" }).max(50, { message: "El m\xE1ximo de caracteres permitidos es de 50" }),
  active: CheckboxInputSchema,
  customerIntegrationId: z62.string().uuid().nullable()
});

// src/dtos/customer-dashboard/customer-chatbot/style-config.dto.ts
import z63 from "zod";
var EditChatbotStyleDtoSchema = z63.object({
  style: z63.object({
    primaryColor: z63.string().regex(/^#(?:[0-9A-F]{3}){1,2}$/i, { message: "Debe ser un color hex valido" }),
    zIndex: z63.preprocess(preprocessStringToNumber, ZIndexSchema),
    position: z63.object({
      bottom: z63.preprocess(preprocessStringToNumber, PositionValueSchema),
      right: z63.preprocess(preprocessStringToNumber, PositionValueSchema)
    })
  })
});

// src/dtos/customer-dashboard/customer-chatbot/edit-customer-chatbot.dto.ts
var REAL_ESTATE_CHATBOT_CONFIG_SECTION_QUERY_STRING_KEY = "config-section";
var REAL_ESTATE_CHATBOT_CONFIG_SECTIONS = [
  "basic",
  "behavior",
  "style",
  "channels",
  "initial-messages",
  "agents"
];
var CHATBOT_CONFIG_SECTION_SCHEMA_MAP = {
  basic: EditChatbotBasicConfigDtoSchema,
  behavior: EditChatbotBehaviorConfigDtoSchema,
  "initial-messages": EditChatbotInitialMessagesDtoSchema,
  style: EditChatbotStyleDtoSchema,
  agents: EditRealEstateAgentsDtoSchema,
  channels: EditChannelsConfigDtoSchema
};
var UpdateCustomerChatbotConfigurationDtoSchema = z64.object({
  configuration: z64.string()
});
var VERTICAL_CUSTOMER_CHATBOT_SCHEMA_MAP = {
  UNASSIGNED: BaseCustomerChatbotConfigurationSchema,
  REAL_ESTATE: RealEstateCustomerChatbotConfigurationSchema,
  RETAIL: BaseCustomerChatbotConfigurationSchema,
  HOTEL: BaseCustomerChatbotConfigurationSchema,
  CUSTOM_BOLSA_COMERCIO_ROSARIO: BaseCustomerChatbotConfigurationSchema
};

// src/dtos/customer-dashboard/customer-integrations/customer-integrations.dto.ts
import z69 from "zod";

// src/types/integrations/full-integration-configuration.type.ts
import z68 from "zod";

// src/types/integrations/base-integration-configuration.type.ts
import z65 from "zod";
var BaseIntegrationRealEstateDemoConfigurationSchema = z65.object({});
var BaseIntegrationRealEstateCustomVanziniAuthenticationSchema = IntegrationApiKeyAuthenticationSchema.extend({
  credentials: z65.object({
    headers: z65.object({
      Authorization: z65.string()
    })
  })
});
var BaseIntegrationRealEstateCustomVanziniConfigurationSchema = z65.object({
  apiUrl: z65.string(),
  authentication: BaseIntegrationRealEstateCustomVanziniAuthenticationSchema
});
var BaseIntegrationRealEstateTokkoBrokerConfigurationSchema = z65.object({
  apiUrl: z65.string()
});
var BaseIntegrationRealEstateMainConfigurationSchema = z65.object({});
var BaseIntegrationRetailTiendaNubeConfigurationSchema = z65.object({});
var BaseIntegrationRetailWooCommerceConfigurationSchema = z65.object({});
var BaseIntegrationRetailM3CConfigurationSchema = z65.object({});
var BaseIntegrationCustomBolsaComercioRosarioConfigurationSchema = z65.object({
  apiUrl: z65.string(),
  authenticationSteps: z65.tuple([
    IntegrationHmacSignedPayloadAuthenticationSchema,
    IntegrationPayloadEncryptionAuthenticationSchema
  ])
});
var BaseIntegrationGoogleAnalyticsConfigurationSchema = z65.object({});

// src/types/integrations/customer-integration-configuration.type.ts
import z66 from "zod";
var CustomerIntegrationRealEstateDemoConfigurationSchema = z66.object({});
var CustomerIntegrationRealEstateCustomVanziniConfigurationSchema = z66.object({});
var CustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema = IntegrationApiKeyAuthenticationSchema.extend({
  credentials: z66.object({
    queryParams: z66.object({
      key: z66.string()
    })
  })
});
var CustomerIntegrationRealEstateTokkoBrokerConfigurationSchema = z66.object({
  authentication: CustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema
});
var CustomerIntegrationRealEstateMainConfigurationSchema = z66.object({});
var CustomerIntegrationRetailTiendaNubeConfigurationSchema = z66.object({
  apiUrl: z66.string(),
  authentication: IntegrationApiKeyAuthenticationSchema
});
var CustomerIntegrationRetailWooCommerceConfigurationSchema = z66.object({
  apiUrl: z66.string(),
  authentication: IntegrationApiKeyAuthenticationSchema
});
var CustomerIntegrationRetailM3CConfigurationSchema = z66.object({
  apiUrl: z66.string(),
  authentication: z66.object({
    type: z66.literal("CUSTOM"),
    credentials: z66.object({
      username: z66.string(),
      password: z66.string(),
      token: z66.string().optional(),
      // Token is obtained with the user/pass
      refreshToken: z66.string().optional(),
      // Refresh token is obtained with the user pass
      expiresAt: z66.string().datetime().optional()
      // Valid until is obtained with the user pass
    })
  })
});
var CustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema = z66.object({});
var CustomerIntegrationGoogleAnalyticsConfigurationSchema = z66.object({
  authentication: IntegrationApiKeyAuthenticationSchema
});

// src/types/integrations/integration-names.type.ts
import z67 from "zod";
var INTEGRATION_NAME = {
  REAL_ESTATE_DEMO: "REAL_ESTATE_DEMO",
  REAL_ESTATE_CUSTOM_VANZINI: "REAL_ESTATE_CUSTOM_VANZINI",
  REAL_ESTATE_TOKKO_BROKER: "REAL_ESTATE_TOKKO_BROKER",
  REAL_ESTATE_MAIN: "REAL_ESTATE_MAIN",
  RETAIL_TIENDA_NUBE: "RETAIL_TIENDA_NUBE",
  RETAIL_WOO_COMMERCE: "RETAIL_WOO_COMMERCE",
  RETAIL_M3C: "RETAIL_M3C",
  CUSTOM_BOLSA_COMERCIO_ROSARIO: "CUSTOM_BOLSA_COMERCIO_ROSARIO",
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS"
};
var IntegrationNamesSchema = z67.enum([
  INTEGRATION_NAME.REAL_ESTATE_DEMO,
  INTEGRATION_NAME.REAL_ESTATE_CUSTOM_VANZINI,
  INTEGRATION_NAME.REAL_ESTATE_TOKKO_BROKER,
  INTEGRATION_NAME.REAL_ESTATE_MAIN,
  INTEGRATION_NAME.RETAIL_TIENDA_NUBE,
  INTEGRATION_NAME.RETAIL_WOO_COMMERCE,
  INTEGRATION_NAME.RETAIL_M3C,
  INTEGRATION_NAME.CUSTOM_BOLSA_COMERCIO_ROSARIO,
  INTEGRATION_NAME.GOOGLE_ANALYTICS
]);
var integrationNameFromSchema = (value) => z67.literal(value);

// src/types/integrations/full-integration-configuration.type.ts
var FullIntegrationRealEstateDemoConfigurationSchema = BaseIntegrationRealEstateDemoConfigurationSchema.merge(
  CustomerIntegrationRealEstateDemoConfigurationSchema
);
var FullIntegrationRealEstateCustomVanziniConfigurationSchema = BaseIntegrationRealEstateCustomVanziniConfigurationSchema.merge(
  CustomerIntegrationRealEstateCustomVanziniConfigurationSchema
);
var FullIntegrationRealEstateTokkoBrokerConfigurationSchema = BaseIntegrationRealEstateTokkoBrokerConfigurationSchema.merge(
  CustomerIntegrationRealEstateTokkoBrokerConfigurationSchema
);
var FullIntegrationRealEstateMainConfigurationSchema = BaseIntegrationRealEstateMainConfigurationSchema.merge(
  CustomerIntegrationRealEstateMainConfigurationSchema
);
var FullIntegrationRetailTiendaNubeConfigurationSchema = BaseIntegrationRetailTiendaNubeConfigurationSchema.merge(CustomerIntegrationRetailTiendaNubeConfigurationSchema);
var FullIntegrationRetailWooCommerceConfigurationSchema = BaseIntegrationRetailWooCommerceConfigurationSchema.merge(CustomerIntegrationRetailWooCommerceConfigurationSchema);
var FullIntegrationRetailM3CConfigurationSchema = BaseIntegrationRetailM3CConfigurationSchema.merge(
  CustomerIntegrationRetailM3CConfigurationSchema
);
var FullIntegrationCustomBolsaComercioRosarioConfigurationSchema = BaseIntegrationCustomBolsaComercioRosarioConfigurationSchema.merge(
  CustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema
);
var FullIntegrationGoogleAnalyticsConfigurationSchema = BaseIntegrationGoogleAnalyticsConfigurationSchema.merge(CustomerIntegrationGoogleAnalyticsConfigurationSchema);
var FullIntegrationConfigurationsSchema = z68.discriminatedUnion("integrationName", [
  FullIntegrationRealEstateMainConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("REAL_ESTATE_MAIN")
  }),
  FullIntegrationRealEstateDemoConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("REAL_ESTATE_DEMO")
  }),
  FullIntegrationRealEstateCustomVanziniConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("REAL_ESTATE_CUSTOM_VANZINI")
  }),
  FullIntegrationRealEstateTokkoBrokerConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("REAL_ESTATE_TOKKO_BROKER")
  }),
  FullIntegrationRetailTiendaNubeConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("RETAIL_TIENDA_NUBE")
  }),
  FullIntegrationRetailWooCommerceConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("RETAIL_WOO_COMMERCE")
  }),
  FullIntegrationRetailM3CConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("RETAIL_M3C")
  }),
  FullIntegrationCustomBolsaComercioRosarioConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("CUSTOM_BOLSA_COMERCIO_ROSARIO")
  }),
  FullIntegrationGoogleAnalyticsConfigurationSchema.extend({
    integrationName: integrationNameFromSchema("GOOGLE_ANALYTICS")
  })
]);

// src/dtos/customer-dashboard/customer-integrations/customer-integrations.dto.ts
var CustomerIntegrationsCreateRealEstateTokkoBrokerConfigurationDtoSchema = z69.object({
  integrationName: integrationNameFromSchema("REAL_ESTATE_TOKKO_BROKER"),
  friendlyName: z69.string(),
  configuration: FullIntegrationRealEstateTokkoBrokerConfigurationSchema
});
var CustomerIntegrationsUpdateRealEstateTokkoBrokerConfigurationDtoSchema = CustomerIntegrationsCreateRealEstateTokkoBrokerConfigurationDtoSchema.extend({
  customerIntegrationId: z69.string()
});
var CustomerIntegrationsCreateRealEstateCustomVanziniConfigurationDtoSchema = z69.object({
  integrationName: integrationNameFromSchema("REAL_ESTATE_CUSTOM_VANZINI"),
  friendlyName: z69.string(),
  configuration: FullIntegrationRealEstateCustomVanziniConfigurationSchema
});
var CustomerIntegrationsUpdateRealEstateCustomVanziniConfigurationDtoSchema = CustomerIntegrationsCreateRealEstateCustomVanziniConfigurationDtoSchema.extend({
  customerIntegrationId: z69.string()
});
var CustomerIntegrationsCreateRetailTiendaNubeConfigurationDtoSchema = z69.object({
  integrationName: integrationNameFromSchema("RETAIL_TIENDA_NUBE"),
  friendlyName: z69.string(),
  configuration: FullIntegrationRetailTiendaNubeConfigurationSchema
});
var CustomerIntegrationsUpdateRetailTiendaNubeConfigurationDtoSchema = CustomerIntegrationsCreateRetailTiendaNubeConfigurationDtoSchema.extend({
  customerIntegrationId: z69.string()
});
var CustomerIntegrationsCreateRetailWooCommerceConfigurationDtoSchema = z69.object({
  integrationName: integrationNameFromSchema("RETAIL_WOO_COMMERCE"),
  friendlyName: z69.string(),
  configuration: FullIntegrationRetailWooCommerceConfigurationSchema
});
var CustomerIntegrationsUpdateRetailWooCommerceConfigurationDtoSchema = CustomerIntegrationsCreateRetailWooCommerceConfigurationDtoSchema.extend({
  customerIntegrationId: z69.string()
});
var CustomerIntegrationsCreateConfigurationDtoSchema = z69.discriminatedUnion("integrationName", [
  CustomerIntegrationsCreateRealEstateTokkoBrokerConfigurationDtoSchema,
  CustomerIntegrationsCreateRetailTiendaNubeConfigurationDtoSchema,
  CustomerIntegrationsCreateRetailWooCommerceConfigurationDtoSchema,
  CustomerIntegrationsCreateRealEstateCustomVanziniConfigurationDtoSchema
]);
var CustomerIntegrationsUpdateConfigurationDtoSchema = z69.discriminatedUnion("integrationName", [
  CustomerIntegrationsUpdateRealEstateTokkoBrokerConfigurationDtoSchema,
  CustomerIntegrationsUpdateRetailTiendaNubeConfigurationDtoSchema,
  CustomerIntegrationsUpdateRetailWooCommerceConfigurationDtoSchema,
  CustomerIntegrationsUpdateRealEstateCustomVanziniConfigurationDtoSchema
]);

// src/dtos/admin/encryption/encryption.dto.ts
import z70 from "zod";
var AdminEncryptDataDtoSchema = z70.object({
  data: z70.string(),
  key: z70.string()
});
var AdminDecryptDataDtoSchema = z70.object({
  data: z70.string(),
  nonce: z70.string(),
  key: z70.string()
});

// src/dtos/admin/meilisearch/meilisearch.dto.ts
import z71 from "zod";
var AdminMeilisearchInitializeIndexDtoSchema = z71.object({
  indexType: z71.enum(["REAL_ESTATE", "RETAIL"], { message: "Index type must be either REAL_ESTATE or RETAIL" })
});
var AdminMeilisearchSyncCustomerPropertiesDtoSchema = z71.object({
  customerId: z71.string().min(1, { message: "Customer ID is required" }).uuid("Invalid customer ID"),
  forceRefresh: z71.boolean().optional().default(false)
});
var AdminMeilisearchSyncCustomerRetailProductsDtoSchema = z71.object({
  customerId: z71.string().min(1, { message: "Customer ID is required" }).uuid("Invalid customer ID"),
  forceRefresh: z71.boolean().optional().default(false)
});
var AdminMeilisearchSearchPropertiesDtoSchema = z71.object({
  query: z71.string(),
  customerId: z71.string().uuid("Invalid customer ID"),
  limit: z71.number().int().min(1).max(100).optional().default(20),
  offset: z71.number().int().min(0).optional().default(0),
  attributesToSearchOn: z71.array(z71.enum(["address", "fakeAddress", "developmentName", "title", "description"])).optional(),
  matchingStrategy: z71.enum(["all", "last", "frequency"]).optional(),
  filters: z71.object({
    customerIntegrationId: z71.string().uuid().optional(),
    documentType: z71.array(z71.enum(["property", "development"])).optional(),
    propertyType: z71.array(z71.enum(["apartment", "house", "land", "office", "garage", "office"])).optional(),
    roomAmount: z71.array(z71.number().int().positive()).optional(),
    bathroomAmount: z71.array(z71.number().int().positive()).optional(),
    floorsAmount: z71.array(z71.number().int().positive()).optional()
  }).optional(),
  customFilter: z71.string().optional()
});
var AdminMeilisearchSearchRetailProductsDtoSchema = z71.object({
  query: z71.string().min(1, { message: "Search query is required" }),
  customerId: z71.string().uuid("Invalid customer ID"),
  limit: z71.number().int().min(1).max(100).optional().default(20),
  offset: z71.number().int().min(0).optional().default(0),
  attributesToSearchOn: z71.array(z71.enum(["title", "searchTitle", "brand", "shortDescription", "sku", "altCodes", "categories"])).optional(),
  rankingScoreThreshold: z71.number().min(0).max(1).optional(),
  matchingStrategy: z71.enum(["all", "last", "frequency"]).optional(),
  filters: z71.object({
    customerIntegrationId: z71.string().uuid().optional(),
    documentType: z71.array(z71.literal("product")).optional(),
    brand: z71.array(z71.string()).optional(),
    brandId: z71.array(z71.string()).optional(),
    categories: z71.array(z71.string()).optional(),
    categoryIds: z71.array(z71.string()).optional(),
    sku: z71.array(z71.string()).optional(),
    status: z71.array(z71.enum(["active", "discontinued", "hidden", "draft"])).optional(),
    sellable: z71.boolean().optional(),
    inStock: z71.boolean().optional(),
    lists: z71.array(z71.string()).optional(),
    sourceVendor: z71.array(z71.string()).optional(),
    priceMin: z71.number().min(0).optional(),
    priceMax: z71.number().min(0).optional(),
    currency: z71.array(z71.string()).optional(),
    promoActive: z71.boolean().optional()
  }).optional(),
  customFilter: z71.string().optional()
});

// src/dtos/admin/email-sender/email-sender.dto.ts
import z72 from "zod";
var UtmParamsSchema = z72.object({
  campaignId: z72.string().optional(),
  ignoreUtmTracking: z72.boolean().optional()
});
var EmailTemplateMarketingFirstContactGeneralArgentinaDtoSchema = z72.object({
  name: z72.literal("MarketingFirstContactGeneralArgentina"),
  props: UtmParamsSchema.merge(
    z72.object({
      recipientName: z72.string(),
      isCompanyEmail: z72.boolean()
    })
  )
});
var EmailTemplateMarketingFirstContactGeneralLatamDtoSchema = z72.object({
  name: z72.literal("MarketingFirstContactGeneralLatam"),
  props: z72.object({
    recipientName: z72.string(),
    isCompanyEmail: z72.boolean()
  })
});
var SenderSchema = z72.object({
  name: z72.string(),
  email: z72.string().email(),
  replyTo: z72.string().email().optional()
});
var AdminEmailSenderBulkDtoSchema = z72.object({
  sender: SenderSchema,
  subject: z72.string(),
  scheduledAt: z72.string().optional(),
  recipients: z72.array(
    z72.object({
      email: z72.string().email(),
      // This overwrite the defaults
      overwriteDefaultSubject: z72.string().optional(),
      overwriteDefaultSender: SenderSchema.optional(),
      template: z72.union([
        EmailTemplateMarketingFirstContactGeneralArgentinaDtoSchema,
        EmailTemplateMarketingFirstContactGeneralLatamDtoSchema
      ])
    })
  )
});

// src/dtos/customer-integrations/find-customer-integrations.dto.ts
import { z as z73 } from "zod";
var FindManyCustomerIntegrationsSharedFiltersSchema = z73.object({
  integrationIds: z73.preprocess(preprocessStringToArray, z73.array(z73.string().uuid())).optional(),
  integrationNames: z73.preprocess(preprocessStringToArray, z73.array(IntegrationNamesSchema)).optional()
});
var FindManyCustomerIntegrationsForDashboardParamsDtoSchema = PaginatedEntityListDtoSchema.merge(
  FindManyCustomerIntegrationsSharedFiltersSchema
).merge(
  z73.object({
    orderBy: z73.enum(["created_at", "updated_at", "friendly_name", "integration_name"]).default("friendly_name"),
    pageSize: z73.preprocess(
      preprocessStringToNumber,
      z73.union([z73.literal(10), z73.literal(20), z73.literal(50), z73.literal(100), z73.literal(500)], {
        invalid_type_error: "Solo se permite paginar por 10, 20, 50, 100 o 500 elementos por p\xE1gina"
      }).default(20)
    )
  })
);

// src/dtos/customer-dashboard/workflows/lead-workflow.dto.ts
import z74 from "zod";
var LEAD_WORKFLOW_STATUS = ["ACTIVE", "COMPLETED", "PAUSED", "FAILED"];
var AssignLeadToWorkflowDtoSchema = z74.object({
  contactId: z74.string().uuid(),
  workflowId: z74.string().uuid(),
  workflowStepId: z74.string().uuid(),
  assignedUserId: z74.string().uuid().optional(),
  relatedConversationIds: z74.array(z74.string().uuid()).or(z74.string().uuid()).optional()
});
var LeadWorkflowsFindManyParamsDtoSchema = z74.object({
  workflowId: z74.string(),
  leadStatuses: z74.preprocess(preprocessStringToArray, z74.array(z74.enum(LEAD_WORKFLOW_STATUS))).optional(),
  createdAtFrom: z74.string().datetime().optional(),
  createdAtTo: z74.string().datetime().optional(),
  leadOwners: z74.preprocess(preprocessStringToArray, z74.array(z74.string().uuid())).optional()
});
var UpdateLeadWorkflowStepDtoSchema = z74.object({
  workflowStepId: z74.string()
});
var BulkUpdateLeadPositionsDtoSchema = z74.object({
  leadPositions: z74.array(
    z74.object({
      leadId: z74.string(),
      orderNumber: z74.number(),
      workflowStepId: z74.string()
    })
  ).min(1, "At least one lead position is required")
});
var UpdateLeadWorkflowStatusDtoSchema = z74.object({
  status: z74.enum(LEAD_WORKFLOW_STATUS)
});
var UpdateLeadWorkflowAssignedUserDtoSchema = z74.object({
  userId: z74.string().nullish()
});

// src/dtos/workflows/workflow.dto.ts
import z75 from "zod";
var FindManyWorkflowsParamsDtoSchema = PaginatedEntityListDtoSchema.merge(
  z75.object({
    orderBy: z75.enum(["name", "id", "created_at"]).default("created_at")
  })
);

// src/dtos/customer-dashboard/lead-field-profile/lead-field-profile.dto.ts
import z76 from "zod";
var CreateOrUpdateLeadFieldProfileDtoSchema = z76.object({
  name: z76.string(),
  description: z76.string().optional()
});

// src/dtos/customer-dashboard/profile-custom-fields/profile-custom-field.dto.ts
import z77 from "zod";
var CreateProfileCustomFieldDtoSchema = z77.object({
  lead_field_profile_id: z77.string().uuid(),
  lead_field_definition_id: z77.string().uuid(),
  is_required: IsEnabledSwitchSchema,
  llm_prompt_instruction: z77.string().max(500).nullable()
});
var UpdateProfileCustomFieldDtoSchema = CreateProfileCustomFieldDtoSchema;

// src/dtos/common/common-dto.ts
import z78 from "zod";
var DeleteEntityDtoSchema = z78.object({
  id: z78.string().uuid()
});

// src/dtos/customer-dashboard/custom-field/custom-field-dto.ts
import z80 from "zod";

// src/types/custom-field/custom-field-type.ts
import z79 from "zod";
var CUSTOM_FIELD_DATA_TYPE = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  DATE: "date"
};
var CustomFieldDataTypeSchema = z79.enum([
  CUSTOM_FIELD_DATA_TYPE.STRING,
  CUSTOM_FIELD_DATA_TYPE.NUMBER,
  CUSTOM_FIELD_DATA_TYPE.BOOLEAN,
  CUSTOM_FIELD_DATA_TYPE.DATE
]);
var CustomFieldSchema = z79.object({
  id: z79.string().uuid(),
  created_at: z79.string(),
  customer_id: z79.string().uuid(),
  data_type: CustomFieldDataTypeSchema,
  description: z79.string().max(500),
  field_metadata: z79.record(z79.string(), z79.any()).nullable(),
  field_name: z79.string().max(100),
  is_active: z79.boolean(),
  label: z79.string().max(100),
  updated_at: z79.string().nullable()
});

// src/dtos/customer-dashboard/custom-field/custom-field-dto.ts
var ReservedLeadFieldDefinitionReservedFieldNamesSchema = z80.enum([
  "email",
  "phone",
  "name",
  "whatsapp_phone",
  "facebook_user",
  "instagram_user",
  "key",
  "id",
  "created_at",
  "updated_at",
  "location",
  "source",
  "customer_id",
  "metadata"
]);
var CreateCustomFieldDtoSchema = z80.object({
  field_name: z80.string().max(50).min(3).superRefine((val, ctx) => {
    if (val.includes(" ")) {
      ctx.addIssue({
        message: "El nombre del campo no debe contener espacios",
        code: "custom"
      });
    }
    if (ReservedLeadFieldDefinitionReservedFieldNamesSchema.safeParse(val).success) {
      ctx.addIssue({
        message: `El nombre del campo "${val}" esta reservado. Elija otro nombre.`,
        code: "custom"
      });
    }
  }),
  description: z80.string().max(255),
  // we do this to avoid mismatch between the model and the database
  data_type: z80.string().refine(
    (val) => {
      CustomFieldDataTypeSchema.safeParse(val);
      return CustomFieldDataTypeSchema.safeParse(val).success;
    },
    {
      message: "El tipo de dato no es v\xE1lido"
    }
  ),
  is_active: IsEnabledSwitchSchema,
  label: z80.string().max(50)
});
var UpdateCustomFieldDtoSchema = CreateCustomFieldDtoSchema.partial().omit({
  field_name: true,
  data_type: true
}).extend({
  is_active: IsEnabledSwitchSchema
});

// src/dtos/conversation-tag-assignments/conversation-tag-assignments-dto.ts
import z81 from "zod";
var CHAT_CONVERSATION_TAG_ASSIGMENT_TYPE = {
  MANUAL: "MANUAL",
  AUTO: "AUTO"
};
var ChatConversationTagAssignmentAssignmentTypeSchema = z81.enum([
  CHAT_CONVERSATION_TAG_ASSIGMENT_TYPE.MANUAL,
  CHAT_CONVERSATION_TAG_ASSIGMENT_TYPE.AUTO
]);
var CreateConversationTagAssignmentDtoSchema = z81.object({
  conversation_id: z81.string().uuid(),
  tag_id: z81.string().uuid(),
  assignment_type: ChatConversationTagAssignmentAssignmentTypeSchema
});
var DeleteConversationTagAssignmentDtoSchema = z81.object({
  conversation_id: z81.string().uuid(),
  tag_id: z81.string().uuid()
});
var ReplaceConversationTagAssignmentDtoSchema = z81.object({
  tag_ids: z81.array(z81.string().uuid())
});

// src/dtos/conversations/dashboard-conversation-dto.ts
import z82 from "zod";
var FindManyDashboardConversationsListItemDtoSchema = z82.object({
  orderBy: z82.enum(["created_at", "reviewed_at"], { invalid_type_error: "No se puede ordenar por este campo." }).default("created_at"),
  orderCriteria: z82.enum(["asc", "desc"], {
    invalid_type_error: 'El criterio de ordenamiento no es v\xE1lido. Valores permitidos "asc", "desc".'
  }).default("desc"),
  contactFilter: z82.string().uuid().or(z82.literal("anonymous")).or(z82.literal("all")).optional(),
  archived: z82.preprocess(preprocessStringToBoolean, z82.boolean().default(false)),
  // TODO: Add support for array of elements
  channel: z82.union([ChatConversationChannelSchema, z82.array(ChatConversationChannelSchema)]).transform((val) => typeof val === "string" ? [val] : val).optional(),
  searchString: z82.string().min(1).optional(),
  reviewStatus: z82.enum(["PENDING", "APPROVED", "CORRECTED", "INCORRECT"]).optional(),
  customerChatbotId: z82.string().uuid().optional(),
  readStatus: z82.enum(["READ", "UNREAD"]).optional()
  // TODO: Date-time based filter. (created_at)
}).merge(PaginatedEntityListDtoSchema);
var FindOneDashboardConversationDtoSchema = z82.object({
  conversationId: z82.string().uuid()
});

// src/dtos/conversations/send-manual-message-dto.ts
import z83 from "zod";
var SendManualMessageDtoSchema = z83.object({
  conversationId: z83.string().uuid(),
  message: z83.string({
    message: "Escribe un mensaje v\xE1lido"
  }).min(1, "El mensaje no puede estar vac\xEDo").max(5e3, "El mensaje no puede exceder los 5000 caracteres")
});

// src/dtos/conversations/review-conversation-dto.ts
import z84 from "zod";
var ReviewConversationDtoSchema = z84.object({
  conversationId: z84.string().uuid(),
  rating: z84.number().int().min(1).max(5),
  comment: z84.string()
});

// src/dtos/conversations/mark-conversation-read-dto.ts
import z85 from "zod";
var MarkConversationReadDtoSchema = z85.object({
  conversationId: z85.string().uuid(),
  userId: z85.string().uuid()
});

// src/dtos/conversations/toggle-archived-dto.ts
import z86 from "zod";
var ToggleArchivedDtoSchema = z86.object({
  conversationIds: z86.array(z86.string().uuid())
});

// src/dtos/customers/invitations/invitations-dto.ts
var INVITATION_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED"
};

// src/dtos/customers/customer-member/customer-member-dto.ts
import z87 from "zod";
var UpdateCustomerMemberPersonalInformationDtoSchema = z87.object({
  firstName: z87.string().min(2, { message: "Ingres\xE1 al menos 2 caracteres" }).optional(),
  lastName: z87.string().min(2, { message: "Ingres\xE1 al menos 2 caracteres" }).optional(),
  location: z87.string().min(2, { message: "Ingres\xE1 al menos 2 caracteres" }).optional()
});
var CustomerMemberActorTypeDtoSchema = z87.object({
  type: z87.enum(["registeredUser", "anonymousUser"])
});

// src/types/customers/customer/customer-type.ts
var CUSTOMER_ACCOUNT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING_ACTIVATION: "PENDING_ACTIVATION"
};

// src/dtos/integrations/send-lead-dto.ts
import z88 from "zod";
var SendRealEstateLeadDtoSchema = z88.object({
  chatbotId: z88.string().uuid(),
  tagId: z88.string().uuid(),
  conversationId: z88.string().uuid(),
  contactName: z88.string().min(2).max(100),
  contactPhone: z88.string().min(5).max(20).optional(),
  contactEmail: z88.string().email().optional()
}).superRefine((data, ctx) => {
  if (!data.contactPhone && !data.contactEmail) {
    ctx.addIssue({
      code: z88.ZodIssueCode.custom,
      message: "Al menos un campo de contacto debe ser proporcionado",
      path: ["contactPhone"]
    });
    ctx.addIssue({
      code: z88.ZodIssueCode.custom,
      message: "Al menos un campo de contacto debe ser proporcionado",
      path: ["contactEmail"]
    });
  }
});

// src/types/integrations/base-integration-encrypted-configurations.type.ts
import z89 from "zod";
var EncryptedBaseIntegrationRealEstateDemoConfigurationSchema = BaseIntegrationRealEstateDemoConfigurationSchema;
var EncryptedBaseIntegrationRealEstateCustomVanziniAuthenticationSchema = BaseIntegrationRealEstateCustomVanziniAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var EncryptedBaseIntegrationRealEstateCustomVanziniConfigurationSchema = z89.object({
  apiUrl: z89.string(),
  authentication: EncryptedBaseIntegrationRealEstateCustomVanziniAuthenticationSchema
});
var EncryptedBaseIntegrationRealEstateTokkoBrokerConfigurationSchema = BaseIntegrationRealEstateTokkoBrokerConfigurationSchema;
var EncryptedBaseIntegrationRealEstateMainConfigurationSchema = BaseIntegrationRealEstateMainConfigurationSchema;
var EncryptedBaseIntegrationRetailTiendaNubeConfigurationSchema = BaseIntegrationRetailTiendaNubeConfigurationSchema;
var EncryptedBaseIntegrationRetailWooCommerceConfigurationSchema = BaseIntegrationRetailWooCommerceConfigurationSchema;
var EncryptedBaseIntegrationRetailM3CConfigurationSchema = BaseIntegrationRetailM3CConfigurationSchema;
var EncryptedBaseIntegrationCustomBolsaComercioRosarioConfigurationSchema = z89.object({
  apiUrl: z89.string(),
  authenticationSteps: z89.tuple([
    IntegrationHmacSignedPayloadEncryptedAuthenticationSchema,
    IntegrationPayloadEncryptionEncryptedAuthenticationSchema
  ])
});
var EncryptedBaseIntegrationGoogleAnalyticsConfigurationSchema = BaseIntegrationGoogleAnalyticsConfigurationSchema;

// src/types/integrations/customer-integration-encrypted-configurations.type.ts
import z90 from "zod";
var EncryptedCustomerIntegrationRealEstateDemoConfigurationSchema = CustomerIntegrationRealEstateDemoConfigurationSchema;
var EncryptedCustomerIntegrationRealEstateCustomVanziniConfigurationSchema = CustomerIntegrationRealEstateCustomVanziniConfigurationSchema;
var EncryptedCustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema = CustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema.omit({
  credentials: true
}).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape);
var EncryptedCustomerIntegrationRealEstateTokkoBrokerConfigurationSchema = z90.object({
  authentication: EncryptedCustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema
});
var EncryptedCustomerIntegrationRealEstateMainConfigurationSchema = CustomerIntegrationRealEstateMainConfigurationSchema;
var EncryptedCustomerIntegrationRetailTiendaNubeConfigurationSchema = CustomerIntegrationRetailTiendaNubeConfigurationSchema;
var EncryptedCustomerIntegrationRetailWooCommerceConfigurationSchema = CustomerIntegrationRetailWooCommerceConfigurationSchema;
var EncryptedCustomerIntegrationRetailM3CConfigurationSchema = z90.object({
  apiUrl: z90.string(),
  authentication: z90.object({
    type: z90.literal("CUSTOM")
  }).extend(IntegrationEncryptedAuthenticationCredentialsSchema.shape)
});
var EncryptedCustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema = CustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema;
var EncryptedCustomerIntegrationGoogleAnalyticsConfigurationSchema = z90.object({
  authentication: IntegrationApiKeyEncryptedAuthenticationSchema
});

// src/types/integrations/full-integration-encrypted-configuration.type.ts
var FullIntegrationEncryptedRealEstateDemoConfigurationSchema = EncryptedBaseIntegrationRealEstateDemoConfigurationSchema.merge(
  EncryptedCustomerIntegrationRealEstateDemoConfigurationSchema
);
var FullIntegrationEncryptedRealEstateCustomVanziniConfigurationSchema = EncryptedBaseIntegrationRealEstateCustomVanziniConfigurationSchema.merge(
  EncryptedCustomerIntegrationRealEstateCustomVanziniConfigurationSchema
);
var FullIntegrationEncryptedRealEstateTokkoBrokerConfigurationSchema = EncryptedBaseIntegrationRealEstateTokkoBrokerConfigurationSchema.merge(
  EncryptedCustomerIntegrationRealEstateTokkoBrokerConfigurationSchema
);
var FullIntegrationEncryptedRealEstateMainConfigurationSchema = EncryptedBaseIntegrationRealEstateMainConfigurationSchema.merge(
  EncryptedCustomerIntegrationRealEstateMainConfigurationSchema
);
var FullIntegrationEncryptedRetailTiendaNubeConfigurationSchema = EncryptedBaseIntegrationRetailTiendaNubeConfigurationSchema.merge(
  EncryptedCustomerIntegrationRetailTiendaNubeConfigurationSchema
);
var FullIntegrationEncryptedRetailWooCommerceConfigurationSchema = EncryptedBaseIntegrationRetailWooCommerceConfigurationSchema.merge(
  EncryptedCustomerIntegrationRetailWooCommerceConfigurationSchema
);
var FullIntegrationEncryptedRetailM3CConfigurationSchema = EncryptedBaseIntegrationRetailM3CConfigurationSchema.merge(EncryptedCustomerIntegrationRetailM3CConfigurationSchema);
var FullIntegrationEncryptedCustomBolsaComercioRosarioConfigurationSchema = EncryptedBaseIntegrationCustomBolsaComercioRosarioConfigurationSchema.merge(
  EncryptedCustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema
);
var FullIntegrationEncryptedGoogleAnalyticsConfigurationSchema = EncryptedBaseIntegrationGoogleAnalyticsConfigurationSchema.merge(
  EncryptedCustomerIntegrationGoogleAnalyticsConfigurationSchema
);

// src/dtos/customer-dashboard/customer-integration/test-integration-connection.dto.ts
import { z as z91 } from "zod";
var TestIntegrationConnectionDtoSchema = z91.discriminatedUnion("integrationName", [
  z91.object({
    integrationName: z91.literal("REAL_ESTATE_DEMO"),
    customerConfig: CustomerIntegrationRealEstateDemoConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("REAL_ESTATE_CUSTOM_VANZINI"),
    customerConfig: CustomerIntegrationRealEstateCustomVanziniConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("REAL_ESTATE_TOKKO_BROKER"),
    customerConfig: CustomerIntegrationRealEstateTokkoBrokerConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("REAL_ESTATE_MAIN"),
    customerConfig: CustomerIntegrationRealEstateMainConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("RETAIL_TIENDA_NUBE"),
    customerConfig: CustomerIntegrationRetailTiendaNubeConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("RETAIL_WOO_COMMERCE"),
    customerConfig: CustomerIntegrationRetailWooCommerceConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("RETAIL_M3C"),
    customerConfig: CustomerIntegrationRetailM3CConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("CUSTOM_BOLSA_COMERCIO_ROSARIO"),
    customerConfig: CustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema
  }),
  z91.object({
    integrationName: z91.literal("GOOGLE_ANALYTICS"),
    customerConfig: CustomerIntegrationGoogleAnalyticsConfigurationSchema
  })
]);

// src/dtos/contact/contact-list-item-dto.ts
import z92 from "zod";
var FindManyContactListItemDtoSchema = PaginatedEntityListDtoSchema.merge(
  z92.object({
    search: z92.string().optional(),
    orderBy: z92.enum(["name", "id", "created_at"]).default("created_at")
  })
);

// src/dtos/chatbot/chatbot-widget-config-dto.ts
import z93 from "zod";
var ChatbotWidgetConfigDtoSchema = z93.object({
  isActive: z93.boolean(),
  chatbotApiKey: z93.string(),
  style: BaseCustomerChatbotConfigurationStyleSchema,
  initialMessages: InitialMessageSchema,
  urlMatcher: RealEstateAgentConfigSchema.shape[PROPERTY_DETAILS_AGENT_NAME].shape.urlMatcher.nullable()
});

// src/dtos/event-automation/triggers/queries/dashboards-trigger-dto.ts
import z94 from "zod";
var DashboardTriggerQueryParamsSchema = z94.object({
  triggerId: z94.string().uuid()
});

// src/dtos/event-automation/triggers/queries/dashboard-trigger-list-item-dto.ts
var DashboardTriggerListItemsQueryParamsSchema = PaginatedEntityListDtoSchema;

// src/dtos/event-automation/triggers/commands/create-trigger-dto.ts
import z96 from "zod";

// src/types/event-automation/action/action-type.ts
import z95 from "zod";
var SEND_LEAD_ACTION_TYPE = "integration.real_estate.send_lead";
var PUSH_ANALYTICS_EVENT_ACTION_TYPE = "integration.analytics.push_event";
var ADD_TAG_ACTION_TYPE = "chatbot.conversation.add_tag";
var SEND_EMAIL_ACTION_TYPE = "system.notification.send_email";
var SEND_USER_ALERT_ACTION_TYPE = "system.notification.send_user_alert";
var EventAutomationActionTypeSchema = z95.enum([
  SEND_LEAD_ACTION_TYPE,
  PUSH_ANALYTICS_EVENT_ACTION_TYPE,
  ADD_TAG_ACTION_TYPE
]);

// src/dtos/event-automation/triggers/commands/create-trigger-dto.ts
var CommonActionPayloadSchema = z96.object({
  name: z96.string().min(1).max(255),
  description: z96.string().max(1024).nullable(),
  isActive: z96.boolean()
});
var SendLeadEventAutomationSchema = z96.object({
  actionType: z96.literal(SEND_LEAD_ACTION_TYPE),
  configuration: z96.null(),
  customerIntegrationId: z96.string().uuid()
});
var PushEventAutomationSchema = z96.object({
  actionType: z96.literal(PUSH_ANALYTICS_EVENT_ACTION_TYPE),
  configuration: z96.null(),
  customerIntegrationId: z96.string().uuid()
});
var AddTagEventAutomationSchema = z96.object({
  actionType: z96.literal(ADD_TAG_ACTION_TYPE),
  configuration: z96.object({
    tag_id: z96.string().uuid()
  }),
  customerIntegrationId: z96.null()
});
var EventAutomationActionSchema = z96.discriminatedUnion("actionType", [
  SendLeadEventAutomationSchema.merge(CommonActionPayloadSchema),
  PushEventAutomationSchema.merge(CommonActionPayloadSchema),
  AddTagEventAutomationSchema.merge(CommonActionPayloadSchema)
]);
var CreateTriggerSchema = z96.object({
  name: z96.string().min(1).max(255),
  description: z96.string().max(1024).nullable(),
  isActive: z96.boolean(),
  eventType: TriggerEventTypeSchema,
  actions: z96.array(EventAutomationActionSchema).min(1).max(10)
});

// src/dtos/event-automation/triggers/commands/update-trigger-dto.ts
import z97 from "zod";
var UpdateTriggerSchema = CreateTriggerSchema.extend({
  id: z97.string().uuid()
});

// src/dtos/auth/sign-up-dto.ts
import z98 from "zod";
var SignUpUserDtoSchema = z98.object({
  email: EmailSchema,
  password: PasswordSchema,
  passwordRepeat: PasswordSchema
}).merge(GoogleRecaptachaSchema).refine((data) => data.password === data.passwordRepeat, {
  message: "Las contrase\xF1as deben coincidir",
  path: ["passwordRepeat"]
});

// src/dtos/customers/register-customer-dto.ts
import z99 from "zod";
var RegisterCustomerDtoSchema = z99.object({
  name: z99.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  lastName: z99.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  companyName: z99.string({ required_error: "El valor es requerido" }).min(2, { message: "Escribe al menos 2 caracteres" }).max(50, { message: "Escribe un m\xE1ximo de 50 caracteres" }),
  vertical: VerticalSchemaForSignup,
  location: LocationSchema,
  hasRequestedCustomIntegration: z99.boolean().optional(),
  customIntegrationRequestMessage: z99.string().optional()
});

// src/utils/is-host-allowed.ts
function isHostAllowed(url, allowedDomains) {
  try {
    const host = new URL(url).host.toLowerCase();
    for (const domain of allowedDomains) {
      const lowercaseDomain = domain.toLowerCase();
      const regexPattern = lowercaseDomain.replace(/\*/g, ".*");
      const regex = new RegExp("^" + regexPattern + "$");
      if (regex.test(host)) {
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }
}

// src/utils/message-content-parser.ts
var componentMatchRegex = /(COMPONENT:\[[^\]]+\])/;
var componentUuidMatchRegex = /COMPONENT:\["([^\]]+)"\]/;
function matchMessageComponent(messageContent) {
  return messageContent.match(componentMatchRegex);
}
function splitMessageContentWithComponents(messageContent) {
  const parts = messageContent.split(componentMatchRegex);
  const parsed = parts.map((part) => {
    var _a;
    const match = (_a = part.match(componentUuidMatchRegex)) == null ? void 0 : _a[1];
    const type = match ? "component" : "text";
    const content = match ?? removeDeprecatedMessagePrefixes(part);
    return { content, type };
  });
  return parsed.filter((p) => p.content);
}
function removeComponentsFromMessageContent(messageContent) {
  return messageContent.replace(componentMatchRegex, "");
}
function removeDeprecatedMessagePrefixes(messageContent) {
  return messageContent.replace(/\[\d+\]:\s*/, "");
}

// src/dtos/reports/reports-conversations.ts
import { z as z100 } from "zod";
var DateRangeQueryDtoSchema = z100.object({
  startDate: z100.string().regex(/^\d{4}-\d{2}-\d{2}$/, "startDate must be in YYYY-MM-DD format"),
  endDate: z100.string().regex(/^\d{4}-\d{2}-\d{2}$/, "endDate must be in YYYY-MM-DD format")
});

// src/types/app-plans/app-plans.type.ts
import z101 from "zod";
var BasePlanSettingsSchema = z101.object({
  pricing: z101.object({
    basePrice: z101.number(),
    includeTaxes: z101.boolean(),
    additionalConversationPackCount: z101.number(),
    additionalConversationPackPrice: z101.number(),
    additionalAccountPrice: z101.number()
  }),
  includedDashboardAccounts: z101.number(),
  includedConversations: z101.number()
});

// src/types/profile-custom-fields/profile-custom-fields-type.ts
import z102 from "zod";
var ProfileCustomFieldSchema = z102.object({
  id: z102.string().uuid(),
  is_required: z102.boolean(),
  conditions: z102.record(z102.string(), z102.any()).nullable(),
  created_at: z102.string(),
  customer_id: z102.string().uuid(),
  lead_field_profile_id: z102.string().uuid(),
  updated_at: z102.string().nullable(),
  lead_field_definition_id: z102.string().uuid(),
  llm_prompt_instruction: z102.string().max(500).nullable()
});
var ProfileCustomFieldWithCustomFieldSchema = z102.object({
  id: z102.string().uuid(),
  is_required: z102.boolean(),
  conditions: z102.record(z102.string(), z102.any()).nullable(),
  created_at: z102.string(),
  customer_id: z102.string().uuid(),
  lead_field_profile_id: z102.string().uuid(),
  updated_at: z102.string().nullable(),
  lead_field_definition_id: z102.string().uuid(),
  llm_prompt_instruction: z102.string().max(500).nullable(),
  custom_field: CustomFieldSchema
});
var PROFILE_CUSTOM_FIELD_DEFINITION_REAL_ESTATE_CONDITION_INTENT = {
  BUY: "buy",
  APPRAISAL: "appraisal",
  RENT: "rent"
};
var ProfileCustomFieldRealEstateIntentConditionSchema = z102.object({
  type: z102.literal("intent"),
  condition: z102.object({
    intent: z102.enum(["buy", "appraisal", "rent"])
  })
});
var ProfileCustomFieldDefinitionConditionRealEstateSchema = z102.discriminatedUnion("type", [
  ProfileCustomFieldRealEstateIntentConditionSchema
]);
var ProfileCustomFieldRealEstateSchema = ProfileCustomFieldWithCustomFieldSchema.extend({
  conditions: ProfileCustomFieldDefinitionConditionRealEstateSchema.nullable()
});

// src/types/event-action/event-action-configuration-type.ts
import z103 from "zod";
var TagConversationEventActionConfigurationSchema = z103.object({
  tag_id: z103.string().uuid()
});
export {
  ADD_TAG_ACTION_TYPE,
  ANTHROPIC_MODELS,
  API_CUSTOM_HEADERS,
  APP_USER_ROLES,
  AUDIO_MESSAGE_CONTENT_TYPE,
  AddTagEventAutomationSchema,
  AdminDecryptDataDtoSchema,
  AdminEmailSenderBulkDtoSchema,
  AdminEncryptDataDtoSchema,
  AdminMeilisearchInitializeIndexDtoSchema,
  AdminMeilisearchSearchPropertiesDtoSchema,
  AdminMeilisearchSearchRetailProductsDtoSchema,
  AdminMeilisearchSyncCustomerPropertiesDtoSchema,
  AdminMeilisearchSyncCustomerRetailProductsDtoSchema,
  AnyConversationStateSchema,
  AppUserRoleSchema,
  ApplicationEventSchema,
  ApplicationEventTypesSchema,
  AppraisalAgentConfigSchema,
  ArrayStringTemplateTransformerSchema,
  AssignContactToConversationDtoSchema,
  AssignLeadToWorkflowDtoSchema,
  AssistantMessageDtoSchema,
  AudioMessageContentSchema,
  BASE_CUSTOMER_CHATBOT_CONFIGURATION_KEYS_TO_OMIT,
  BaseChatbotEventSchema,
  BaseChatbotRealEstateLeadDataSchema,
  BaseChatbotRetailLeadDataSchema,
  BaseCustomerChatbotConfigurationSchema,
  BaseCustomerChatbotConfigurationStyleSchema,
  BaseCustomerChatbotSchema,
  BaseIntegrationCustomBolsaComercioRosarioConfigurationSchema,
  BaseIntegrationGoogleAnalyticsConfigurationSchema,
  BaseIntegrationRealEstateCustomVanziniAuthenticationSchema,
  BaseIntegrationRealEstateCustomVanziniConfigurationSchema,
  BaseIntegrationRealEstateDemoConfigurationSchema,
  BaseIntegrationRealEstateMainConfigurationSchema,
  BaseIntegrationRealEstateTokkoBrokerConfigurationSchema,
  BaseIntegrationRetailM3CConfigurationSchema,
  BaseIntegrationRetailTiendaNubeConfigurationSchema,
  BaseIntegrationRetailWooCommerceConfigurationSchema,
  BasePlanSettingsSchema,
  BaseToolInvocationSchema,
  BaseWorkflowEventSchema,
  BolsaComercioRosarioCustomerChatbotConfigurationSchema,
  BolsaComercioRosarioCustomerChatbotSchema,
  BotActionSchema,
  BulkUpdateLeadPositionsDtoSchema,
  CHATBOT_CONFIG_SECTION_SCHEMA_MAP,
  CHAT_CONVERSATION_TAG_ASSIGMENT_TYPE,
  CHAT_MODEL_FACTORY,
  CHUNK_END_SEPARATOR,
  CLIENT_ERROR_DEFAULT_STATUS_MESSAGE,
  CLIENT_ERROR_MESSAGES,
  COMMON_MESSAGE_FAILED_EVENT_TYPE,
  CONTACT_FORM_TOOL_NAME,
  CUSTOMER_ACCOUNT_STATUS,
  CUSTOM_BOLSA_COMERCIO_ROSARIO,
  CUSTOM_FIELD_DATA_TYPE,
  CaptionSchema,
  ChannelSpecificMessageSchema,
  ChatContactCustomFieldsSchema,
  ChatContactMetadataSchema,
  ChatContactSchema,
  ChatConversationChannelSchema,
  ChatConversationMetadataSchema,
  ChatConversationReviewContentSchema,
  ChatConversationTagAssignmentAssignmentTypeSchema,
  ChatModelSchema,
  ChatModelSupportedOptionsSchema,
  ChatbotApplicationEventSchema,
  ChatbotRealEstateRequestedAppraisalEventSchema,
  ChatbotRealEstateRequestedContactEventSchema,
  ChatbotRealEstateRequestedVisitEventSchema,
  ChatbotRetailRequestedContactCustomerSupportEventSchema,
  ChatbotWebContextSchema,
  ChatbotWidgetConfigDtoSchema,
  CommonActionPayloadSchema,
  ConfirmUserInviteDtoSchema,
  ConversationChatbotKeySchema,
  ConversationMessageDtoSchema,
  ConversationStateDetailsSchema,
  ConversationStateSchema,
  CopyCustomerChatbotDtoSchema,
  CreateContactDtoSchema,
  CreateContactFromDashboardDtoSchema,
  CreateConversationTagAssignmentDtoSchema,
  CreateCustomFieldDtoSchema,
  CreateCustomIntegrationDtoSchema,
  CreateCustomerAccountWizardFormSchema,
  CreateCustomerAccountWizardFormStep1Schema,
  CreateCustomerAccountWizardFormStep2Schema,
  CreateCustomerAccountWizardFormStep3Schema,
  CreateCustomerChatbotDtoSchema,
  CreateCustomerChatbotFromCustomerSignupWizardDtoSchema,
  CreateCustomerDtoSchema,
  CreateCustomerIntegrationDtoSchema,
  CreateLeadAppraisalChatbotDtoSchema,
  CreateLeadContactChatbotDtoNonRefinedSchema,
  CreateLeadContactChatbotDtoSchema,
  CreateM3CIntegrationDtoSchema,
  CreateOrUpdateLeadFieldProfileDtoSchema,
  CreateProfileCustomFieldDtoSchema,
  CreateTokkoIntegrationDtoSchema,
  CreateTriggerSchema,
  CreateUserDtoSchema,
  CreateUserInviteDtoSchema,
  CreateWebContactMessageDtoSchema,
  CreateWebNewsletterSignUpDtoSchema,
  CustomFieldDataTypeSchema,
  CustomFieldSchema,
  CustomerChatbotConfigurationUnionSchema,
  CustomerChatbotMetadataSchema,
  CustomerChatbotUnionSchema,
  CustomerDashboardFindManyConversationTagsDtoSchema,
  CustomerDashboardUpdateAccountEmailDtoSchema,
  CustomerDashboardUpdateAccountPasswordDtoSchema,
  CustomerDashboardUpsertConversationTagDtoSchema,
  CustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema,
  CustomerIntegrationGoogleAnalyticsConfigurationSchema,
  CustomerIntegrationRealEstateCustomVanziniConfigurationSchema,
  CustomerIntegrationRealEstateDemoConfigurationSchema,
  CustomerIntegrationRealEstateMainConfigurationSchema,
  CustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema,
  CustomerIntegrationRealEstateTokkoBrokerConfigurationSchema,
  CustomerIntegrationRetailM3CConfigurationSchema,
  CustomerIntegrationRetailTiendaNubeConfigurationSchema,
  CustomerIntegrationRetailWooCommerceConfigurationSchema,
  CustomerIntegrationsCreateConfigurationDtoSchema,
  CustomerIntegrationsCreateRealEstateCustomVanziniConfigurationDtoSchema,
  CustomerIntegrationsCreateRealEstateTokkoBrokerConfigurationDtoSchema,
  CustomerIntegrationsCreateRetailTiendaNubeConfigurationDtoSchema,
  CustomerIntegrationsCreateRetailWooCommerceConfigurationDtoSchema,
  CustomerIntegrationsUpdateConfigurationDtoSchema,
  CustomerIntegrationsUpdateRealEstateCustomVanziniConfigurationDtoSchema,
  CustomerIntegrationsUpdateRealEstateTokkoBrokerConfigurationDtoSchema,
  CustomerIntegrationsUpdateRetailTiendaNubeConfigurationDtoSchema,
  CustomerIntegrationsUpdateRetailWooCommerceConfigurationDtoSchema,
  CustomerMemberActorTypeDtoSchema,
  DashboardTriggerListItemsQueryParamsSchema,
  DashboardTriggerQueryParamsSchema,
  DataStreamPrefixSchema,
  DateRangeQueryDtoSchema,
  DeleteConversationTagAssignmentDtoSchema,
  DeleteEntityDtoSchema,
  DisplayContactFormToolInvocationSchema,
  ERROR_CODES,
  ERROR_PREFIX,
  EditChannelsConfigDtoSchema,
  EditChatbotBasicConfigDtoSchema,
  EditChatbotBehaviorConfigDtoSchema,
  EditChatbotInitialMessagesDtoSchema,
  EditChatbotInstagramDtoSchema,
  EditChatbotMessengerDtoSchema,
  EditChatbotStyleDtoSchema,
  EditChatbotWebDtoSchema,
  EditChatbotWhatsappDtoSchema,
  EditRealEstateAgentsDtoSchema,
  EmailTemplateMarketingFirstContactGeneralArgentinaDtoSchema,
  EmailTemplateMarketingFirstContactGeneralLatamDtoSchema,
  EncryptedBaseIntegrationCustomBolsaComercioRosarioConfigurationSchema,
  EncryptedBaseIntegrationGoogleAnalyticsConfigurationSchema,
  EncryptedBaseIntegrationRealEstateCustomVanziniAuthenticationSchema,
  EncryptedBaseIntegrationRealEstateCustomVanziniConfigurationSchema,
  EncryptedBaseIntegrationRealEstateDemoConfigurationSchema,
  EncryptedBaseIntegrationRealEstateMainConfigurationSchema,
  EncryptedBaseIntegrationRealEstateTokkoBrokerConfigurationSchema,
  EncryptedBaseIntegrationRetailM3CConfigurationSchema,
  EncryptedBaseIntegrationRetailTiendaNubeConfigurationSchema,
  EncryptedBaseIntegrationRetailWooCommerceConfigurationSchema,
  EncryptedCustomerIntegrationCustomBolsaComercioRosarioConfigurationSchema,
  EncryptedCustomerIntegrationGoogleAnalyticsConfigurationSchema,
  EncryptedCustomerIntegrationRealEstateCustomVanziniConfigurationSchema,
  EncryptedCustomerIntegrationRealEstateDemoConfigurationSchema,
  EncryptedCustomerIntegrationRealEstateMainConfigurationSchema,
  EncryptedCustomerIntegrationRealEstateTokkoBrokerAuthenticationSchema,
  EncryptedCustomerIntegrationRealEstateTokkoBrokerConfigurationSchema,
  EncryptedCustomerIntegrationRetailM3CConfigurationSchema,
  EncryptedCustomerIntegrationRetailTiendaNubeConfigurationSchema,
  EncryptedCustomerIntegrationRetailWooCommerceConfigurationSchema,
  EventAutomationActionSchema,
  EventAutomationActionTypeSchema,
  ExtendedCustomerCommunicationPlatformInstagramSchema,
  ExtendedCustomerCommunicationPlatformMessengerFacebookPagesSchema,
  ExtendedCustomerCommunicationPlatformWhatsappSchema,
  FacebookLoginCompleteEmbeddedSignupProcessDtoSchema,
  FacebookLoginSaveEmbeddedSignupProgressDtoSchema,
  FindManyContactListItemDtoSchema,
  FindManyCustomerIntegrationsForDashboardParamsDtoSchema,
  FindManyDashboardConversationsListItemDtoSchema,
  FindManyWorkflowsParamsDtoSchema,
  FindOneDashboardConversationDtoSchema,
  FindOrCreateChatConversationDtoSchema,
  FullIntegrationConfigurationsSchema,
  FullIntegrationCustomBolsaComercioRosarioConfigurationSchema,
  FullIntegrationEncryptedCustomBolsaComercioRosarioConfigurationSchema,
  FullIntegrationEncryptedGoogleAnalyticsConfigurationSchema,
  FullIntegrationEncryptedRealEstateCustomVanziniConfigurationSchema,
  FullIntegrationEncryptedRealEstateDemoConfigurationSchema,
  FullIntegrationEncryptedRealEstateMainConfigurationSchema,
  FullIntegrationEncryptedRealEstateTokkoBrokerConfigurationSchema,
  FullIntegrationEncryptedRetailM3CConfigurationSchema,
  FullIntegrationEncryptedRetailTiendaNubeConfigurationSchema,
  FullIntegrationEncryptedRetailWooCommerceConfigurationSchema,
  FullIntegrationGoogleAnalyticsConfigurationSchema,
  FullIntegrationRealEstateCustomVanziniConfigurationSchema,
  FullIntegrationRealEstateDemoConfigurationSchema,
  FullIntegrationRealEstateMainConfigurationSchema,
  FullIntegrationRealEstateTokkoBrokerConfigurationSchema,
  FullIntegrationRetailM3CConfigurationSchema,
  FullIntegrationRetailTiendaNubeConfigurationSchema,
  FullIntegrationRetailWooCommerceConfigurationSchema,
  GEMINI_MODELS,
  GeneralIntentSchema,
  HOTEL_VERTICAL,
  HasAppraisedSchema,
  HasBeenUpdatedByAgentSchema,
  HasContactedCompanySchema,
  HumanAssistantMessageDtoSchema,
  HumanAssistantMessageSourceSchema,
  IMAGE_MESSAGE_CONTENT_TYPE,
  INTEGRATION_NAME,
  INVITATION_STATUS,
  ImageMessageContentSchema,
  InitialMessageSchema,
  InstagramGraphApiErrorSchema,
  InstagramGraphApiGetOauthAccessTokenErrorSchema,
  InstagramGraphApiGetOauthAccessTokenSuccessResponseSchema,
  InstagramLoginCompleteSignupProcessDtoSchema,
  InstagramMessageSchema,
  InstagramMessagingSchema,
  InstagramWebhookDtoSchema,
  IntegrationApiKeyAuthenticationSchema,
  IntegrationApiKeyEncryptedAuthenticationSchema,
  IntegrationAuthenticationSchema,
  IntegrationBasicAuthAuthenticationSchema,
  IntegrationBasicAuthEncryptedAuthenticationSchema,
  IntegrationBearerTokenAuthenticationSchema,
  IntegrationBearerTokenEncryptedAuthenticationSchema,
  IntegrationEncryptedAuthenticationCredentialsSchema,
  IntegrationEncryptedAuthenticationSchema,
  IntegrationHmacSignedPayloadAuthenticationSchema,
  IntegrationHmacSignedPayloadEncryptedAuthenticationSchema,
  IntegrationNamesSchema,
  IntegrationOAuthAccessTokenAuthenticationSchema,
  IntegrationOAuthAccessTokenEncryptedAuthenticationSchema,
  IntegrationOAuthAuthCodeAuthenticationSchema,
  IntegrationOAuthAuthCodeEncryptedAuthenticationSchema,
  IntegrationOAuthClientCredentialsAuthenticationSchema,
  IntegrationOAuthClientCredentialsEncryptedAuthenticationSchema,
  IntegrationPayloadEncryptionAuthenticationSchema,
  IntegrationPayloadEncryptionEncryptedAuthenticationSchema,
  IsEnabledSwitchSchema,
  LEAD_WORKFLOW_STATUS,
  LastPropertyInterestedIn,
  LeadWorkflowsFindManyParamsDtoSchema,
  LocationSearchPreprocessorSchema,
  LoginUserDtoSchema,
  MarkConversationReadDtoSchema,
  MatcherWhereSchema,
  MatchersSchema,
  MessageContentSchema,
  MessengerFacebookPagesMessageSchema,
  MessengerFacebookPagesMessageWithAttachmentSchema,
  MessengerFacebookPagesMessagesWebhookDtoSchema,
  MessengerFacebookPagesTextMessageSchema,
  MetaGraphApiDebugTokenErrorSchema,
  MetaGraphApiDebugTokenSuccessResponseSchema,
  MetaGraphApiErrorSchema,
  MetaGraphApiGetAssociatedFacebookPageSchema,
  MetaGraphApiGetOauthAccessTokenSuccessResponseSchema,
  MetaGraphApiGetUserIdsForAppsSchema,
  MetaGraphApiGetWhatsappBusinessAccountPhoneNumberListSuccessResponseSchema,
  MetaGraphApiGetWhatsappBusinessAccountPhoneNumberSuccessResponseSchema,
  MetaGraphApiGetWhatsappBusinessAccountSuccessResponseSchema,
  MetaGraphApiPaginationSchema,
  MetaGraphApiRefreshAccessTokenSuccessResponseSchema,
  MetaGraphApiWhatsappBusinessPhoneSendMessageResponseSchema,
  MimeTypeSchema,
  OPEN_AI_MODELS,
  PROBLEMS,
  PROFILE_CUSTOM_FIELD_DEFINITION_REAL_ESTATE_CONDITION_INTENT,
  PROPERTY_APPRAISAL_AGENT_NAME,
  PROPERTY_DETAILS_AGENT_NAME,
  PROPERTY_SEARCH_AGENT_NAME,
  PUSH_ANALYTICS_EVENT_ACTION_TYPE,
  PaginatedEntityListDtoSchema,
  ParamTransformerConfigurationSchema,
  PositionValueSchema,
  PriceRangePreprocessorSchema,
  ProfileCustomFieldDefinitionConditionRealEstateSchema,
  ProfileCustomFieldRealEstateIntentConditionSchema,
  ProfileCustomFieldRealEstateSchema,
  ProfileCustomFieldSchema,
  ProfileCustomFieldWithCustomFieldSchema,
  PropertyDetailsAgentConfigSchema,
  PropertyPromptFieldsSchema,
  PropertySearchAgentConfigSchema,
  PushEventAutomationSchema,
  REAL_ESTATE_CHATBOT_CONFIG_SECTIONS,
  REAL_ESTATE_CHATBOT_CONFIG_SECTION_QUERY_STRING_KEY,
  REAL_ESTATE_LEAD_REQUESTED_APPRAISAL_EVENT_TYPE,
  REAL_ESTATE_LEAD_REQUESTED_CONTACT_EVENT_TYPE,
  REAL_ESTATE_LEAD_REQUESTED_VISIT_EVENT_TYPE,
  REAL_ESTATE_VERTICAL,
  RETAIL_LEAD_CREATED_EVENT_TYPE,
  RETAIL_LEAD_REQUESTED_CONTACT_CUSTOMER_SUPPORT_EVENT_TYPE,
  RETAIL_VERTICAL,
  RealEstateAgentConfigSchema,
  RealEstateAppraisalLeadDataSchema,
  RealEstateContactLeadDataSchema,
  RealEstateConversationStateSchema,
  RealEstateCustomerChatbotConfigurationSchema,
  RealEstateCustomerChatbotSchema,
  RealEstateSearchParamsSchema,
  RealEstateVisitLeadDataSchema,
  ReceiveChatConversationMessagesDtoSchema,
  RegisterCustomerDtoSchema,
  ReplaceConversationTagAssignmentDtoSchema,
  ReservedLeadFieldDefinitionReservedFieldNamesSchema,
  ResetPasswordDtoSchema,
  ResourceRefSchema,
  RetailContactCustomerSupportDataSchema,
  RetailConversationStateDetailsSchema,
  RetailConversationStateSchema,
  RetailCustomerChatbotConfigurationSchema,
  RetailCustomerChatbotSchema,
  RetailGeneralIntentSchema,
  RetailHasContactedCompanySchema,
  RetailOrderItemSchema,
  RetailOrderSchema,
  RetailSearchParamsSchema,
  ReviewConversationDtoSchema,
  SEND_EMAIL_ACTION_TYPE,
  SEND_LEAD_ACTION_TYPE,
  SEND_USER_ALERT_ACTION_TYPE,
  STRING_PREFIX,
  SanitizedCustomerCommunicationPlatformInstagramSchema,
  SanitizedCustomerCommunicationPlatformMessengerFacebookPagesSchema,
  SanitizedCustomerCommunicationPlatformWhatsappSchema,
  ScopeSchema,
  SendLeadEventAutomationSchema,
  SendManualMessageDtoSchema,
  SendRealEstateLeadDtoSchema,
  SignUpUserDtoSchema,
  SignUpUserSuccessResponseSchema,
  SpecificIntentSchema,
  StringTemplateTransformerSchema,
  TEXT_MESSAGE_CONTENT_TYPE,
  TOOLCALL_PREFIX,
  TOOLRESULT_PREFIX,
  TagConversationEventActionConfigurationSchema,
  TestIntegrationConnectionDtoSchema,
  TextMessageContentSchema,
  ToggleArchivedDtoSchema,
  ToolCallSchema,
  ToolInvocationSchema,
  ToolNameSchema,
  ToolResultDtoSchema,
  TransactionTypeSchema,
  TransformerParamsPreprocessorSchema,
  TransformerSchema,
  TriggerEventTypeSchema,
  UNASSIGNED,
  USER_SYSTEM_ROLES,
  UpdateContactFromDashboardDtoSchema,
  UpdateCustomFieldDtoSchema,
  UpdateCustomerChatbotConfigurationDtoSchema,
  UpdateCustomerMemberPersonalInformationDtoSchema,
  UpdateLeadWorkflowAssignedUserDtoSchema,
  UpdateLeadWorkflowStatusDtoSchema,
  UpdateLeadWorkflowStepDtoSchema,
  UpdatePasswordDtoSchema,
  UpdateProfileCustomFieldDtoSchema,
  UpdateTriggerSchema,
  UserMessageDtoSchema,
  UtmParamsSchema,
  VERTICAL,
  VERTICAL_CUSTOMER_CHATBOT_SCHEMA_MAP,
  VerticalSchema,
  VerticalSchemaForSignup,
  WhatsappAudioMessageSchema,
  WhatsappBusinessPhoneDataSchema,
  WhatsappButtonMessageSchema,
  WhatsappDocumentMessageSchema,
  WhatsappFieldBaseValueSchema,
  WhatsappFieldEchoesSchema,
  WhatsappFieldHistorySchema,
  WhatsappFieldMessagesSchema,
  WhatsappFieldSmbAppStateSyncSchema,
  WhatsappGroupedWebhookDataSchema,
  WhatsappGroupedWebhookEchoesMessagesByUserPhoneNumberSchema,
  WhatsappGroupedWebhookIncomingMessagesByUserPhoneNumberSchema,
  WhatsappGroupedWebhookUserDataSchema,
  WhatsappHistoryErrorSchema,
  WhatsappImageMessageSchema,
  WhatsappMessageChangeSchema,
  WhatsappMessageSchema,
  WhatsappMessageTypeSchema,
  WhatsappPlatformBusinessPhoneNumbersSchema,
  WhatsappReactionMessageSchema,
  WhatsappRegisterPhoneNumberIdDtoSchema,
  WhatsappStickerMessageSchema,
  WhatsappSystemMessageSchema,
  WhatsappTextMessageSchema,
  WhatsappUnRegisterPhoneNumberIdDtoSchema,
  WhatsappVideoMessageSchema,
  WhatsappWebhookDtoSchema,
  WhereConditionKeySchema,
  WorkflowApplicationEventSchema,
  WorkflowEventTypesSchema,
  WorkflowLeadAssignedEventSchema,
  WorkflowLeadCreatedEventSchema,
  WorkflowLeadStepChangedEventSchema,
  ZIndexSchema,
  buildTextMessageContent,
  componentMatchRegex,
  componentUuidMatchRegex,
  dateStringSchema,
  extractOnlyTextMessageContent,
  extractTextMessageContents,
  getClientErrorMessage,
  integrationNameFromSchema,
  isHostAllowed,
  matchMessageComponent,
  preprocessStringToArray,
  preprocessStringToBoolean,
  preprocessStringToNumber,
  removeComponentsFromMessageContent,
  removeDeprecatedMessagePrefixes,
  responseAsProblemDetail,
  splitMessageContentWithComponents,
  stringTemplateInterpolationRegex,
  superRefineEmailOrPhone,
  zJsonSchema,
  zLiteralSchema
};
//! TODO: Use Api Response for paginated results
//! TODO: HANDLE REFERRALS (ADS)
//! History error doesn't have a "field" attribute.
//! TODO: Validate this schema, it feels wrong.
//! TODO: Remove passthrough and optional clauses once the metadata is structured is confirmed
//! TODO: Remove
//! TODO: Move to dtos/workflows
//! Note: these are just placeholders as reference for future implementations
//! TODO: This is a temp fix. Should be removed once all conversations in database are properly updated.
